import api from "api";
import { MainStore } from "core/store";
import {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import {
  CaretDownOutlined,
  CaretLeftFilled,
  CaretUpOutlined,
  CheckOutlined,
  CloseCircleFilled,
  CloseOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  HeartFilled,
  HeartOutlined,
  LeftCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Carousel,
  DatePicker,
  Divider,
  Empty,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Select,
  Steps,
  Upload,
  message,
} from "antd";

import liff from "@line/liff";
import CaddyTipIcon from "assets/images/png/caddy_tips.png";
import SkipIcon from "assets/images/png/skip-compansate.png";
import ComingSoon from "components/coming-soon";
import CouponInput from "components/coupon-input";
import Loading from "components/loading";
import CustomTimePicker from "components/time-picker";
import dayjs from "dayjs";
import { THAI_MONTHS, TIPS_PERCEN, BOOKING_MODE_OPTIONS } from "utils/constants";
import AvailableCard from "./avilable-card";
import ReviewCard from "./review-card";

import "../style.css";

const { Option } = Select;

let countdownInterval;
let check_payment_interval = null;

export default function SearchCaddyView({ is_comming }) {
  const navigate = useNavigate();
  const [search_pararms] = useSearchParams();
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const params = useParams();
  const formRef = useRef();

  const [isGetSearchDate, setIsGetSearchDate] = useState(false);

  const [showTermCondition, setShowTermCondition] = useState(false);
  const [privatecyCollapse, setPricatecyCollapse] = useState(false);
  const [termAndConditionCollapse, setTermAndConditionCollapse] =
    useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const [timeLeft, setTimeLeft] = useState(null);
  const [targetTime, setTargetTime] = useState(null);
  const [isCancel, setIsCancel] = useState(false);
  const [bookingData, setBookingData] = useState(null);

  // const [isSuccess, setIsSuccess] = useState(false);

  const [caddyData, setCaddyData] = useState();
  const [slipImage, setSlipImage] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [groupName, setGroupName] = useState(null);
  const [bookingNote, setBookingNote] = useState(null);
  const [selectedMode, setSelectedMode] = useState(
    search_pararms.get("modePreference") === "carting" || search_pararms.get("modePreference") === "walking"
      ? search_pararms.get("modePreference")
      : null
  );

  const [controllerData, setControllerData] = useState(null);

  const [available, setAvailable] = useState([]);
  const [avalibleSelected, setAvailableSelected] = useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const [openConfirmOrder, setOpenConfirmOrder] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [refundList, setRefundList] = useState([]);

  const [viewState, setViewState] = useState(params.booking_id ? 4 : 0);
  const [refundState, setRefundState] = useState(0);

  const [selectedPercen, setSelectedPercen] = useState(null);
  const [compensateTips, setCompensateTips] = useState(0);
  const [golferRefundAmount, setGolferRefundAmount] = useState(0);

  const [refundJobsSelected, setRefundJobsSelected] = useState(null);

  const [tipError, setTipError] = useState(false);
  const [isSkipCompensate, setIsSkipCompensate] = useState(false);

  const [confirmRefundData, setConfirmRefundData] = useState(null);
  const [isConfirmRefund, setIsConfirmRefund] = useState(false);

  const [paymentContent, setPaymentContent] = useState(null);

  const [refundAmount, setRefundAmount] = useState(0);

  const { userData, setUserData } = useContext(MainStore);

  const [isLoading, setIsLoading] = useState(false);

  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discountedGrandTotal, setDiscountedGrandTotal] = useState(null);
  const [couponError, setCouponError] = useState("");

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
        width: "100%",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  useEffect(() => {
    let isPopupOpen = false;

    const handleTouchMove = (event) => {
      const dropdown = document.querySelector(".touch-disable-dropdown");

      // ถ้า popup เปิดอยู่
      if (isPopupOpen && dropdown) {
        // ถ้า touch เกิดข้างนอก dropdown → ป้องกัน scroll ของ body
        if (!dropdown.contains(event.target)) {
          if (event.cancelable) event.preventDefault();
        }
      }
    };

    const observer = new MutationObserver(() => {
      const dropdown = document.querySelector(".touch-disable-dropdown");
      if (dropdown && !isPopupOpen) {
        isPopupOpen = true;
        document.body.style.overflow = "hidden";

        document.addEventListener("touchmove", handleTouchMove, {
          passive: false,
        });

        const removePopup = () => {
          isPopupOpen = false;
          document.body.style.overflow = "";
          document.removeEventListener("touchmove", handleTouchMove);
        };

        const popupObserver = new MutationObserver(() => {
          if (!document.querySelector(".touch-disable-dropdown")) {
            removePopup();
            popupObserver.disconnect();
          }
        });

        popupObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", handleTouchMove);
      observer.disconnect();
    };
  }, []);
  useEffect(() => {
    const cleanup = () => clearInterval(countdownInterval);

    if (
      !targetTime ||
      !bookingData ||
      bookingData.refuned ||
      bookingData.status === 2
    ) {
      return cleanup;
    }

    const calculateTimeDifference = () => {
      const now = new Date();
      const targetDate = dayjs(new Date(targetTime)).subtract(7, "hours");
      const difference = targetDate - now;

      return difference;
    };

    const parseTimeDifference = (difference) => {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      return { days, hours, minutes, seconds };
    };

    const handleExpiry = () => {
      clearInterval(countdownInterval);
      setTimeLeft(null);
      setIsCancel(true);
    };

    const updateCountdown = () => {
      const difference = calculateTimeDifference();
      console.log("difference", difference);

      if (difference <= 0) {
        handleExpiry();
      } else {
        const timeComponents = parseTimeDifference(difference);
        setTimeLeft(timeComponents);
      }
    };

    const initialDifference = calculateTimeDifference();
    if (initialDifference <= 0) {
      setTimeLeft(null);
      setIsCancel(true);
      return cleanup;
    }

    countdownInterval = setInterval(updateCountdown, 1000);

    return cleanup;
  }, [targetTime, bookingData]);

  useEffect(() => {
    if (
      paymentContent &&
      bookingData &&
      !bookingData.is_payment_complete &&
      !bookingData.refuned
    ) {
      check_payment_interval = setInterval(() => {
        CheckPaymentStatus();
      }, 3500);
    } else {
      clearInterval(check_payment_interval);
    }
  }, [paymentContent, bookingData]);

  useEffect(() => {
    GetCaddyData();
  }, []);
  const handleGoPayment = () => {
    let total = bookingData.grand_total;
    if (bookingData.roll_up_amount > 0) {
      total = bookingData.roll_up_amount;
    }

    // If a coupon is applied, re-create payment with coupon_code
    if (appliedCoupon) {
      handleGoPaymentWithCoupon(total);
      return;
    }

    navigate("/payment", {
      state: {
        booking_code: bookingData.booking_ref,
        booking_id: bookingData.id,
        grand_total: total,
      },
    });
  };

  const handleGoPaymentWithCoupon = async (originalTotal) => {
    setIsLoading(true);
    setCouponError("");

    try {
      const { data } = await api.paymentApi.createPayment({
        booking_code: bookingData.booking_ref,
        booking_id: bookingData.id,
        grand_total: discountedGrandTotal ?? originalTotal,
        coupon_code: appliedCoupon.coupon_code,
      });

      if (data.payment_code === 0) {
        setPaymentContent(data.data.pay_content);
        navigate("/payment", {
          state: {
            booking_code: bookingData.booking_ref,
            booking_id: bookingData.id,
            grand_total: discountedGrandTotal ?? originalTotal,
            coupon_code: appliedCoupon.coupon_code,
          },
        });
      }

      if (data.code === 400) {
        const couponErrorCodes = [
          "COUPON_EXPIRED",
          "COUPON_FULLY_REDEEMED",
          "COUPON_INVALID",
          "COUPON_USER_LIMIT_REACHED",
          "COUPON_MIN_SPEND_NOT_MET",
        ];
        if (couponErrorCodes.includes(data.error_code)) {
          setCouponError(data.message || "คูปองไม่สามารถใช้ได้ กรุณาลองใหม่");
          setAppliedCoupon(null);
          setDiscountedGrandTotal(null);
          messageApi.error(data.message || "คูปองไม่สามารถใช้ได้");
        } else {
          setPaymentContent(false);
        }
      }
    } catch (error) {
      console.error("CreatePayment with coupon error:", error);
      const errorData = error?.response?.data;
      const couponErrorCodes = [
        "COUPON_EXPIRED",
        "COUPON_FULLY_REDEEMED",
        "COUPON_INVALID",
        "COUPON_USER_LIMIT_REACHED",
        "COUPON_MIN_SPEND_NOT_MET",
      ];
      if (couponErrorCodes.includes(errorData?.error_code)) {
        setCouponError(errorData?.message || "คูปองไม่สามารถใช้ได้ กรุณาลองใหม่");
        setAppliedCoupon(null);
        setDiscountedGrandTotal(null);
        messageApi.error(errorData?.message || "คูปองไม่สามารถใช้ได้");
      } else {
        setPaymentContent(false);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const CheckPaymentStatus = async () => {
    // setIsLoading(true);

    try {
      const { data } = await api.bookingApi.getBooking(bookingData.id);
      const booking_resp = data.data;

      if (
        booking_resp.status !== bookingData.status ||
        booking_resp.is_payment_complete
      ) {
        GetBookingData(booking_resp.id);
        setPaymentContent(null);
        clearInterval(check_payment_interval);
      }
    } catch (error) {
      console.error("CheckPaymentStatus error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onClickAddFavorite = async (id) => {
    const temp = { ...userData };
    if (!temp.favorite) temp.favorite = [];
    temp.favorite.push(id);
    setIsLoading(true);

    try {
      const { status } = await api.favoriteApi.updateFavorite(userData.id, {
        favorite: temp.favorite,
      });
      if (status === 200) setUserData(temp);
    } catch (error) {
      console.error("Add favorite error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onClickRemoveFavorite = async (id) => {
    setIsLoading(true);

    const temp = { ...userData };
    if (!temp.favorite) temp.favorite = [];

    const favoriteIndex = temp.favorite.findIndex(
      (fav) => parseInt(fav) === parseInt(id)
    );

    if (favoriteIndex !== -1) {
      temp.favorite.splice(favoriteIndex, 1);
    }

    try {
      const { status } = await api.favoriteApi.updateFavorite(userData.id, {
        favorite: temp.favorite,
      });
      if (status === 200) setUserData(temp);
    } catch (error) {
      console.error("Remove favorite error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  async function GetCaddyData() {
    setIsLoading(true);
    const caddy_id = params.id;
    try {
      const { data } = await api.caddyApi.getCaddyById(caddy_id);
      const caddy = data.data;
      setCaddyData(caddy);
      setReviews(caddy.reviews);
      if (params.booking_id) {
        await GetBookingData(params.booking_id);
        setIsConfirmModal(false);
        // setViewState((prev) => prev + 1);
        GetRefundList();
      } else {
        await GetControllerData();
        await GetRefundList();
      }
    } catch (error) {
      console.error("GetCaddyData", error);
    } finally {
      setIsLoading(false);
    }
  }

  const calculateRefundAmount = (booking) => {
    if (booking.roll_up_amount < 0 && !booking.roll_up_from_job) {
      return Math.abs(booking.roll_up_amount);
    } else {
      if (booking.is_from_golfer) {
        return booking.fee;
      } else {
        return booking.grand_total;
      }
    }
  };

  const calculateViewAndRefundState = (booking) => {
    const rollUp = booking.roll_up_job;
    let viewState = 0;
    let refundState = 0;

    switch (booking.status) {
      case 0:
      case 1:
        viewState = booking.qr_expire ? 5 : 4;
        refundState = booking.is_from_golfer ? 0 : 1;
        break;
      case 2:
        viewState = 7;
        break;
      case 3: // ยกเลิก
        viewState = booking.refuned ? 9 : 8;
        refundState = 0;
        break;

      case 5: // ยกเลิกหลังการชำระเงิน
        viewState = 9;
        if (!booking.refuned && booking.is_refund) {
          if (booking.is_from_golfer) {
            refundState = 0;
          } else {
            refundState = 1;
          }
        } else {
          refundState = 4;
        }
        break;

      case 6: // รอรับเงินคืน
        viewState = 9;
        refundState = 4;
        break;

      case 7: // สำเร็จ
        viewState = 9;
        refundState = 3;
        break;

      default:
        viewState = booking.qr_expire ? 5 : 4;
        refundState = booking.is_from_golfer ? 0 : 1;
        break;
    }

    return { viewState, refundState };
  };

  const GetBookingData = async (booking_id, is_refresh = true) => {
    if (!is_refresh) return;
    setIsLoading(true);

    try {
      const { data } = await api.bookingApi.getBooking(booking_id);
      if (!booking_id || !data?.data) return;

      const booking = data.data;
      const refundAmount = calculateRefundAmount(booking);
      const targetDate = dayjs(new Date(targetTime)).subtract(7, "hours");

      setTargetTime(booking.qr_expire);
      setBookingData(booking);
      setRefundAmount(refundAmount);

      const { viewState, refundState } = calculateViewAndRefundState(booking);

      setViewState(viewState);
      setRefundState(refundState);

      if (targetDate && targetDate.isAfter(dayjs())) {
        console.log("Target date has passed");
        clearInterval(countdownInterval);
        setTimeLeft(null);
        setIsCancel(true);
        // setViewState(8);
      }

      if (
        viewState === 5 &&
        booking.status !== 2 &&
        !booking.is_payment_complete
      ) {
        CreatePayment(booking);
      }

      setCompensateTips(booking.caddy_compensate_amount);

      GetControllerData(
        (booking.roll_up_from_job &&
          booking.roll_up_amount <= 0 &&
          !booking.is_refund) ||
          booking.is_refund
      );
    } catch (error) {
      console.error("GetBookingData error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const CreatePayment = async (booking, couponCode) => {
    setIsLoading(true);

    try {
      const payload = {
        booking_code: booking.booking_ref,
        booking_id: booking.id,
        grand_total: booking.grand_total,
      };

      if (couponCode) {
        payload.coupon_code = couponCode;
      }

      const { data } = await api.paymentApi.createPayment(payload);

      if (data.payment_code === 0) {
        setPaymentContent(data.data.pay_content);
        setCouponError("");
      }

      if (data.code === 400) {
        // Handle coupon re-validation errors from payment endpoint
        const couponErrorCodes = [
          "COUPON_EXPIRED",
          "COUPON_FULLY_REDEEMED",
          "COUPON_INVALID",
          "COUPON_USER_LIMIT_REACHED",
          "COUPON_MIN_SPEND_NOT_MET",
        ];
        if (couponCode && couponErrorCodes.includes(data.error_code)) {
          setCouponError(data.message || "คูปองไม่สามารถใช้ได้ กรุณาลองใหม่");
          setAppliedCoupon(null);
          setDiscountedGrandTotal(null);
          messageApi.error(data.message || "คูปองไม่สามารถใช้ได้");
        } else {
          setPaymentContent(false);
        }
      }
    } catch (error) {
      console.error("CreatePayment error:", error);
      const errorData = error?.response?.data;
      const couponErrorCodes = [
        "COUPON_EXPIRED",
        "COUPON_FULLY_REDEEMED",
        "COUPON_INVALID",
        "COUPON_USER_LIMIT_REACHED",
        "COUPON_MIN_SPEND_NOT_MET",
      ];
      if (couponCode && couponErrorCodes.includes(errorData?.error_code)) {
        setCouponError(errorData?.message || "คูปองไม่สามารถใช้ได้ กรุณาลองใหม่");
        setAppliedCoupon(null);
        setDiscountedGrandTotal(null);
        messageApi.error(errorData?.message || "คูปองไม่สามารถใช้ได้");
      } else {
        setPaymentContent(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const GetControllerData = async (is_refund) => {
    setIsLoading(true);
    try {
      const { data } = await api.masterDataApi.getMasterDataController();
      setControllerData(data.data);
      if (is_refund) GetBankingDatas();
    } catch (error) {
      console.error("GetControllerData error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetBankingDatas = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.masterDataApi.getMasterDataBanks();
      setBankList(data.data);
    } catch (error) {
      console.error("GetBankingDatas error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onClickPayment = async () => {
    setOpenConfirmOrder(false);
    setIsLoading(true);

    // Merge mode preference into booking note
    const modeLabel = selectedMode === "carting" ? "รถกอล์ฟ (Cart)" : "เดิน (Walking)";
    const modeText = `[ใช้รถหรือเดิน: ${modeLabel}]`;
    const mergedNote = bookingNote
      ? `${modeText} ${bookingNote}`
      : modeText;

    const params = {
      caddy_name: caddyData.display_name,
      caddy_number: caddyData.caddy_number,
      qr_expire: dayjs().add(controllerData?.payment_time_out * 60, "seconds"),
      tf_date: search_pararms.get("date"),
      tf_time: dayjs(
        `${search_pararms.get("date")} ${search_pararms.get("time")}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DD HH:mm"),
      group_name: groupName,
      booking_note: mergedNote,
      slip: null,
      caddy_id: caddyData.id,
      golf_course_id: caddyData.golf_course.data.id,
      golfer_id: userData.id,
      roll_up_from_job: refundJobsSelected ? refundJobsSelected.id : null,
    };

    try {
      const { data, status } = await api.bookingApi.createBooking(params);

      if (status === 201) {
        liff.sendMessages([
          {
            type: "text",
            text: "สถานะการจอง: รอการยืนยันจากแคดดี้\n" +
              "แคดดี้: " + caddyData.display_name + "\n" +
              "เบอร์: " + caddyData.caddy_number + "\n" +
              "รหัสการจอง: " + data.ref + "\n" +
              "วันที่ทีออฟ: " + dayjs(data.tf_date).format("DD/MM/YYYY") + "\n" +
              "เวลาทีออฟ: " + dayjs(data.tf_time).format("HH:mm") + "\n\n" +
              "*หมายเหตุ การจองจะเสร็จสมบูรณ์ต่อเมื่อนักกอล์ฟได้รับการยืนยันจากแคดดี้และได้มีการชำระเงินแล้วเท่านั้น",
          }
        ]);
        setViewState((prev) => prev + 1);
      }
      navigate(
        `/book_caddy/${caddyData.id}/${data.id}?date=${search_pararms.get(
          "date"
        )}&time=${dayjs(search_pararms.get("time"), "HH:mm").format("HH:mm")}`
      );
      setTargetTime(
        dayjs().add(controllerData?.payment_time_out * 60, "seconds")
      );
      setBookingData({
        booking_ref: data.ref,
        tf_date: data.tf_date,
        caddy_accept_expire_at: data.caddy_accept_expire_at,
        tf_time: data.tf_time,
      });
      GetBookingData(data.id, true);
    } catch (error) {
      console.error("booking error:", error);
      const messageTH = error?.response?.data?.error?.message?.th;
      if (messageTH) {
        messageApi.error(messageTH);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const disableDates = (current) => {
    const isBeforeToday = current && current < new Date().setHours(0, 0, 0, 0); // ปิดการใช้งานวันก่อนหน้า
    return isBeforeToday;
  };

  function Page1() {
    return (
      <div style={{ marginBottom: 20 }}>
        <Carousel autoplaySpeed={1500} autoplay style={{ height: 300 }}>
          {caddyData?.file_uploads?.map((file, index) => {
            return (
              <div key={"file_upload" + index}>
                <div
                  style={{
                    height: 300,
                    backgroundImage: `url(${file.image_url})`,
                    backgroundPosition: "center center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                ></div>
              </div>
            );
          })}
        </Carousel>
        <div className="search-caddy-view-content">
          <div
            style={{
              background: "white",
              padding: "15px 20px 20px 20px",
              borderRadius: 20,
              position: "relative",
              marginBottom: 20,
            }}
          >
            <div style={{ position: "absolute", right: 20, top: 15 }}>
              {userData?.favorite?.find((fav) => fav == caddyData?.id) ? (
                <HeartFilled
                  onClick={() => onClickRemoveFavorite(caddyData?.id)}
                  style={{ color: "red", fontSize: 24 }}
                />
              ) : (
                <HeartOutlined
                  onClick={() => onClickAddFavorite(caddyData?.id)}
                  style={{ fontSize: 24 }}
                />
              )}
            </div>

            <h2 style={{ marginBottom: 5 }}>{caddyData?.display_name}</h2>
            <h3>หมายเลขแคดดี้ : {caddyData?.caddy_number}</h3>
            {/* <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <Rate allowHalf disabled={true} value={caddyData?.average_rate ?? 0} style={{ marginTop: 0, marginBottom: 5 }} />
              <div>({caddyData?.review_count} รีวิว)</div>
            </div> */}
            <div style={{ color: "#007AFF" }}>
              {caddyData?.golf_course?.data?.name}
            </div>

            <div
              style={{
                color: "rgb(255, 0, 169)",
                fontWeight: "bold",
                fontSize: 18,
                marginTop: 5,
                marginBottom: -5,
              }}
            >
              {new Intl.NumberFormat().format(caddyData?.price)} บาท
            </div>
           {(
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  color: "#555",
                  fontSize: 14,
                }}
              >
                <h3>ใช้รถหรือเดิน: </h3>
                <span>
                  {caddyData?.mode_preference === "walking"
                    ? "เดิน (Walking)"
                    : caddyData?.mode_preference === "carting"
                    ? "รถกอล์ฟ (Carting)"
                    : "เดิน / รถกอล์ฟ (Both)"}
                </span>
              </div>
            )}
            <div style={{ marginTop: 15 }}>
              <h2>เกี่ยวกับฉัน</h2>
              <Divider style={{ margin: "5px 0px" }} />
              <div style={{ marginTop: 10 }}>{caddyData?.about_me}</div>
            </div>
            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <h2>รีวิวล่าสุด</h2>
              <Divider style={{ margin: "5px 0px" }} />
              {reviews?.length > 0 ? (
                reviews.map((review) => {
                  return <ReviewCard data={review} />;
                })
              ) : (
                <Empty
                  style={{ marginTop: 20 }}
                  description="ยังไม่มีการ Review"
                />
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: 10,
            width: "100%",
            left: 0,
            padding: "0px 20px 10px 20px",
          }}
          onClick={() => setViewState(1)}
        >
          <Button type="primary" style={{ width: "100%", height: 35 }}>
            จองแคดดี้
          </Button>
        </div>
      </div>
    );
  }

  const handleSearchSlot = async (values) => {
    setIsLoading(true);
    const params = {
      tf_date: dayjs(values.tee_off_date).format("YYYY-MM-DD"),
    };

    try {
      const { data } = await api.caddyApi.searchTfDate(caddyData?.id, params);
      setAvailable(data.data);
    } catch (error) {
      console.error("handleSearchSlot error:", error);
      setAvailable(null);
    } finally {
      setIsLoading(false);
    }
  };

  function Page2() {
    const search_date = search_pararms.get("date")
      ? dayjs(
        search_pararms.get("date"),
        search_pararms.get("date").split("-")[0].length === 4
          ? "YYYY-MM-DD"
          : "DD-MM-YYYY"
      )
      : null;
    if (search_date && caddyData && viewState === 1 && !isGetSearchDate) {
      handleSearchSlot({ tee_off_date: search_date });
      setIsGetSearchDate(true);
    }

    return (
      <div className="search-caddy-view-content">
        <div
          style={{
            padding: 20,
            background: "white",
            borderRadius: 15,
            marginTop: 20,
          }}
        >
          <Form layout="vertical" onFinish={handleSearchSlot}>
            <Form.Item
              initialValue={search_date ?? null}
              rules={[{ required: true, message: "กรุณาเลือก วันทีออฟ" }]}
              name="tee_off_date"
              label={<h3>เลือก วันทีออฟ</h3>}
            >
              <DatePicker
                onChange={(value) => {
                  handleSearchSlot({ tee_off_date: value });
                }}
                disabledDate={disableDates}
                format={"DD-MM-YYYY"}
                style={{ width: "100%" }}
                inputReadOnly={true}
              />
            </Form.Item>
            {/* <Form.Item style={{ margin: 0 }}>
              <Button
                htmlType="submit"
                type="primary"
                style={{ width: "100%" }}
              ></Button>
            </Form.Item> */}
          </Form>
        </div>

        <div
          style={{
            padding: 20,
            background: "white",
            borderRadius: 15,
            marginTop: 15,
          }}
        >
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>
            ใช้รถหรือเดิน
          </div>
          <Radio.Group
            value={selectedMode}
            onChange={(e) => setSelectedMode(e.target.value)}
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            {BOOKING_MODE_OPTIONS.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
          {!selectedMode && (
            <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 5 }}>
              กรุณาเลือกใช้รถหรือเดิน
            </div>
          )}
        </div>

        <Divider style={{ margin: "15px 0px 15px 0px" }} />

        <div
          style={{
            padding: 20,
            background: "white",
            borderRadius: 15,
            marginTop: 10,
          }}
        >
          <h3>ตาราง เวลาทีออฟ</h3>
          {available?.available_slots?.length > 0 ? (
            available?.available_slots?.map((slot) => {
              return (
                <AvailableCard
                  onClick={() => {
                    setViewState(2);
                    setAvailable(null);
                    setAvailableSelected({ date: available.date, slot: slot });
                  }}
                  date={available?.date}
                  data={slot}
                  caddy_profile={caddyData?.file_uploads?.find(
                    (file) => file.type === "profile"
                  )}
                />
              );
            })
          ) : (
            <Empty description={"ไม่มีรายการ เวลาทีออฟ ที่ว่างอยู่"} />
          )}
        </div>
      </div>
    );
  }

  const disableHours = () => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      if (
        i < dayjs(avalibleSelected?.slot?.start, "HH:mm").format("HH") ||
        (!avalibleSelected?.slot?.end &&
          i > dayjs(avalibleSelected?.slot?.start, "HH:mm").format("HH")) ||
        i > dayjs(avalibleSelected?.slot?.end, "HH:mm").format("HH")
      ) {
        hours.push(i);
      }
    }
    return hours;
  };

  const disableMinutes = (selectedHour) => {
    const minutes = [];
    const start = dayjs(avalibleSelected?.slot?.start, "HH:mm");
    const end = avalibleSelected?.slot?.end
      ? dayjs(avalibleSelected?.slot?.end, "HH:mm")
      : null;

    const startHour = parseInt(start.format("HH"), 10);
    const startMinute = parseInt(start.format("mm"), 10);
    const endHour = end ? parseInt(end.format("HH"), 10) : null;
    const endMinute = end ? parseInt(end.format("mm"), 10) : null;

    for (let i = 0; i < 60; i++) {
      // กรณีเลือกชั่วโมงเท่ากับ start hour
      if (selectedHour === startHour && i < startMinute) {
        minutes.push(i);
      }
      // กรณีไม่มี end slot → disable ทั้งหมดยกเว้น startMinute
      else if (!end && i !== startMinute) {
        minutes.push(i);
      }
      // กรณีเลือกชั่วโมงเท่ากับ end hour
      else if (end && selectedHour === endHour && i > endMinute) {
        minutes.push(i);
      }
    }

    return minutes;
  };

  function handleSubmit(values) {
    navigate(
      `/book_caddy/${caddyData.id}?date=${avalibleSelected.date}&time=${dayjs(
        values.tftime
      ).format("HH:mm")}`
    );
    setViewState((prev) => prev + 1);
  }

  const GetRefundList = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.bookingApi.getRefundList({
        golfer_id: userData.id,
      });
      setRefundList(data.data);
      setRefundJobsSelected(data.data[0]);
    } catch (error) {
      console.error("GetRefundList error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  function GetRefundTotal(refund_amount) {
    const vat = controllerData?.transaction_fee * 0.07;
    return (
      vat + caddyData?.price + controllerData?.transaction_fee - refund_amount
    );
  }
  function onUploadSlip(values) {
    setIsConfirmModal(true);
  }

  const handleSumbit = async () => {
    setIsLoading(true);

    const formData = new FormData();

    formData.append("slip_image", slipImage[0].originFileObj);
    formData.append("golfer_id", userData.id);

    try {
      const response = await api.bookingApi.updateBooking(
        params.booking_id,
        formData
      );

      if (response.code === 400) {
        messageApi.error(
          `เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง หรือติดต่อพนักงาน.`
        );
        setIsConfirmModal(false);
      } else {
        GetBookingData(params.booking_id, true);
      }
    } catch (error) {
      console.error("handleSumbit error:", error);
      setIsConfirmModal(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  function onUploadImage(newFileList) {
    let newFile = { ...newFileList.file };

    if (newFile.status === "removed") return;

    newFile.percent = 100;
    newFile.status = "done";

    setSlipImage([newFile]);
  }

  function onClickCompensateTips() {
    if (!compensateTips || compensateTips <= 0) {
      setTipError(true);
      return;
    }

    setTipError(false);
    setRefundState((prev) => prev + 1);
  }

  function handleSubmitRefund(value) {
    setConfirmRefundData(value);
    setIsConfirmRefund(true);
  }

  const onSubmitRefuned = async () => {
    setIsLoading(true);

    let params = {};

    const hasRollUpJob = bookingData?.status !== 5 && bookingData?.roll_up_job;

    if (hasRollUpJob) {
      const rollUp = bookingData.roll_up_job;
      const golferRefundAmount =
        rollUp.roll_up_amount === 0
          ? refundAmount - compensateTips
          : Math.abs(refundAmount) - compensateTips;

      const refundAmountTotal =
        rollUp.roll_up_amount === 0 ? refundAmount : Math.abs(refundAmount);

      params = {
        golfer_refuned_amount: Number((golferRefundAmount ?? 0).toFixed(2)),
        refund_amount_total: Number((refundAmountTotal ?? 0).toFixed(2)),
        caddy_compensate_amount: Number((compensateTips ?? 0).toFixed(2)),
        golfer_id: bookingData.golfer_id,
        caddy_id: rollUp.caddy_id,
        booking_id: bookingData.id,
        bank_id: confirmRefundData.banking_id,
        golfer_banking_name: confirmRefundData.banking_name,
        golfer_banking_number: confirmRefundData.banking_number,
        roll_up_job: rollUp,
      };
    } else {
      const refundAmountTotal = bookingData?.roll_up_to_job
        ? Math.abs(refundAmount)
        : refundAmount;

      params = {
        golfer_refuned_amount: Number(
          (refundAmount - compensateTips ?? 0).toFixed(2)
        ),
        refund_amount_total: Number((refundAmountTotal ?? 0).toFixed(2)),
        caddy_compensate_amount: Number((compensateTips ?? 0).toFixed(2)),
        golfer_id: bookingData.golfer_id,
        caddy_id: bookingData.caddy_id,
        booking_id: bookingData.id,
        bank_id: confirmRefundData.banking_id,
        golfer_banking_name: confirmRefundData.banking_name,
        golfer_banking_number: confirmRefundData.banking_number,
        roll_up_job: bookingData?.roll_up_job,
      };
    }

    try {
      const { data } = await api.bookingApi.createRefund(params);
      if (data.code === 200) {
        messageApi.success("สร้างคำขอคืนเงินสำเร็จ");
        setViewState(hasRollUpJob ? 7 : 9);
        setRefundState((prev) => prev + 1);
        navigate(`/bookings`);
      }
    } catch (error) {
      console.error("onSubmitRefuned error:", error);
      messageApi.error(`เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง`);
    } finally {
      setIsConfirmRefund(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    calculateGolferRefundAmount(bookingData, refundAmount);
  }, [bookingData, refundAmount, compensateTips]);

  const calculateGolferRefundAmount = (booking, refundAmount) => {
    if (booking?.status == 5) {
      if (booking?.roll_up_amount < 0 && !booking?.roll_up_from_job) {
        setGolferRefundAmount(
          Math.abs(booking?.roll_up_amount) - compensateTips
        );
      } else {
        setGolferRefundAmount(refundAmount - compensateTips);
      }
    }
  };

  const PageRefund = () => {
    return (
      <div className="search-caddy-view-content">
        {refundState !== 0 ? (
          bookingData.is_from_golfer &&
          !bookingData.refuned &&
          !bookingData.roll_up_used ? (
            <div
              style={{
                position: "absolute",
                left: 20,
                top: 30,
                fontSize: 20,
                padding: 5,
              }}
              onClick={() => setRefundState((prev) => prev - 1)}
            >
              <CaretLeftFilled />
            </div>
          ) : (
            <Fragment />
          )
        ) : (
          <Fragment />
        )}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <center
            style={{
              color: "red",
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <h3 style={{ margin: 0, color: "#1F75FE" }}>
              ข้อมูลบัญชีธนาคาร เพื่อคืนเงินของ
            </h3>
            <h3 style={{ margin: 0, color: "#1F75FE" }}>
              Booking ID :{" "}
              {bookingData?.status !== 5 &&
              bookingData?.roll_up_job &&
              bookingData?.roll_up_job > 0
                ? bookingData?.roll_up_job?.booking_ref
                : bookingData?.booking_ref}
            </h3>
          </center>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              border: "1px solid rgba(5, 5, 5, 0.06)",
              padding: "20px 20px 0px 20px",
              borderRadius: 10,
            }}
          >
            {PAGE_REFUND[refundState]}
          </div>
        </div>
      </div>
    );
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  function renderTermCondition() {
    return (
      showTermCondition && (
        <div className="register-termcondition-container" style={{ top: 0 }}>
          <div
            className="payment-termcondition-content"
            style={{ overflowY: "scroll" }}
          >
            <center>
              <h2 style={{ marginBottom: 5, marginTop: "auto" }}>
                ข้อกำหนดและเงื่อนไขการชำระเงิน
              </h2>
            </center>
            <div
              style={{
                padding: 15,
                border: "2px solid #90C7C5",
                borderRadius: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ height: "100%", overflowY: "scroll" }}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                >
                  <div>
                    ข้าพเจ้ามีความประสงค์โดยสมัครใจขอเข้าร่วมเป็นสมาชิก Golfalo
                    ของ บริษัท กอล์ฟาโล่ จำกัด (“บริษัทฯ”)
                    ซึ่งเป็นผู้ให้บริการและผู้บริหารจัดการระบบสมาชิก Golfalo
                    เพื่อขอใช้บริการ โดยตกลงตามข้อกำหนดและเงื่อนไข ดังต่อไปนี้
                  </div>
                  <div>
                    <div>
                      1. ข้าพเจ้าตกลงให้บริษัทฯ
                      ออกบัตรหรือหลักฐานอื่นใดที่แสดงและยืนยันถึงการเป็นสมาชิก
                      Golfalo ตามประเภทที่ระบุด้านล่าง ในรูปแบบตามที่บริษัทฯ
                      กำหนด เช่น digital membership card เป็นต้น (รวมเรียกว่า
                      “บัตร”) ให้แก่ข้าพเจ้า จนกว่าข้าพเจ้าหรือบริษัทฯ
                      ฝ่ายใดฝ่ายหนึ่งจะแจ้งยกเลิกการเป็นสมาชิก Golfalo
                      ของข้าพเจ้า ตามวิธีการที่บริษัทฯ กำหนด
                      โดยข้าพเจ้าตกลงและรับทราบว่า
                      ข้าพเจ้าจะต้องแสดงบัตรหรือข้อมูลอื่นใดที่แสดงถึงการเป็นสมาชิก
                      Golfalo ผ่านช่องทางตามที่บริษัทฯ กำหนด เช่น Golfalo
                      Application แอปพลิเคชันอื่นใด หรือโปรแกรมใดๆ เป็นต้น
                      ต่อบริษัทฯ หรือบุคคลอื่นใดตามที่บริษัทฯ กำหนด
                      เพื่อรับสิทธิประโยชน์ใดๆ จากการเป็นสมาชิก Golfalo
                    </div>
                    <div style={{ marginTop: 10 }}>
                      2. ในการเป็นสมาชิก Golfalo
                      ข้าพเจ้ามีสิทธิเข้าร่วมกิจกรรมทางการตลาดที่จัดขึ้นเพื่อสิทธิประโยชน์ของสมาชิก
                      Golfalo ซึ่งรวมถึงแต่ไม่จำกัดเพียง การติดต่อ
                      การสื่อสารทางการตลาด การมอบ การประชาสัมพันธ์
                      การเผยแพร่ข้อมูลข่าวสาร การส่งเสริมการขาย
                      การให้สิทธิประโยชน์ทางการตลาด การแสดงสินค้า
                      การจัดหรือสนับสนุนให้มีการจัดกิจกรรมพิเศษ การตลาดแบบตรง
                      และ/หรือการเชิญชวนให้ข้าพเจ้าเข้าร่วมกิจกรรมในรูปแบบต่างๆ
                      ในการขายสินค้า บริการ หรือภาพลักษณ์ กับบริษัทฯ
                      กลุ่มกอล์ฟาโล่ ตลอดจนบริษัทในเครือ บริษัทย่อย
                      และ/หรือพันธมิตรทางธุรกิจของกลุ่มกอล์ฟาโล่
                      (ซึ่งต่อไปนี้จะรวมเรียกบริษัทฯ กลุ่มกอล์ฟาโล่
                      บริษัทในเครือ และบริษัทในกลุ่ม ว่า
                      “กลุ่มบริษัทกอล์ฟาโล่”และจะเรียกพันธมิตรทางธุรกิจของกลุ่มกอล์ฟาโล่
                      ว่า “กลุ่มพันธมิตรทางธุรกิจ”)
                    </div>
                    <div style={{ marginTop: 10 }}>
                      3.
                      ข้าพเจ้าตกลงปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บัตรและการเป็นสมาชิก
                      Golfalo ตามที่บริษัทฯ กำหนด
                      ตลอดจนการเปลี่ยนแปลงแก้ไขที่อาจจะมีขึ้นในภายหน้า
                      โดยบริษัทฯ
                      จะแจ้งให้ทราบถึงการเปลี่ยนแปลงดังกล่าวผ่านช่องทางการติดต่อใดๆ
                      ของบริษัทฯ
                    </div>
                    <div style={{ marginTop: 10 }}>
                      4. ข้าพเจ้าตกลงว่าบริษัทฯ
                      สามารถปฏิเสธการเข้าร่วมเป็นสมาชิก Golfalo ได้ตามที่บริษัทฯ
                      เห็นสมควร โดยไม่ต้องแจ้งให้ข้าพเจ้าทราบล่วงหน้า
                      และไม่ต้องรับผิดใดๆ ต่อข้าพเจ้า
                    </div>
                    <div style={{ marginTop: 10 }}>
                      5.
                      ข้าพเจ้าตกลงว่าข้าพเจ้าจะรับผิดชอบภาษีทั้งหมดที่เกิดขึ้นจากการร่วมกิจกรรมเป็น
                      Gift Card บัตรกำนัลเงินสด ส่วนลด หรือของรางวัลต่างๆ
                      แต่เพียงผู้เดียว (ถ้ามี)
                    </div>
                    <div style={{ marginTop: 10 }}>
                      6.
                      ข้าพเจ้ารับทราบว่าหากข้าพเจ้าละเมิดข้อกำหนดและเงื่อนไขนี้
                      และนโยบายใดๆ ที่เกี่ยวข้อง บริษัทฯ
                      และกลุ่มบริษัทกอล์ฟาโล่อาจพิจารณาดำเนินการใดๆ
                      ตามที่เห็นสมควร รวมไปถึงการระงับหรือยกเลิกการเป็นสมาชิก
                      Golfalo ของข้าพเจ้า
                      ตลอดจนการดำเนินการอย่างใดอย่างหนึ่งตามที่เห็นสมควร
                    </div>
                    <div style={{ marginTop: 10 }}>
                      7. ข้าพเจ้าตกลงว่าบริษัทฯ กลุ่มบริษัทกอล์ฟาโล่
                      และกลุ่มพันธมิตรทางธุรกิจ
                      สามารถเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บัตร
                      การเป็นสมาชิก Golfalo และการเข้าร่วมกิจกรรมทางการตลาด
                      ตลอดจนของกำนัลที่จัดให้แลก รวมทั้งสิทธิพิเศษต่างๆ
                      โดยมิต้องแจ้งให้ข้าพเจ้าทราบล่วงหน้า ทั้งนี้
                      กรณีที่มีปัญหา
                      หรือข้อขัดแย้งเกี่ยวกับข้อกำหนดและเงื่อนไขดังกล่าว
                      ให้บริษัทฯ เป็นผู้ชี้ขาด และให้คำชี้ขาดของบริษัทฯ ถือเป็น
                      ที่สิ้นสุด
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div>
                        8. บริษัทฯ
                        และกลุ่มบริษัทกอล์ฟาโล่ไม่ต้องรับผิดต่อท่านหรือบุคคลใดๆ
                        ในกรณีดังต่อไปนี้
                      </div>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          8.1) การใช้สิทธิในการเป็นสมาชิก Golfalo
                          โดยไม่ได้รับอนุญาต
                        </div>
                        <div>
                          8.2) การใช้สิทธิในการเป็นสมาชิก Golfalo
                          เกิดความล่าช้าหรือข้อผิดพลาดอันเนื่องมาจากสถานการณ์ที่อยู่เหนือการควบคุมของบริษัทฯ
                          หรือกลุ่มบริษัทกอล์ฟาโล่
                        </div>
                        <div>
                          8.3) ความสูญเสีย ความบกพร่อง หรือความเสียหายใดๆ
                          ที่ไม่ได้เกิดขึ้นจากความผิดของบริษัทฯ
                          หรือกลุ่มบริษัทกอล์ฟาโล่
                        </div>
                        <div>
                          8.4)
                          ความถูกต้องตามกฎหมายของธุรกรรมที่เกิดขึ้นระหว่างท่านและร้านค้าที่ร่วมรายการ
                          และ/หรือกรณีใดๆ อันเกิดมาจากเหตุสุดวิสัย
                          (รวมถึงภัยธรรมชาติ ไวรัสโคโรนาสายพันธุ์ใหม่หรือ
                          โควิด-19 โรคระบาด โรคระบาดที่กลายพันธุ์ การกักตัว
                          และกิจกรรมที่เป็นไปตามคำสั่งของหน่วยงานรัฐบาล เป็นต้น)
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      9. ท่านตกลงที่จะชดใช้ค่าเสียหาย ปกป้องความเสียหาย
                      และปลดเปลื้องความรับผิดของบริษัทฯ และกลุ่มบริษัทกอล์ฟาโล่
                      จากการอ้างสิทธิ การฟ้องร้องดำเนินคดี การดำเนินการ คำสั่ง
                      ความรับผิด และค่าเสียหายใดๆ ทั้งหมด ไม่ว่าในลักษณะใด
                      รวมถึงหนี้สิน ความเสียหาย การชำระหนี้ บทลงโทษ ค่าปรับ
                      ค่าใช้จ่ายและต้นทุนที่เกี่ยวข้องทั้งหมด
                      ซึ่งเกิดจากหรือเกี่ยวข้องกับการฝ่าฝืนหรือละเมิดข้อกำหนดและเงื่อนไขนี้
                      และนโยบายอื่นใดที่เกี่ยวข้อง
                    </div>
                    <div style={{ marginTop: 10 }}>
                      10. ข้อกำหนดและเงื่อนไขนี้
                      จัดทำขึ้นเป็นภาษาไทยและภาษาอังกฤษ
                      ในกรณีที่มีข้อขัดแย้งระหว่างฉบับภาษาไทยและฉบับภาษาอังกฤษ
                      ให้ฉบับภาษาไทยมีผลใช้บังคับ
                    </div>
                    <div style={{ marginTop: 10 }}>
                      11.
                      ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้บังคับตามกฎหมายแห่งราชอาณาจักรไทย
                      ข้อพิพาทใดๆ
                      ที่เกิดขึ้นหรือเกี่ยวข้องกับข้อกำหนดและเงื่อนไขนี้
                      ให้ดำเนินคดี ณ ศาลที่มีเขตอำนาจในประเทศไทย
                    </div>
                    <div style={{ marginTop: 10 }}>
                      12.
                      ข้าพเจ้ารับรองว่าข้าพเจ้าได้อ่านและรับทราบถึงเนื้อหาภายในนโยบายคุ้มครองข้อมูลส่วนบุคคล
                      ของบริษัทฯ ซึ่งอธิบายถึงการเก็บรวบรวม ใช้ เปิดเผย
                      และ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของข้าพเจ้า
                      ตามที่ได้ระบุไว้ใน Privacy Policy
                      ซึ่งอาจมีการแก้ไขเป็นครั้งคราว
                      (โปรดอ่านนโยบายความส่วนตัวของบริษัทฯ
                      ทุกครั้งก่อนทำธุรกรรมกับบริษัทฯ)
                    </div>
                    <div style={{ marginTop: 10 }}>
                      13. ข้าพเจ้ารับรองแก่บริษัทฯ ว่า ข้อมูลใดๆ
                      ที่ข้าพเจ้าให้แก่บริษัทฯ ไว้ รวมถึงข้อมูลส่วนบุคคล
                      เป็นข้อมูลที่ถูกต้องสมบูรณ์ และเป็นปัจจุบัน ทั้งนี้
                      ข้าพเจ้าจะแจ้งให้บริษัทฯ ทราบ หากมีการเปลี่ยนแปลงใดๆ
                      ในเนื้อหาข้อมูลที่เคยให้ไว้กับบริษัทฯ เพื่อให้บริษัทฯ
                      สามารถให้บริการ และ/หรือดำเนินการใดๆ
                      ตามที่ระบุไว้ในข้อกำหนดและเงื่อนไขนี้
                      แก่ข้าพเจ้าได้อย่างต่อเนื่อง
                    </div>
                    <div style={{ marginTop: 10 }}>
                      14.
                      ในกรณีที่ข้าพเจ้าได้ให้ข้อมูลส่วนบุคคลของบุคคลอื่นแก่บริษัทฯ
                      ข้าพเจ้ารับรองแก่บริษัทฯ ว่า (ก)
                      เจ้าของข้อมูลส่วนบุคคลนั้นๆ ได้รับทราบถึงการเก็บรวบรวม ใช้
                      เปิดเผย
                      และ/หรือการโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลภายใต้ข้อกำหนดและเงื่อนไขนี้
                      (ข) ข้าพเจ้าได้รับความยินยอม หรือมีฐานทางกฎหมายอื่นๆ
                      ในการเก็บรวบรวม ใช้ เปิดเผย
                      และ/หรือการโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
                      และ (ค)
                      ข้าพเจ้ามีอำนาจในการเปิดเผยข้อมูลส่วนบุคคลของบุคคลนั้นๆ
                      แก่บริษัทฯ ซึ่งเป็นผลให้บริษัทฯ มีสิทธิในการเก็บรวบรวม ใช้
                      เปิดเผย และ/หรือการโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคล
                      เพื่อวัตถุประสงค์เดียวกันตามที่ได้ระบุไว้ ณ ที่นี้
                      ข้าพเจ้าจะชดใช้ค่าเสียหายให้แก่บริษัทฯ ทั้งหมดจากค่าปรับ
                      การสูญเสีย หรือความเสียหายที่เกิดขึ้นกับบริษัทฯ
                      อันเป็นผลมาจากการที่ข้าพเจ้าละเมิดการรับรองใดๆ เหล่านี้
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <div>
                        15. ข้าพเจ้ารับทราบและยอมรับสิทธิประโยชน์สำหรับสมาชิก
                        Golfalo ดังนี้
                      </div>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          15.1) การเป็นสมาชิก Golfalo เกี่ยวกับ lucky draw
                        </div>
                        <div>
                          15.2) คะแนนสะสมในบัญชีสมาชิก Golfalo
                          ของข้าพเจ้าไม่สามารถโอนไปยังบัญชีสมาชิก Golfalo
                          ของผู้อื่น หรือโอนสิทธิให้ผู้อื่นได้
                        </div>
                        <div>
                          15.3) คะแนนสะสมที่ถูกใช้งานไปแล้วในคราวใด
                          จะถูกประมวลผลเพื่อทำการหักลบในยอดคงเหลือทันที
                        </div>
                        <div>15.4) คะแนนสะสมไม่มีวันหมดอายุ</div>
                        <div>
                          15.5) ในกรณีที่มีการขอยกเลิกการเป็นสมาชิก Golfalo
                          หรือบริษัทฯ ได้ยกเลิกการเป็นสมาชิก Golfalo
                          ในการนำคะแนนสะสมมาใช้งานจะสิ้นสุดลงในทันที
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      16. การสอบถามรายละเอียดเพิ่มเติม
                      หรือรายละเอียดเกี่ยวกับการเป็นสมาชิก Golfalo
                      รวมถึงการร้องเรียนหรือติดตามการดำเนินการแก้ไขข้อร้องเรียน
                      สามารถสอบถามหรือดำเนินการได้ โดยติดต่อไปยัง
                      <b>
                        <div>
                          บริษัทกอล์ฟาโล่ จำกัด 571 อาคารอาร์เอสยูทาวเวอร์ ชั้น9
                          ยูนิต903 ซอยสุขุมวิท31 ถนนสุขุมวิท แขวงคลองตันเหนือ
                          เขตวัฒนา กรุงเทพมหานคร 10110
                        </div>
                        <div>โทร.02-117-9538</div>
                        <div>email: info@golfalo.com</div>
                      </b>
                    </div>
                  </div>
                </div>
                <Divider style={{ margin: "10px 0px" }} />
                <div style={{ marginTop: 15 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      setPricatecyCollapse((prev) => !prev);
                    }}
                  >
                    <h3 style={{ margin: 0 }}>
                      นโยบายความเป็นส่วนตัว (Privacy Notice)
                    </h3>
                    {privatecyCollapse ? (
                      <CaretUpOutlined />
                    ) : (
                      <CaretDownOutlined />
                    )}
                  </div>

                  <div
                    className={`privacy-container ${
                      privatecyCollapse ? "collapse" : ""
                    }`}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                        padding: "0px 10px",
                        marginTop: 10,
                      }}
                    >
                      <div>
                        บริษัท กอล์ฟาโล่ จำกัด (“บริษัทฯ” “เรา” หรือ “ของเรา”)
                        เล็งเห็นถึงความสำคัญของการคุ้มครองสิทธิของท่านในข้อมูลใดๆ
                        ที่เกี่ยวข้องกับบุคคลธรรมดาซึ่งถูกระบุหรือสามารถถูกระบุได้
                        (“ข้อมูลส่วนบุคคล”) จากผลิตภัณฑ์และบริการของบริษัทฯ
                        บริษัทฯ
                        ทราบดีว่าท่านต้องการที่จะได้รับการคุ้มครองตามมาตรฐานที่ระบุโดยกฎหมายไทยที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคลในส่วนของวิธีการที่บริษัทฯ
                        เก็บรวบรวม ใช้
                        เปิดเผยและ/หรือโอนข้อมูลของท่านไปยังต่างประเทศ
                        ข้อมูลที่ท่านให้กับบริษัทฯ นั้น ทำให้บริษัทฯ
                        สามารถมอบผลิตภัณฑ์และการให้บริการที่ตรงกับความต้องการเฉพาะสำหรับท่านอย่างเหมาะสมจากบริษัทฯ
                        บริษัท กอล์ฟาโล่ จำกัด ซึ่งบริษัทฯ
                        มีมาตรการคุ้มครองข้อมูลส่วนบุคคลซึ่งรวมถึงการคุ้มครองมิให้ข้อมูลส่วนบุคคลของท่านถูกใช้โดยมิได้รับความยินยอมจากท่านก่อน
                        นโยบายความเป็นส่วนตัวฉบับนี้ (“นโยบายความเป็นส่วนตัว”)
                        ใช้กับแอปพลิเคชั่นบนโทรศัพท์มือถือ
                        ช่องทางสื่อสังคมออนไลน์ ช่องทางการสื่อสารทางออนไลน์
                        งานและกิจกรรม ตลอดจนสถานที่อื่นๆ
                        ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม
                        กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับบริการเฉพาะดังกล่าวที่ท่านใช้
                        ซึ่งอาจมีข้อตกลงและเงื่อนไขต่างหากเกี่ยวกับข้อมูลส่วนบุคคลของท่านที่บริษัทฯ
                        เก็บไว้ บริษัทฯ
                        ขอสงวนสิทธิในการแก้ไขนโยบายความเป็นส่วนตัวนี้เมื่อบริษัทฯ
                        เห็นว่ามีความจำเป็น ซึ่งอาจมีหรือไม่มีการแจ้งล่วงหน้า
                        ดังนั้นโปรดอ่านนโยบายความเป็นส่วนตัวนี้ทุกครั้งก่อนทำธุรกรรมกับบริษัทฯ
                        โดยบริษัทฯ
                        จะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงในสาระสำคัญ
                      </div>
                      <div>
                        <div>
                          1. ข้อมูลส่วนบุคคลประเภทใดบ้างที่บริษัทฯ เก็บรวบรวม
                          บริษัทฯ อาจมีการเก็บรวบรวม รักษา
                          และใช้ข้อมูลประเภทดังต่อไปนี้
                          ซึ่งอาจรวมไปถึงข้อมูลส่วนบุคคลของท่านโดยตรงหรือโดยอ้อมจากท่าน
                          แหล่งข้อมูลอื่นๆ หรือจากกลุ่มบริษัทกอล์ฟาโล่
                          พันธมิตรทางธุรกิจ และ/หรือจากการสื่อสารระหว่างบริษัทฯ
                          โดยลักษณะของข้อมูลส่วนบุคคลที่บริษัทฯ
                          เก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารและความสัมพันธ์ของบริษัทฯ
                          กับท่าน
                          รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากบริษัทฯ
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            1.1) ข้อมูลส่วนตัว เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ
                            อายุ หมู่เลือด สัญชาติ วันเกิด ประวัติการศึกษา อาชีพ
                            ตำแหน่งงาน สถานที่ทำงาน ข้อมูลบนบัตรที่ออกโดยรัฐบาล
                            (เช่น เลขที่บัตรประจำตัวประชาชน เลขหนังสือเดินทาง
                            ข้อมูลใบอนุญาตขับขี่รถยนต์
                            บัตรประจำตัวเจ้าหน้าที่ของรัฐ
                            หรือเอกสารระบุตัวตนที่มีลักษณะเดียวกัน เป็นต้น)
                            รูปถ่าย และ/หรือข้อมูลทางกายภาพอื่นๆ
                          </div>
                          <div>
                            1.2) ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์
                            ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้
                            หมายเลขโทรศัพท์ ที่อยู่อีเมล
                            ชื่อบัญชีผู้ใช้แอปพลิเคชันไลน์ (LINE ID)
                            และ/หรือชื่อบัญชีผู้ใช้ในเว็บไซต์สื่อสังคมออนไลน์อื่นๆ{" "}
                          </div>
                          <div>
                            1.3) ข้อมูลทางการเงิน เช่น ข้อมูลบัญชีธนาคาร
                            และ/หรือข้อมูลทางการเงินอื่นๆ
                          </div>
                          <div>
                            1.4) ข้อมูลการทำธุรกรรม เช่น
                            ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน
                            วันที่และเวลาที่ชำระเงิน ยอดชำระเงิน ใบเสร็จ
                            ใบแจ้งหนี้ ประวัติการทำธุรกรรม
                            และ/หรือสถานะของธุรกรรม{" "}
                          </div>
                          <div>
                            1.5) ข้อมูลและรายละเอียดด้านระบบคอมพิวเตอร์
                            เครื่องมือ และอุปกรณ์ เช่น ชื่อผู้ใช้ PIN
                            อุปกรณ์ที่ใช้ ที่ตั้งทางภูมิศาสตร์
                            ระบบที่ใช้ดำเนินงาน
                            ข้อมูลเครือข่ายของโทรศัพท์เครื่องที่
                            ข้อมูลการใช้งานคอมพิวเตอร์
                            และ/หรือข้อมูลการเรียกดูบริการบนเว็บไซต์และแอปพลิเคชัน
                            (เช่น ประวัติการค้นหา วันที่ เวลา)
                          </div>
                          <div>
                            1.6) ข้อมูลเกี่ยวกับพฤติกรรม เช่น
                            ข้อมูลเกี่ยวกับพฤติกรรมของท่าน วิถีการดำเนินชีวิต
                            ความคิดเห็น การสื่อสารโต้ตอบ{" "}
                          </div>
                          <div>
                            1.7) ข้อมูลการเป็นสมาชิก ได้แก่ หมายเลขบัตรสมาชิก
                            รหัสสมาชิก หรือ ชื่อผู้ใช้ และ/หรือข้อมูลอื่นๆ
                            เกื่ยวกับบริการที่ท่านได้ซื้อ ยื่นเรื่องร้องเรียน
                            เรียกร้องสิทธิ ติชม และให้คำแนะนำ
                          </div>
                          <div>
                            1.8) ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น
                            ความต้องการของท่านในการรับข้อมูลทางการตลาดจากบริษัทฯ
                            กลุ่มบริษัทกอล์ฟาโล่ บุคคลที่สาม พันธมิตรทางธุรกิจ
                            และ/หรือรูปแบบการติดต่อสื่อสารที่ต้องการหากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่บริษัทฯ
                            (เช่น ชื่อ นามสกุล ที่อยู่
                            หมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน เป็นต้น)
                            กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้
                            และ/หรือขอความยินยอมจากบุคคลเหล่านั้น หากสามารถทำได้
                            บริษัทฯ จะเก็บรวบรวม ใช้
                            และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่ละเอียดอ่อนก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน
                            หรือในกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ บริษัทฯ
                            จะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ
                            คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้แทนโดยชอบธรรม
                            ผู้พิทักษ์ หรือผู้อนุบาลของผู้เยาว์เท่านั้น บริษัทฯ
                            จะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่บริษัทฯ
                            รู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี
                            หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถ
                            หากไม่ได้รับความยินยอมจากผู้แทนโดยชอบธรรม ผู้พิทักษ์
                            หรือผู้อนุบาลในกรณีที่จำเป็นต้องได้รับความยินยอม
                            โดยในกรณีที่บริษัทฯ ทราบว่าบริษัทฯ
                            ได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใดๆ
                            ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ
                            หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้แทนโดยชอบธรรม
                            ผู้พิทักษ์ หรือผู้อนุบาล บริษัทฯ
                            จะดำเนินการลบข้อมูลดังกล่าวทันที หรือเก็บรวบรวม ใช้
                            และ/หรือเปิดเผยเฉพาะในส่วนของข้อมูลที่บริษัทฯ
                            สามารถกระทำได้บนฐานทางกฎหมายอื่นๆ
                            นอกเหนือจากการขอความยินยอม
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          2. เหตุใดบริษัทฯ จึงเก็บรวบรวม
                          ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            <div>
                              2.1) วัตถุประสงค์ที่ต้องได้รับความยินยอมจากท่าน
                            </div>
                            <div
                              style={{
                                padding: "0px 10px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                marginTop: 10,
                              }}
                            >
                              <div>
                                2.1.1) การตลาดและการติดต่อสื่อสาร
                                เพื่อติดต่อสื่อสารด้านการตลาด มอบสิทธิพิเศษ
                                การลดราคา การประชาสัมพันธ์ การแจ้งเตือน ข่าวสาร
                                โปรโมชั่น ข้อเสนอพิเศษ แคมเปญ งานอีเว้นท์
                                กิจกรรมทางการตลาด การโฆษณา และการตลาดทางตรง
                                และข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการจากบริษัทฯ
                                กลุ่มบริษัทกอล์ฟาโล่
                                และ/หรือพันธมิตรทางธุรกิจของบริษัทฯ ซึ่งบริษัทฯ
                                ไม่สามารถอาศัยฐานทางกฎหมายอื่น
                              </div>
                              <div>
                                2.1.2) ธุรกิจวิเคราะห์ข้อมูล
                                เพื่อการทำธุรกิจวิเคราะห์ข้อมูล (Data Analytics
                                Business)
                              </div>
                            </div>
                          </div>
                          <div>
                            <div>
                              2.2) วัตถุประสงค์และฐานทางกฎหมายอื่นๆ ที่บริษัทฯ
                              ใช้เพื่อการเก็บรวบรวม ใช้
                              และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                            </div>
                            <div
                              style={{
                                padding: "0px 10px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                marginTop: 10,
                              }}
                            >
                              <div>2.2.1) บริษัทฯ อาจอาศัย</div>
                              <div
                                style={{
                                  padding: "0px 10px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 10,
                                  marginTop: 10,
                                }}
                              >
                                <div>
                                  (1)
                                  ฐานทางสัญญาในการเข้าทำสัญญาหรือการปฏิบัติตามสัญญากับท่าน
                                </div>
                                <div>
                                  (2) หน้าที่ตามกฎหมาย
                                  เพื่อการปฏิบัติหน้าที่ตามกฎหมาย
                                </div>
                                <div>
                                  (3) ประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ
                                  และของบุคคลภายนอก{" "}
                                </div>
                                <div>
                                  (4)
                                  ประโยชน์ซึ่งจำเป็นเพื่อการป้องกันหรือระงับอันตรายต่อชีวิต
                                  ร่างกาย หรือสุขภาพของบุคคล และ/หรือ
                                </div>
                                <div>
                                  (5) ประโยชน์สาธารณะ
                                  สำหรับการดำเนินภารกิจเพื่อประโยชน์สาธารณะ
                                  หรือการใช้สิทธิของเจ้าหน้าที่ของรัฐ
                                  หรือฐานทางกฎหมายอื่นๆ
                                  ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลอนุญาต
                                  (แล้วแต่กรณี) ทั้งนี้
                                  ขึ้นอยู่กับความสัมพันธ์ระหว่างบริษัทฯ กับท่าน
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                padding: "0px 10px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                marginTop: 10,
                              }}
                            >
                              <div>
                                2.2.2) บริษัทฯ อาจเก็บรวบรวม ใช้
                                และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้
                              </div>
                              <div
                                style={{
                                  padding: "0px 10px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 10,
                                  marginTop: 10,
                                }}
                              >
                                <div>
                                  (1) เพื่อจัดหาผลิตภัณฑ์และบริการให้แก่ท่าน
                                  เช่น
                                  เพื่อเข้าทำสัญญาที่เป็นลายลักษณ์อักษรหรือไม่เป็นลายลักษณ์อักษรและจัดการความสัมพันธ์ตามสัญญาระหว่างบริษัทฯ
                                  กับท่าน เพื่อสนับสนุนการสมัครสมาชิก
                                  สมัครใช้บัตร การใช้จ่ายและเปิดใช้งาน
                                  และดำเนินกิจกรรมอื่นๆ
                                  ที่เกี่ยวข้องกับรายละเอียดตามสัญญา
                                  ธุรกรรมทางการเงินและบริการที่เกี่ยวข้องกับการชำระเงิน
                                  เพื่อรายงานสถานะคำสั่งซื้อของท่าน
                                  การแจ้งเตือนวันหมดอายุของบัตรสมาชิกและบัตรกำนัลของท่าน
                                  การตรวจสอบยอดบัตรและคะแนนสะสม
                                  การให้บริการที่เกี่ยวข้องกับผลิตภัณฑ์ทางการเงิน
                                  กู้เงินธนาคาร การจัดการสินทรัพย์ การลงทุน
                                  ประกัน ธุรกรรมทางอิเล็กทรอนิกส์ บัตรเครดิต
                                  บัตรเงินสด ทรัพย์สิน การจัดส่งสินค้า
                                  บริการขนส่ง
                                  บริการด้านท่องเที่ยวและบริษัทนำเที่ยว
                                  การออกใบแจ้งหนี้และใบเสร็จ
                                  การเปลี่ยนหรือส่งคืนสินค้า และการคืนเงิน
                                  การแลกคะแนนสะสมเป็นของสมนาคุณ
                                  การอนุญาติการเชื่อมต่อและให้บริการ Wi-Fi ฟรี
                                  การให้บริการที่จอดรถ
                                  และการอนุญาตให้ออกจากอาคารในกรณีที่บัตรจอดรถหาย
                                  การให้บริการท่านในการเดินทางเชิงธุรกิจ
                                  การส่งหรือคืนของหายของท่าน
                                  และ/หรือการให้บริการหลังการขาย
                                </div>
                                <div>
                                  (2) การตลาดและการติดต่อสื่อสาร เช่น
                                  เพื่อการติดต่อ การสื่อสารทางการตลาด การมอบ
                                  การประชาสัมพันธ์ การเผยแพร่ข้อมูลข่าวสาร
                                  การส่งเสริมการขาย
                                  การให้สิทธิประโยชน์ทางการตลาด การแสดงสินค้า
                                  การจัดหรือสนับสนุนให้มีการจัดกิจกรรมพิเศษ
                                  การตลาดแบบตรง
                                  และ/หรือการเชิญชวนให้ข้าพเจ้าเข้าร่วมกิจกรรมในรูปแบบต่างๆ
                                  ในการขายสินค้า บริการ หรือภาพลักษณ์ จากบริษัทฯ
                                  กลุ่มบริษัทกอล์ฟาโล่
                                  และ/หรือพันธมิตรทางธุรกิจของบริษัทฯ
                                  ตามที่ท่านได้ระบุความต้องการของท่านไว้หรือเคยได้ใช้บริการมาก่อน
                                  ทั้งทางตรงและทางอ้อม
                                  ที่ไม่ต้องอาศัยความยินยอมจากท่าน
                                </div>
                                <div>
                                  (3) โปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง
                                  (Loyalty Programs) โปรแกรมการสะสมคะแนน
                                  (Rewarding Programs) การจับรางวัล
                                  และข้อเสนออื่นๆ เช่น เพื่อการสะสม ใช้
                                  และแลกเปลี่ยนคะแนน/เหรียญ เพื่อการแสดงสินค้า
                                  การจัดสรรและสนับสนุน กิจกรรมพิเศษ
                                  การสะสมและแลกคะแนนตามโปรแกรม การจับฉลาก
                                  และ/หรือบริการที่เกี่ยวข้องอื่นๆ
                                </div>
                                <div>
                                  (4) การแนะนำและการจัดการให้เหมาะสมกับบุคคล
                                  เช่น
                                  เพื่อแนะนำผลิตภัณฑ์และบริการที่ท่านอาจจะสนใจ
                                  ทราบถึงความต้องการของท่าน
                                  และ/หรือดำเนินการให้ท่านได้รับผลิตภัณฑ์และบริการที่เหมาะสมกับท่าน
                                </div>
                                <div>
                                  (5) การลงทะเบียนและการยืนยันตัวตน เช่น
                                  เพื่อลงทะเบียน ยืนยัน ระบุ
                                  และ/หรือรับรองท่านหรือตัวตนของท่าน
                                </div>
                                <div>
                                  (6) เพื่อติดต่อและสื่อสารกับท่าน เช่น
                                  เพื่อสื่อสารกับท่าน
                                  ที่เกี่ยวข้องกับผลิตภัณฑ์และการบริการที่ท่านได้รับ
                                  เพื่อประมวลและปรับข้อมูลของลูกค้าให้เป็นปัจจุบัน
                                  และรองรับคำถามเกี่ยวกับการบริการลูกค้า คำขอ
                                  ข้อเสนอแนะ การร้องเรียน การใช้สิทธิประกัน
                                  ข้อพิพาท และ/หรือการกำหนดจ่ายค่าสินไหมทดแทน
                                </div>
                                <div>
                                  (7)
                                  การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรมของลูกค้า
                                  (Profiling) และการวิเคราะข้อมูล (Data
                                  Analytics) เช่น
                                  เพื่อวิเคราะห์ข้อมูลส่วนบุคคลของท่าน (เช่น
                                  พฤติกรรมการใช้งานแอปพลิเคชั่น)
                                  สำหรับกิจกรรมทางด้านการตลาด
                                  และการพัฒนาผลิตภัณฑ์และบริการ
                                  การวิเคราะห์ข้อมูลตามความสนใจหรือพฤติกรรม
                                  (Profiling) และการทำความสะอาดข้อมูล (Data
                                  Cleansing) เพื่อทำการค้นคว้าวิจัยทางการตลาด
                                  ทำแบบสำรวจ ประเมินผล พฤติกรรม
                                  สถิติและการแบ่งประเภท
                                  รูปแบบและกระแสความนิยมด้านการบริโภค
                                  เพื่อยกระดับการดำเนินธุรกิจให้ดียิ่งขึ้น
                                  ตลอดจนเพื่อปรับเปลี่ยนเนื้อหาให้ตรงกับความพึงพอใจ
                                  คาดเดาอุปสงค์ในอนาคต
                                  และ/หรือเพื่อพิจารณาความมีประสิทธิภาพของการบริการ
                                  เพื่อวัตถุประสงค์ดังกล่าว บริษัทฯ
                                  จะเก็บรวบรวมและเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อความสนใจและผลประโยชน์ของท่าน
                                  หรือเพื่อประโยชน์โดยชอบด้วยกฎหมาย
                                  หรือการดำเนินธุรกิจของบริษัทฯ
                                  กลุ่มบริษัทกอล์ฟาโล่ และ/หรือพันธมิตรทางธุรกิจ
                                  ซึ่งไม่เกินกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของท่าน{" "}
                                </div>
                                <div>
                                  (8) เพื่อยกระดับการดำเนินธุรกิจ
                                  ผลิตภัณฑ์และการบริการให้ดียิ่งขึ้น เช่น
                                  เพื่อจัดการและยกระดับการให้บริการ
                                  และการดำเนินธุรกิจให้แก่ท่านและลูกค้าของบริษัทฯ
                                  ทั้งหมด ซึ่งรวมถึงแต่ไม่จำกัดเพียง
                                  พันธมิตรทางธุรกิจ
                                  เพื่อรับรองมาตรฐานของผลิตภัณฑ์และบริการบริษัทฯ
                                  เพื่อการให้คำแนะนำด้านกฎหมาย
                                  เพื่อจัดทำรายงานภาพรวมของข้อมูลและการใช้งานของลูกค้า
                                  เพื่อการวินิจฉัยและแก้ไขปัญหาที่เกิดจากบริการที่มีอยู่
                                  เพื่อติดตาม จัดการ
                                  และส่งเสริมประสบการณ์ลูกค้าบนแอปพลิเคชัน
                                  และแพลตฟอร์มของบริษัทฯ
                                  และ/หรือเสนอบริการเพิ่มเติมซึ่งอาจมีในอนาคต{" "}
                                </div>
                                <div>
                                  (9) เพื่อทราบข้อมูลเกี่ยวกับท่านมากขึ้น เช่น
                                  เพื่อทราบข้อมูลมากขึ้นเกี่ยวกับบริการที่ท่านได้รับ
                                  และบริการอื่นที่ท่านอาจสนใจ ตัวอย่างเช่น
                                  ด้วยการพิจารณาประเภทของบริการที่ท่านใช้จากบริษัทฯ
                                  ความถี่ของท่านในการเข้ามาใช้งานแอปพลิเคชั่น
                                  ท่านต้องการให้บริษัทฯติดต่อท่านอย่างไร ฯลฯ
                                  เพื่อทราบข้อมูลจากการสำรวจความพึงพอใจ การติชม
                                  คำแนะนำ และ/หรือข้อร้องเรียนของท่าน
                                </div>
                                <div>
                                  (10)
                                  การปฏิบัติตามหน้าที่ตามกฎข้อบังคับและข้อผูกพัน
                                  เช่น
                                  เพื่อดำเนินการให้เป็นไปตามบทบัญญัติแห่งกฎหมาย
                                  กระบวนการทางกฎหมาย หรือคำสั่งของหน่วยงานรัฐ
                                  ให้ความร่วมมือกับศาล ผู้ควบคุม หน่วยงานรัฐ
                                  และหน่วยงานที่บังคับใช้กฎหมาย
                                  ในกรณีที่มีเหตุผลอันควรเชื่อได้ว่าบริษัทฯ
                                  ต้องดำเนินการดังกล่าวเพื่อปฎิบัติตามกฎหมายและในกรณีที่บริษัทฯ
                                  จำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านอย่างเคร่งครัดเพื่อปฏิบัติตามบทบัญญัติแห่งกฎหมาย
                                  กระบวนการทางกฎหมาย หรือคำสั่งของรัฐดังกล่าว
                                  เพื่อการจัดการเรื่องการจ่ายภาษี
                                  การขอคืนภาษีมูลค่าเพิ่ม (VAT refunds)
                                  และ/หรือค่าธรรมเนียมอื่นๆ
                                </div>
                                <div>
                                  (11) การปกป้องผลประโยชน์ของบริษัทฯ เช่น
                                  เพื่อปกป้องความมั่นคงและความเชื่อมั่นทางธุรกิจของบริษัทฯ
                                  เพื่อใช้สิทธิหรือปกป้องผลประโยชน์ของบริษัทฯ
                                  ที่จำเป็นและสามารถทำได้ตามกฎหมาย เช่น
                                  การตรวจจับ ป้องกัน
                                  และตอบโต้ข้อเรียกร้องการทุจริต
                                  การละเมิดทรัพย์สินทางปัญญา
                                  เพื่อกระบวนการทางกฎหมายหรือการไม่ปฏิบัติตามกฎหมาย
                                  เพื่อจัดการและป้องกันความเสียหายแก่ทรัพย์สินและสมบัติของบริษัทฯ
                                  เพื่อการปฏิบัติตามข้อกำหนดและเงื่อนไขของบริษัทฯ
                                  การประมวลบนระบบรักษาความปลอดภัยและระบบดำเนินงาน
                                  IT
                                  เพื่อตรวจจับและป้องกันการประพฤติที่มิชอบภายในองค์กรซึ่งรวมไปถึงการใช้กล้องวงจรปิด
                                  เพื่อติดตามเฝ้าระวังเหตุการณ์
                                  และ/หรือเพื่อป้องกันและรายงานความผิดทางอาญา
                                </div>
                                <div>
                                  (12) การตรวจจับการทุจริต เช่น
                                  เพื่อตรวจจับและป้องกันการใช้บริการโดยไม่ได้รับอนุญาต
                                  หรือมีการทุจริต
                                  หรือผิดกฎหมายเพื่อดำเนินการตรวจสอบทางกฎหมายหรือกฎข้อบังคับอื่นๆ
                                  ที่บังคับใช้ (เช่น
                                  เพื่อดำเนินการตามกฎหมายป้องกันและปราบปรามการฟอกเงิน)
                                  ทั้งนี้ รวมไปถึง การตรวจสอบและทำบันทึกภายใน
                                  และการควบคุมทางธุรกิจอื่นๆ{" "}
                                </div>
                                <div>
                                  (13) การทำธุรกรรมขององค์กร เช่น
                                  ในกรณีที่มีการขาย การโอน การควบรวม
                                  การปรับโครงสร้างองค์กร หรือเหตุการณ์อื่นๆ
                                  ที่ใกล้เคียงกัน บริษัทฯ
                                  อาจโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกอื่นๆ
                                  ไม่ว่าจะรายเดียวหรือหลายราย
                                  อันเป็นส่วนหนึ่งของการทำธุรกรรมนั้นๆ และ/หรือ
                                </div>
                                <div>
                                  (14) ชีวิต
                                  เพื่อป้องกันหรือยับยั้งอันตรายที่เกิดขึ้นต่อชีวิต
                                  ร่างกาย หรือสุขภาพของบุคคล ทั้งนี้
                                  หากท่านไม่สามารถให้ข้อมูลส่วนบุคคลแก่บริษัทฯ
                                  เมื่อมีการร้องขอ บริษัทฯ
                                  อาจไม่สามารถนำเสนอหรือจัดหาผลิตภัณฑ์หรือบริการของบริษัทฯ
                                  แก่ท่านได้
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          3. บุคคลใดที่บริษัทฯ
                          อาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านได้ บริษัทฯ
                          อาจเปิดเผย
                          หรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลที่สามตามที่ระบุด้านล่าง
                          ซึ่งเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล
                          เพื่อวัตถุประสงค์ตามนโยบายความเป็นส่วนตัวฉบับนี้
                          บุคคลที่สามอาจอยู่ภายในประเทศไทยหรือภายนอกประเทศไทย
                          โดยท่านสามารถอ่านนโยบายส่วนบุคคลของบุคคลภายนอกเหล่านั้นเพื่อศึกษาข้อมูลเพิ่มเติมเกี่ยวกับวิธีการที่บุคคลภายนอกดังกล่าวเก็บรวบรวม
                          ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่านได้
                          เพราะท่านเองก็อยู่ภายใต้นโยบายความเป็นส่วนตัวเหล่านั้นด้วย
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.1) กลุ่มบริษัทกอล์ฟาโล่ ในฐานะที่ บริษัท กอล์ฟาโล่
                            จำกัด ซึ่งทั้งหมดมีการร่วมมือและเสนอบริการ
                            และระบบต่างๆ แก่ลูกค้า
                            รวมไปถึงแพลตฟอร์มที่เกี่ยวข้องกับเว็บไซต์และระบบอื่นๆ
                            บริษัทฯอาจมีความจำเป็นที่จะต้องเปิดเผยข้อมูลส่วนบุคคลของท่านไปยังบริษัทอื่นๆ
                            ในกลุ่มบริษัทกอล์ฟาโล่ หรืออนุญาตให้บริษัทอื่นๆ
                            ในกลุ่มกอล์ฟาโล่
                            ดังกล่าวเข้าถึงข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ตามที่ได้ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
                            ทั้งนี้ บริษัทอื่นๆ
                            ในกลุ่มกอล์ฟาโล่สามารถอาศัยความยินยอมที่บริษัทฯ
                            ได้รับมาได้ด้วยเช่นกัน ทั้งนี้ บริษัทฯ
                            จะปกป้องข้อมูลของท่านและจะเปิดเผยข้อมูลส่วนบุคคลของท่าน
                            เพื่อให้ท่านได้รับประโยชน์ในการรับบริการจากกลุ่มบริษัทกอล์ฟาโล่
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.2) ผู้ให้บริการของบริษัทฯ บริษัทฯ
                            อาจใช้บริการบริษัท ตัวแทน
                            หรือผู้รับจ้างอื่นเพื่อให้บริการต่างๆ แทนบริษัทฯ
                            หรือเพื่อช่วยในการจัดหาผลิตภัณฑ์และบริการให้แก่ท่าน
                            บริษัทฯ
                            อาจแบ่งปันข้อมูลส่วนบุคคลของท่านให้แก่ผู้ให้บริการหรือผู้จัดหาผลิตภัณฑ์บริการจากภายนอก
                            ซึ่งรวมถึง แต่ไม่จำกัดเฉพาะ
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>(1) ธนาคาร และสถาบันทางการเงิน </div>
                            <div>(2) ผู้ให้บริการด้านโลจิสติกส์และการขนส่ง</div>
                            <div>
                              (3) บริษัทที่ให้บริการด้านการตลาด สื่อโฆษณา
                              การออกแบบ การสร้างสรรค์ และการสื่อสาร
                            </div>
                            <div>(4) บริษัทที่ให้บริการด้านการจัดงาน </div>
                            <div>
                              (5) ผู้ให้บริการด้านโทรคมนาคมและการสื่อสาร
                            </div>
                            <div>(6) ผู้ให้บริการด้านธุรการจากภายนอก</div>
                            <div>
                              (7)
                              ผู้ให้บริการด้านการจัดเก็บข้อมูลและบริการคลาวด์{" "}
                            </div>
                            <div>(8) บริษัทประกัน</div>
                            <div>(9) ผู้ให้บริการด้านการบริหารความเสี่ยง</div>
                            <div>(10) บริษัทนำเที่ยว </div>
                            <div>(11) ผู้ให้บริการด้านการปรับปรุงอาคาร</div>
                            <div>(12) ผู้ให้บริการออกบัตรของขวัญ และ/หรือ </div>
                            <div>
                              (13) ผู้ให้บริการด้านอินเทอร์เน็ต ซอฟต์แวร์
                              สื่อดิจิทัล
                              ผู้ให้บริการด้านเทคโนโลยีสารสนเทศและบริษัท
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.3) ผู้ให้บริการสนับสนุนด้านเทคโนโลยีสารสนเทศ
                            ในระหว่างการให้บริการต่างๆ ดังกล่าว
                            ผู้ให้บริการอาจจะต้องเข้าถึงข้อมูลส่วนบุคคลของท่าน
                            อย่างไรก็ตาม
                            บริษัทฯจะให้ข้อมูลส่วนบุคคลแก่ผู้ให้บริการของบริษัทฯ
                            เพียงเท่าที่จำเป็นสำหรับการให้บริการดังกล่าวเท่านั้น
                            และจะขอให้ผู้ให้บริการไม่ใช้ข้อมูลของท่านเพื่อวัตถุประสงค์อื่นแต่อย่างใด
                            บริษัทฯ รับรองว่าผู้ให้บริการของบริษัทฯ
                            จะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลตามที่กฎหมายระบุไว้
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.4) พันธมิตรทางธุรกิจของบริษัทฯ บริษัทฯ
                            อาจโอนข้อมูลส่วนบุคคลของท่านให้แก่พันธมิตรทางธุรกิจของบริษัทฯ
                            บริษัทฯ
                            อาจมีการดำเนินธุรกิจร่วมกับพันธมิตรทางธุรกิจของบริษัทฯ
                            (เช่น ผู้เช่าร้านค้า
                            พันธมิตรทางธุรกิจเพื่อการจัดโปรแกรมการสะสมคะแนน
                            พันธมิตรทางธุรกิจบัตรเครดิต) ซึ่งบริษัทฯ
                            อาจเสนอผลิตภัณฑ์หรือบริการซึ่งมีร่วมกัน
                            หรืออาจเสนอผลิตภัณฑ์หรือบริการของพันธมิตรทางธุรกิจเอง
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.5) เว็บไซต์ต่างๆ ในสื่อสังคมออนไลน์ บริษัทฯ
                            อาจมีสื่อโฆษณาซึ่งเชื่อมต่อไปยังเว็บไซต์อื่นๆ
                            แอปพลิเคชันบนโทรศัพท์มือถือ ช่องทางสื่อสังคมออนไลน์
                            ช่องทางการสื่อสารทางออนไลน์ ซึ่งแพลตฟอร์มต่างๆ
                            ดังกล่าวอาจมีข้อกำหนดในการใช้งานหรือนโยบายเกี่ยวกับการใช้งาน
                            และนโยบายความเป็นส่วนตัวซึ่งแตกต่างไปจากนโยบายความเป็นส่วนตัวและข้อกำหนดในการใช้งานของบริษัทฯ
                            บริษัทฯ
                            ขอแนะนำให้ท่านทบทวนข้อกำหนดในการใช้งานและนโยบายความเป็นส่วนตัวบนแพลตฟอร์มข้างต้นด้วยตัวเอง
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.6) บุคคลภายนอกตามที่กฎหมายกำหนด ในบางกรณี บริษัทฯ
                            อาจจำเป็นที่จะต้องเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามกฎหมาย
                            หรือกฎข้อบังคับ ซึ่งรวมถึง
                            การปฏิบัติตามหน่วยงานที่บังคับใช้กฎหมาย ศาล
                            ผู้ดูแลควบคุม หน่วยงานรัฐ หรือบุคคลภายนอกอื่นๆ
                            ในกรณีที่บริษัทฯ
                            เชื่อว่าจำเป็นจะต้องปฏิบัติตามหน้าที่ตามกฎหมายหรือกฎข้อบังคับทางกฎหมาย
                            หรือเพื่อการปกป้องสิทธิของบริษัทฯ สิทธิของบุคคลอื่น
                            หรือเพื่อความปลอดภัยของบุคคล หรือเพื่อตรวจสอบ
                            ป้องกัน หรือจัดการเกี่ยวกับปัญหาการทุจริต
                            หรือด้านความมั่นคงหรือความปลอดภัย
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.7) ที่ปรึกษามืออาชีพด้านต่างๆ เช่น
                            ผู้ให้คำปรึกษาด้านกฎหมาย ผู้สอบบัญชี
                            และผู้ให้คำปรึกษาด้านอื่นซึ่งข้องเกี่ยวกับการดำเนินงานทางธุรกิจ
                            และ การพิพาทหรือเรียกร้องทางกฎหมาย
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.8) ผู้รับโอนสิทธิและ/หรือหน้าที่
                            บุคคลภายนอกในฐานะผู้รับโอนสิทธิและ/หรือหน้าที่
                            ในกรณีมีการปรับโครงสร้างองค์กร การควบรวมกิจการ
                            การโอนกิจการไม่ว่าจะบางส่วน หรือทั้งหมด
                            ผู้รับโอนสิทธิและ/หรือหน้าที่ของบริษัทฯจะปฏิบัติตามนโยบายความเป็นส่วนตัวฉบับนี้เพื่อเป็นการเคารพต่อข้อมูลส่วนบุคคลของท่าน
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "0px 10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            marginTop: 10,
                          }}
                        >
                          <div>
                            3.9) บุคคลภายนอกอื่นๆ บริษัทฯ
                            อาจต้องเปิดเผยข้อมูลส่วนบุคคลภายใต้ฐานทางกฎหมายตามวัตถุประสงค์ที่ระบุไว้ในนโยบายความเป็นส่วนตัวฉบับนี้ให้แก่บุคคลภายนอกอื่นๆ
                            เช่น บุคคลทั่วไป
                            ผู้ร้องเรียนหรือบุคคลภายนอกที่ร้องขอดูข้อมูลจากกล้องโทรทัศน์วงจรปิด
                            เป็นต้น แล้วแต่กรณี
                          </div>
                        </div>
                      </div>
                      <div>
                        4. การโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ บริษัทฯ
                        อาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกหรือเซิร์ฟเวอร์ที่อยู่ในต่างประเทศซึ่งประเทศปลายทางอาจมี
                        หรืออาจไม่มีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เท่าเทียมกัน
                        ทั้งนี้ บริษัทฯ จะดำเนินการตามขั้นตอนและมาตรการต่างๆ
                        เพื่อทำให้มั่นใจว่าข้อมูลส่วนบุคคลของท่านจะถูกโอนอย่างปลอดภัยและบุคคลที่รับโอนข้อมูลนั้นมีระดับการคุ้มครองข้อมูลส่วนบุคคลที่เหมาะสมหรือกรณีอื่นๆ
                        ตามที่กฎหมายกำหนด และบริษัทฯ
                        จะขอความยินยอมจากท่านเพื่อการโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศหากจำเป็นต้องปฏิบัติตามที่กฎหมายกำหนด
                      </div>
                      <div>
                        5. ระยะเวลาในการที่บริษัทฯเก็บข้อมูลส่วนบุคคลของท่าน
                        บริษัทฯ
                        จะเก็บรักษาข้อมูลส่วนบุคคลของท่านในระยะเวลาเท่าที่จำเป็นอย่างสมเหตุสมผล
                        เพื่อให้บรรลุตามวัตถุประสงค์ที่บริษัทฯได้รับข้อมูลส่วนบุคคลนั้นมา
                        และเพื่อปฏิบัติตามภาระหน้าที่ทางกฎหมายและกฎข้อบังคับต่างๆ
                        อย่างไรก็ตาม
                        บริษัทฯอาจเก็บข้อมูลส่วนบุคคลของท่านนานขึ้นหากจำเป็นตามกฎหมายที่ใช้บังคับ
                      </div>
                      <div>
                        6. วิธีการใช้คุกกี้ และไฟล์แคช (cache file)
                        เมื่อท่านเข้าเยี่ยมเว็บไซต์และแอปพลิเคชัน บริษัทฯ
                        จะทำการติดตาม เก็บ และบันทึกข้อมูลส่วนบุคคลบางประการ
                        โดยการใช้คุกกี้หรือเทคโนโลยีเพื่อติตดามอื่นๆ
                        สำหรับแอปพลิเคชันนั้น
                        คุกกี้จะถูกใช้ต่อเมื่อท่านลงชื่อเข้าใช้บัญชีบนแอปพลิเคชัน
                        โดยตัวคุกกี้จะทำการจดจำท่านไว้
                        เพื่อให้ไม่ต้องกรอกชื่อผู้ใช้และรหัสทุกครั้งที่จะเข้าใช้แอปพลิเคชัน
                        อย่างไรก็ตาม คุกกี้จะหยุดทำงานทันทีเมื่อท่านออกจากระบบ
                        และในกรณีที่บริษัทฯ ไม่มีอำนาจควบคุมตัวคุกกี้ บริษัทฯ
                        จะไม่มีการเก็บข้อมูลจากคุกกี้หรือการเข้าถึงคุกกี้
                        บริษัทฯ จะใช้ข้อมูลแคชเพื่อการบันทึกข้อมูลของท่าน
                        ในกรณีที่ท่านใช้เครื่องมืออื่นเพื่อต่อไปยังเว็บไซต์หรือแอปพลิเคชันของบริษัทฯ
                        ข้อมูลของท่านอาจถูกเก็บและบันทึกไว้ในรูปแบบไฟล์แคช
                        (cache file) หรือ
                        ส่วนข้อมูลของท่านอาจถูกคัดลอกบนคอมพิวเตอร์หรือโทรศัพท์มือถือสำหรับการใช้ในคราวถัดไป
                        ในกรณีที่บริษัทฯ
                        ไม่มีอำนาจควบคุมข้อมูลหรือการเข้าถึงไฟล์แคช
                      </div>
                      <div>
                        7. สิทธิของเจ้าของข้อมูลส่วนบุคคล
                        ภายใต้บทบัญญัติแห่งกฎหมายและข้อยกเว้นตามกฎหมายที่เกี่ยวข้อง
                        ท่านอาจมีสิทธิตามที่ระบุไว้ดังต่อไปนี้
                        สิทธิในการเข้าถึง:
                        ท่านอาจมีสิทธิในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลที่บริษัทฯ
                        เก็บรวบรวม ใช้และ/หรือเปิดเผยเกี่ยวกับท่าน ทั้งนี้
                        เพื่อความเป็นส่วนตัวและความปลอดภัยของท่าน บริษัทฯ
                        อาจขอให้ท่านพิสูจน์ตัวตนของท่านก่อนจะให้ข้อมูลตามที่ท่านขอ
                        สิทธิในการแก้ไขข้อมูล:
                        ท่านอาจมีสิทธิขอให้มีการดำเนินการแก้ไขข้อมูลส่วนบุคคลที่ไม่ครบถ้วน
                        ไม่แม่นยำ สามารถทำให้เข้าใจผิด หรือไม่เป็นปัจจุบัน
                        ซึ่งบริษัทฯ ได้เก็บรวบรวม
                        ใช้และ/หรือเปิดเผยเกี่ยวกับท่าน สิทธิในการโอนย้ายข้อมูล:
                        ท่านอาจมีสิทธิขอรับข้อมูลส่วนบุคคลที่บริษัทฯ
                        มีเกี่ยวกับท่านในรูปแบบที่มีการจัดระเบียบแล้วและสามารถอ่านได้ในรูปแบบอิเล็กทรอนิกส์
                        และเพื่อส่งหรือโอนข้อมูลดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น
                        โดยต้องเป็น (ก) ข้อมูลส่วนบุคคลที่ท่านได้ให้กับบริษัทฯ
                        และ (ข) กรณีที่บริษัทฯ
                        ได้รับความยินยอมจากท่านในการเก็บรวบรวม ใช้
                        และ/หรือเปิดเผยหรือเพื่อปฏิบัติตามสัญญาที่บริษัทฯ
                        มีกับท่าน สิทธิในการคัดค้าน:
                        ท่านอาจมีสิทธิคัดค้านการเก็บรวบรวม
                        ใช้และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน เช่น
                        การคัดค้านการตลาดแบบตรง สิทธิในการระงับการใช้ข้อมูล:
                        ท่านอาจมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลของท่านในบางกรณี
                        สิทธิในการถอนความยินยอม:
                        สำหรับวัตถุประสงค์ที่ท่านได้ให้ความยินยอมให้บริษัทฯ
                        เก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
                        ท่านมีสิทธิที่จะถอนความยินยอมของท่าน ณ เวลาใด ก็ได้
                        สิทธิในการลบข้อมูล: ท่านอาจมีสิทธิขอให้บริษัทฯ
                        ดำเนินการลบ หรือทำให้ข้อมูลส่วนบุคคลของท่านที่บริษัทฯ
                        เก็บรวบรวม ใช้ และ/หรือเปิดเผย
                        เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล
                        เว้นเสียแต่ว่า การเก็บรักษาข้อมูลดังกล่าวของบริษัทฯ
                        นั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย
                        หรือเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย เพื่อการใช้
                        หรือการปกป้องสิทธิเรียกร้องตามกฎหมาย
                        สิทธิในการร้องเรียน:
                        ท่านอาจมีสิทธิยื่นเรื่องร้องเรียนไปยังหน่วยงานที่มีอำนาจในกรณีที่ท่านเชื่อว่าการเก็บรวบรวม
                        ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลของบริษัทฯ
                        นั้นไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่บังคับใช้
                      </div>
                      <div>
                        8. มาตรการรักษาความมั่นคงปลอดภัย บริษัทฯ
                        ได้จัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลที่เหมาะสม
                        ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ
                        มาตรการป้องกันด้านเทคนิค
                        และมาตรการป้องกันทางกายภาพในเรื่องการเข้าถึงหรือควบคุมการเข้าถึงข้อมูลส่วนบุคคล
                        เพื่อธำรงไว้ซึ่งความลับ ความถูกต้องครบถ้วน
                        และสภาพความพร้อมใช้งานของข้อมูลส่วนบุคคล
                        เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข
                        หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ
                        ทั้งนี้ เป็นไปตามที่กฎหมายที่ใช้บังคับกำหนด บริษัทฯ
                        ได้จัดให้มีมาตรการควบคุมการเข้าถึงข้อมูลส่วนบุคคลและการใช้งานอุปกรณ์สำหรับจัดเก็บและประมวลผลข้อมูลส่วนบุคคลที่ปลอดภัยและเหมาะสมกับการเก็บรวบรวม
                        ใช้ และเปิดเผยข้อมูลส่วนบุคคล รวมทั้งบริษัทฯ
                        ยังได้วางมาตรการจำกัดการเข้าถึงข้อมูลส่วนบุคคล
                        และการใช้งานอุปกรณ์สำหรับจัดเก็บและประมวลผลข้อมูลส่วนบุคคล
                        โดยกำหนดสิทธิการเข้าถึงข้อมูลของผู้ใช้งาน
                        สิทธิในการอนุญาตให้พนักงานที่ได้รับมอบหมายให้เข้าถึงข้อมูล
                        และหน้าที่ความรับผิดชอบของผู้ใช้งาน
                        เพื่อป้องกันการเข้าถึงข้อมูลส่วนบุคคล การเปิดเผย
                        การล่วงรู้ หรือการลักลอบทำสำเนาข้อมูลส่วนบุคคล
                        หรือการลักขโมยอุปกรณ์จัดเก็บหรือประมวลผลข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาต
                        นอกจากนี้ บริษัทฯ
                        ยังได้วางมาตรการสำหรับการตรวจสอบย้อนหลังเกี่ยวกับการเข้าถึง
                        เปลี่ยนแปลง ลบ หรือถ่ายโอนข้อมูลส่วนบุคคล
                        ให้สอดคล้องเหมาะสมกับวิธีการและสื่อที่ใช้ในการเก็บรวบรวม
                        ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
                      </div>
                      <div>
                        9. รายละเอียดการติดต่อบริษัทฯ
                        หากท่านมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน
                        หรือหากท่านมีข้อสงสัยเกี่ยวกับข้อมูลส่วนบุคคลของท่านภายใต้นโยบายความเป็นส่วนตัวฉบับนี้
                        โปรดติดต่อบริษัทฯ
                        หรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของบริษัทฯ ได้ที่
                      </div>
                      <b>
                        บริษัท กอล์ฟาโล่ จำกัด 571 อาคารอาร์เอสยูทาวเวอร์ ชั้น9
                        ยูนิต903 ซอยสุขุมวิท31 ถนนสุขุมวิท แขวงคลองตันเหนือ
                        เขตวัฒนา กรุงเทพมหานคร 10110 โทร.02-117-9538 email:
                        info@golfalo.com
                      </b>{" "}
                    </div>
                  </div>
                  <Divider style={{ margin: "10px 0px" }} />
                </div>
                <div style={{ marginTop: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    onClick={() => {
                      setTermAndConditionCollapse((prev) => !prev);
                    }}
                  >
                    <h3 style={{ margin: 0 }}>Terms & Conditions</h3>
                    {termAndConditionCollapse ? (
                      <CaretUpOutlined />
                    ) : (
                      <CaretDownOutlined />
                    )}
                  </div>
                  <div
                    className={`privacy-container ${
                      termAndConditionCollapse ? "collapse" : ""
                    }`}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                        padding: "0px 10px",
                        marginTop: 10,
                      }}
                    >
                      <div>
                        เงื่อนไขและข้อตกลงการใช้บริการแพลตฟอร์มสำหรับผู้ว่าจ้าง
                        (Platform Terms & Conditions for Employer) ของบริษัท
                        กอล์ฟาโล่ จำกัด
                      </div>
                      <h3 style={{ marginBottom: -10 }}>นิยาม</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        “แพลตฟอร์ม” หมายถึง แอปพลิเคชั่น หรือ LINE Official
                        CADDIE DEE (@caddiedee) ของบริษัทฯ
                        เป็นช่องทางและเป็นพื้นที่กลางที่เปิดให้ผู้ใช้งานสามารถสร้าง
                        และซื้องานหรือบริการในรูปแบบของการชำระเงินตามมูลค่าที่ถูกกำหนดเอาไว้ของงานหรือบริการดังกล่าว
                        “งาน” หมายถึง ผลงาน และ/หรือการบริการต่าง ๆ
                        ที่ผู้ว่าจ้างว่าจ้างและแคดดี้ได้ตกลงกันผ่านแพลตฟอร์ม
                        “บริษัทฯ” หมายถึง บริษัท กอล์ฟาโล่ จำกัด “Caddie Dee”
                        หมายถึง แพลตฟอร์มของบริษัทฯ
                        สำหรับผู้ใช้งานเพื่อรับการบริการที่ให้บริการโดยผู้ให้บริการบุคคลที่สาม
                        หน้าที่ของบริษัทฯ
                        คือเป็นตัวกลางสื่อสารระหว่างผู้ว่าจ้างและแคดดี้
                        “ผู้ใช้งาน” หมายถึง ผู้ว่าจ้างและแคดดี้ “ผู้ว่าจ้าง”
                        หรือ “ท่าน” หมายถึง บุคคลที่ใช้บริการแพลตฟอร์ม
                        โดยตกลงจ้างงานและรับมอบงานผ่านแพลตฟอร์ม “แคดดี้” หมายถึง
                        บุคคลที่ใช้บริการแพลตฟอร์ม
                        โดยตกลงรับทำงานและส่งมอบงานผ่านแพลตฟอร์ม “งานที่นำเสนอ”
                        หมายถึง
                        หน้าหนึ่งบนแพลตฟอร์มที่แคดดี้เสนองานหรือประวัติการทำงานของแคดดี้เพื่อให้ผู้ว่าจ้างตรวจสอบคุณภาพงานหรือประวัติการทำงานก่อนการจอง
                        “พูดคุย” หมายถึง หน้าหนึ่งบนแพลตฟอร์ม
                        สำหรับใช้เป็นช่องทางการสื่อสารระหว่างผู้ว่าจ้างกับแคดดี้ที่เกี่ยวข้องกับงานที่ผู้ว่าจ้างได้ตกลงว่าจ้างแคดดี้
                        ซึ่งอาจใช้งานได้ด้วยวิธีการสื่อสารผ่านข้อความ
                        ข้อความเสียง ภาพ หรือวิธีการอื่นใด “จ้างงาน” หมายถึง
                        หน้าหนึ่งบนแพลตฟอร์มที่ผู้ว่าจ้างสร้างขึ้นหลังจากยืนยันจ้างงานตามที่แคดดี้นำเสนอค่าบริการในหน้างานที่นำเสนอ
                        เมื่อการจองแล้ว
                        ผู้ใช้งานย่อมสามารถพูดคุยกันถึงรายละเอียดของงานต่อไปได้
                        “ค่าบริการ” หมายถึง
                        ค่าบริการที่ผู้ว่าจ้างตกลงชำระให้แคดดี้
                        เพื่อตอบแทนการบริการ โดยบริษัทฯ
                        จะดูแลค่าบริการไว้จนกว่าแคดดี้จะได้ส่งมอบงานแก่ผู้ว่าจ้าง
                        ทั้งนี้ ค่าบริการดังกล่าวจะไม่รวมภาษีหัก ณ ที่จ่าย
                        “ค่าธรรมเนียมการใช้” หมายถึง ค่าธรรมเนียมที่บริษัทฯ
                        เรียกเก็บจากทางผู้ใช้งาน เพื่อตอบแทนการใช้
                        บริการแพลตฟอร์มสำหรับการรับงานผ่านแพลตฟอร์ม
                        “ค่าธรรมเนียมการชำระเงิน” หมายถึง ค่าธรรมเนียมที่บริษัทฯ
                        เรียกเก็บจากผู้ว่าจ้าง
                        เพื่อตอบแทนการว่าจ้างงานผ่านแพลตฟอร์ม “ข้อมูลส่วนบุคคล”
                        หมายถึง
                        ข้อมูลของบุคคลธรรมดาซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้
                        ไม่ว่าทางตรงหรือทางอ้อม
                        แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม
                      </div>
                      <h3 style={{ marginBottom: -10 }}>ทั่วไป</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        เงื่อนไขและข้อตกลงการใช้บริการแพลตฟอร์มสำหรับผู้ว่าจ้าง
                        (Platform Terms & Conditions for Golfer)
                        ฉบับให้มีผลใช้มีผลใช้บังคับตั้งแต่วันที่ 1 พฤษภาคม 2568
                        เป็นต้นไปจนกว่าจะมีการประกาศแก้ไขเพิ่มเติม
                        เมื่อมีการแก้ไขเพิ่มเติม บริษัทฯ
                        จะประกาศข้อตกลงการใช้งานผ่านแพลตฟอร์มและแจ้งเตือนเพื่อให้ผู้ใช้งานรับทราบและอ่านข้อตกลงการใช้งานเพื่อยอมรับข้อตกลงการใช้งานใหม่ผ่านแพลตฟอร์ม
                        ในกรณีที่ท่านไม่ยอมรับข้อตกลงการใช้งาน
                        ท่านจะไม่สามารถใช้บริการแพลตฟอร์มได้
                        ข้อตกลงการใช้งานจะเป็นข้อตกลงการใช้งานระหว่างท่านกับบริษัทฯ
                        ซึ่งกำหนดสิทธิ หน้าที่
                        และความรับผิดชอบที่แต่ละฝ่ายพึงมีตลอดระยะเวลาที่ใช้บริการแพลตฟอร์ม
                        เมื่อท่านยอมรับข้อตกลงการใช้งานของบริษัทฯ แล้ว บริษัทฯ
                        จะถือว่าท่านยอมรับที่จะปฏิบัติตามข้อตกลงการใช้งาน
                        รวมถึงยอมรับนโยบายความเป็นส่วนตัวที่บริษัทฯ กำหนด
                        ทั้งนี้ ท่านรับรองว่าจะไม่ดำเนินการใด ๆ
                        อันเป็นการฝ่าฝืนกฎหมายที่ขัดต่อความสงบเรียบร้อย
                        หรือศีลธรรมอันดีของประชาชนผ่านแพลตฟอร์มโดยเด็ดขาด
                        ในกรณีที่บริษัทฯ ตรวจพบว่าท่านกระทำการใด ๆ
                        ที่ฝ่าฝืนข้อตกลงการใช้งาน นโยบายความเป็นส่วนตัว
                        หรือฝ่าฝืนคำรับรองใด ๆ บริษัทฯ
                        ขอสงวนสิทธิในการให้ท่านเข้าถึงการใช้บริการแพลตฟอร์ม
                        ทั้งนี้ ดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        คำรับรองของผู้ว่าจ้าง
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        ผู้ว่าจ้างตกลงและรับรองที่จะไม่กระทำการใด ๆ
                        อันมีพฤติการณ์หรือลักษณะเป็นการหลอกลวง เพื่อหวังข้อมูล
                        (ฟิชชิ่ง) หรือก่อให้เกิดความเดือดร้อนรำคาญแก่แคดดี้
                        (สแปม) ผู้ว่าจ้างตกลงและรับรองที่จะไม่กระทำการใด ๆ
                        อันเป็นสิ่งผิดกฎหมาย
                        หรือขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชนผ่านแพลตฟอร์ม
                        ผู้ว่าจ้างตกลงและรับรองว่าจะติดต่อกับแคดดี้ผ่านการพูดคุยของแพลตฟอร์มเพื่อขอข้อมูลเพิ่มเติมหรือสอบถามรายละเอียดต่าง
                        ๆ ที่เกี่ยวข้องกับงาน ทั้งนี้
                        โดยผู้ว่าจ้างตกลงและรับรองที่จะไม่แสดงข้อมูลส่วนบุคคลของตน
                        อาทิ ชื่อ สกุล เบอร์โทรศัพท์ จดหมายอิเล็กทรอนิกส์
                        ที่อยู่ ชื่อบัญชีผู้ใช้งานในช่องทางอื่น ๆ
                        นอกเหนือจากผ่านแพลตฟอร์ม ซึ่งรวมถึงแต่ไม่จำกัดเพียง
                        LINE, Whatsapp, WeChat, Facebook ฯลฯ
                        หรือข้อมูลส่วนบุคคลอื่นใด ทั้งนี้
                        เพื่อการปฏิบัติตามข้อตกลงการใช้งานฉบับนี้และเพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านตามนโยบายความเป็นส่วนตัว
                        ในกรณีที่ผู้ว่าจ้างได้รับการติดต่อจากแคดดี้ในช่องทางอื่นนอกเหนือจากพูดคุยของแพลตฟอร์ม
                        ผู้ว่าจ้างตกลงแจ้งเหตุละเมิดการใช้งานที่ฝ่าฝืนข้อตกลงการใช้งานให้บริษัทฯ
                        ทราบโดยทันทีแต่ต้องไม่เกินกว่า 3 วัน
                        นับแต่วันที่ได้รับการติดต่อดังกล่าว
                        ผู้ว่าจ้างตกลงและรับรองที่จะไม่ใช้สิทธิในฐานะผู้ว่าจ้างหรือฐานะอื่นใด
                        เพื่อชักชวนแคดดี้ให้ส่งมอบผลงาน และ/หรือบริการ ติดต่อ
                        หรือกระทำการอื่นใดที่เกี่ยวข้องกับงาน
                        หรืองานที่อาจเกิดขึ้นในอนาคตนอกแพลตฟอร์ม ทั้งนี้
                        ไม่ว่าเพื่อผลประโยชน์แก่ผู้ว่าจ้างหรือบุคคลอื่น
                        เช่นกรณีการมีเจตนาชำระเงินผ่านระบบเพียงบางส่วน
                        การใช้บริการโดยตรง
                        หรือเพื่อสร้างข้อมูลหรือผลงานอันเป็นเท็จ เป็นต้น
                        ในกรณีที่บริษัทฯ พบเห็นว่าผู้ว่าจ้างกระทำการใด ๆ
                        อันเป็นการฝ่าฝืนคำรับรอง บริษัทฯ
                        มีสิทธิใช้ดุลพินิจระงับการใช้งานบัญชีผู้ใช้งาน
                        ลบบัญชีผู้ใช้งาน ขึ้นทะเบียนแบล็คลิสต์
                        หรือกระทำการอื่นใดตามที่บริษัทฯ เห็นสมควร
                        ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        การสมัครใช้บริการแพลตฟอร์ม
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        แคดดี้ที่สมัครใช้บริการแพลตฟอร์มจะต้องเป็นบุคคลธรรมดาที่มีอายุครบ
                        15 ปีบริบูรณ์ขึ้นไปเท่านั้น
                        ผู้ว่าจ้างที่สมัครใช้บริการแพลตฟอร์มอาจเป็นบุคคลธรรมดาหรือนิติบุคคลก็ได้
                        ในกรณีที่เป็นบุคคลธรรมดา
                        ผู้ใช้บริการจะต้องเป็นบุคคลธรรมดาที่มีอายุครบ 15
                        ปีบริบูรณ์ขึ้นไปเท่านั้น ในกรณีที่เป็นนิติบุคคล
                        ผู้สมัครใช้บริการแพลตฟอร์มต้องเป็นผู้แทนนิติบุคคลหรือผู้รับมอบอำนาจจากนิติบุคคลนั้น
                        ๆ
                        การใช้บริการแพลตฟอร์มถือเป็นการแสดงเจตนาและยืนยันว่าท่านมีคุณสมบัติตามเงื่อนไขที่กำหนดและยอมรับข้อตกลงการใช้งานด้วยตนเอง
                        อย่างไรก็ตาม หากบริษัทฯ
                        พบว่าท่านมีคุณสมบัติไม่ครบถ้วนตามที่กำหนด บริษัทฯ
                        มีสิทธิที่จะระงับการใช้งานบัญชีผู้ใช้งานของท่าน
                        รวมถึงการจ้างงานที่ถูกยกเลิกหรือยุติด้วยสาเหตุที่ผู้ใช้บริการเป็นผู้ไร้ความสามารถตามกฎหมาย
                        (อาทิ ผู้เยาว์ ผู้ไร้ความสามารถ
                        หรือผู้เสมือนไร้ความสามารถ เป็นต้น)
                        ผู้ใช้งานต้องดำเนินการสมัครสมาชิกตามขั้นตอนที่บริษัทฯ
                        กำหนด
                        ผู้ใช้งานจึงจะสามารถเป็นผู้ว่าจ้างทำการจ้างงานหรือเป็นแคดดี้
                        บนแพลตฟอร์มได้แล้วแต่กรณี ผู้ใช้งานยืนยันว่าข้อมูลต่าง ๆ
                        ที่ผู้ใช้งานใช้ในการสมัครสมาชิกเป็นข้อมูลที่ถูกต้องครบถ้วน
                        ไม่เป็นเท็จ ไม่ทำให้ผู้อื่นสำคัญผิด
                        หรือไม่ขาดข้อมูลในสาระสำคัญที่ควรต้องแจ้งให้บริษัทฯ ทราบ
                        หากบริษัทฯ พบว่าข้อมูลไม่ถูกต้องหรือไม่ครบถ้วน
                        ไม่ว่าในระหว่างการสมัครหรือหลังจากที่การสมัครเสร็จสมบูรณ์แล้ว
                        บริษัทฯ มีสิทธิระงับหรือยกเลิกบัญชีผู้ใช้งาน
                        รวมถึงเรียกร้องค่าเสียหายที่เกิดขึ้นจากผู้ใช้งานได้
                      </div>
                      <h3 style={{ marginBottom: -10 }}>การจ้างงาน</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        แคดดี้สามารถนำเสนอรายละเอียดของงานผ่านช่องทางบนแพลตฟอร์มได้
                        โดยแคดดี้ตกลงและรับรองว่ารายละเอียดงานนั้นจะเกี่ยวข้องกับงาน
                        เพื่อให้ผู้ว่าจ้างพิจารณาและจ้างงานต่อไปในอนาคต
                        แคดดี้รับรองและตกลงว่าข้อความใด ๆ
                        ที่เผยแพร่ลงในงานที่นำเสนอนั้นมีความเหมาะสม
                        ชอบด้วยกฎหมาย และไม่เป็นการละเมิดสิทธิของบุคคลอื่น
                        ผู้ว่าจ้างอาจติดต่อหรือสอบถามรายละเอียดเกี่ยวกับงานกับแคดดี้ได้ผ่านการพูดคุย
                        เมื่อผู้ว่าจ้างได้รับข้อมูลเกี่ยวกับรายละเอียดงานแล้ว
                        แคดดี้มีสิทธิตรวจสอบขอบเขตของงานเพื่อส่งมอบหรือให้บริการตามสัญญา
                        ในกรณีที่แคดดี้พิจารณาแล้วไม่ประสงค์เข้าร่วมงานดังกล่าว
                        แคดดี้มีสิทธิปฏิเสธการรับงานจากผู้ว่าจ้างได้
                        โดยแคดดี้ตกลงจะแจ้งเหตุผลของการปฏิเสธร่วมงานกับผู้ว่าจ้างดังกล่าวโดยไม่ชักช้า
                        เมื่อผู้ว่าจ้างมีการจองบนประกาศงานแล้ว
                        ให้ถือว่าผู้ว่าจ้างยอมรับเงื่อนไขและรายละเอียดเกี่ยวกับการจ้างงานรวมทั้งขั้นตอนกำหนดระยะเวลาการเริ่มและส่งงาน
                        และรายละเอียดอื่น ๆ (ถ้ามี) ทั้งนี้
                        ตามที่แคดดี้กำหนดไว้ในการจองหรือเงื่อนไขระยะเวลาการให้บริการ
                        อนึ่ง
                        กำหนดระยะเวลาการเริ่มและส่งงานจะเริ่มนับแต่วันที่ผู้ว่าจ้างได้ชำระเงินค่าบริการผ่านแพลตฟอร์ม
                        ตามระยะเวลาการจองที่ระบุในแพลตฟอร์ม
                        ผู้ว่าจ้างตกลงชำระค่าบริการภายในระยะเวลาที่กำหนดในแพลตฟอร์ม
                        ในกรณีที่ผู้ว่าจ้างไม่ชำระเงินภายในระยะเวลาที่กำหนด
                        แพลตฟอร์มจะทำการยกเลิกการจ้างงานที่เกี่ยวข้องโดยอัตโนมัติทันที
                        ทั้งนี้
                        ระบบจะมีการแจ้งเตือนกำหนดวันสุดท้ายของการชำระค่าบริการให้ผู้ว่าจ้างได้รับทราบ
                        เมื่อผู้ว่าจ้างได้ชำระค่าบริการในแพลตฟอร์มเสร็จสมบูรณ์
                        ผู้ว่าจ้างจะได้รับหมายเลขการจ้างงานที่ว่าจ้างและแคดดี้ตกลงทำงานที่ได้รับว่าจ้าง
                        เพื่อส่งมอบผลงาน และ/หรือบริการภายในระยะเวลาที่กำหนดไว้
                        ตลอดระยะเวลาทำงาน
                        ผู้ใช้งานสามารถติดต่อกันโดยผ่านการพูดคุยของแพลตฟอร์ม
                        เพื่อขอข้อมูลเพิ่มเติมหรือสอบถามรายละเอียดต่าง ๆ
                        ที่เกี่ยวข้องกับงาน ทั้งนี้ เพื่อให้ผลงาน และ/หรือ
                        บริการเป็นไปตามวัตถุประสงค์ของงานที่ว่าจ้าง อนึ่ง
                        ผู้ใช้งานตกลงและรับรองว่าจะไม่ดำเนินการแลกข้อมูลส่วนบุคคลหรือข้อมูลใด
                        ๆ
                        เพื่อติดต่อหรือส่งมอบงานในทางอื่นนอกเหนือจากพูดคุยที่บริษัทฯ
                        จัดเตรียมให้ไว้ เมื่อแคดดี้ทำงานที่จ้างสมบูรณ์แล้ว
                        แคดดี้จะแจ้งให้ผู้ว่าจ้างเพื่อพิจารณาอนุมัติ
                        และเมื่อผู้ว่าจ้างอนุมัติแล้ว
                        การจ้างงานจะถูกเปลี่ยนสถานะเป็นเสร็จสิ้นและผู้ว่าจ้างมีสิทธิประเมินผลงานดังกล่าว
                        หากผู้ว่าจ้างไม่อนุมัติ และ/หรือ ประเมินผลงานภายใน 1 วัน
                        นับแต่วันที่แคดดี้ได้ส่งมอบผลงาน และ/หรือบริการ
                        การจ้างงานจะถูกเปลี่ยนสถานะเป็นเสร็จสิ้นโดยอัตโนมัติและถือว่าการจ้างงานเสร็จสิ้นโดยสมบูรณ์
                        ในกรณีที่แคดดี้ไม่ส่งมอบผลงาน
                        และ/หรือบริการภายในระยะเวลาที่กำหนด
                        หรือส่งมอบผลงานภายในกำหนดแต่ไม่ถูกต้องครบถ้วน
                        ผู้ว่าจ้างมีสิทธิร้องเรียนงาน
                        และ/หรือประเมินผลงานของแคดดี้ได้
                        การจ้างงานที่ไม่มีการเคลื่อนไหวเกินกว่า 7 วัน
                        จะถือว่าถูกยกเลิกโดยความยินยอมของผู้ว่าจ้างและแคดดี้
                        โดยให้ถือว่าผู้ใช้งานตกลงและยินยอมให้ค่าบริการที่ผู้ว่าจ้างชำระแล้วนั้นเป็นค่าธรรมเนียมการใช้บริการแพลตฟอร์ม
                        และ/หรือ ค่าธรรมเนียมการชำระเงิน ทั้งนี้ บริษัทฯ
                        ขอสงวนสิทธิในการคิดค่าธรรมเนียมดังกล่าวโดยไม่ต้องแจ้งให้ผู้ใช้งานทราบล่วงหน้า
                      </div>
                      <h3 style={{ marginBottom: -10 }}>ติดต่อ</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          1. ผู้ใช้งานตกลงสื่อสารผ่านการพูดคุย
                          เพื่อให้แคดดี้ทราบถึงความต้องการในงานที่ผู้ว่าจ้างประสงค์ว่าจ้าง
                        </div>
                        <div>
                          2. ผู้ใช้งานตกลงและรับรองว่า ข้อความใด ๆ
                          ที่ใช้ในการติดต่อสื่อสารนั้น ต้องมีความเหมาะสม
                          ชอบด้วยกฎหมาย และไม่เป็นการละเมิดสิทธิของบุคคลอื่น
                        </div>
                        <div>
                          3. ผู้ใช้งานตกลงและรับรองว่าว่า จะไม่ดำเนินการใด ๆ
                          ซึ่งรวมถึง
                          การชักจูงหรือจูงใจให้มีการติดต่อเพื่อจ้างงานนอกแพลตฟอร์ม
                          การติดต่อสอบถามหรือส่งมอบงานเพิ่มเติมในช่องทางอื่นที่นอกเหนือจากแพลตฟอร์ม
                          หรือกระทำการอื่นใดอันมีลักษณะฝ่าฝืนข้อตกลงการใช้งานดังกล่าว
                          หากบริษัทฯ พบว่าผู้ใช้งานมีพฤติการณ์ใด ๆ
                          ที่เป็นการชักจูงหรือจูงใจให้นำไปสู่การติดต่อเพื่อจ้างงานนอกแพลตฟอร์ม
                          เช่น การจ่ายเงินมัดจำ การชำระเงินเพียงบางส่วน ฯลฯ
                          บริษัทฯ
                          จะถือว่าผู้ใช้งานได้กระทำการฝ่าฝืนข้อตกลงการใช้งาน
                          และบริษัทฯ มีสิทธิระงับหรือยกเลิกบัญชีผู้ใช้งาน
                          รวมถึงการใช้สิทธิเรียกร้องค่าเสียหายใดๆ
                          ที่เกิดขึ้นดังกล่าวจากผู้ใช้งานได้
                        </div>
                        <div>
                          4.
                          ข้อมูลส่วนบุคคลหรือข้อมูลอื่นใดที่ผู้ใช้งานสื่อสารผ่านการพูดคุยบนแพลตฟอร์มบริษัทฯ
                          ให้ถือว่าเป็นข้อมูลความลับของผู้ใช้งาน
                          ผู้รับข้อมูลไม่สามารถนำข้อมูลอันเป็นความลับดังกล่าวมาเปิดเผยได้
                          เว้นแต่จะได้รับความยินยอมเป็นหนังสือจากผู้ให้ข้อมูล
                          หรือเป็นข้อมูลทั่วไปที่สามารถเปิดเผยได้
                          หรือเป็นกรณีที่มีกฎหมายหรือการใช้อำนาจของหน่วยงานรัฐในการร้องขอหรือบังคับให้เปิดเผยข้อมูลดังกล่าว
                        </div>
                        <div>
                          5. บริษัทฯ
                          สนับสนุนให้ผู้ใช้งานมีการสื่อสารกันด้วยความสุภาพ
                          เพื่อป้องกันความเสี่ยงในการเกิดข้อพิพาทต่างๆ
                        </div>
                        <div>
                          6.
                          ผู้ว่าจ้างและแคดดี้สามารถสมัครเป็นสมาชิกแพลตฟอร์มได้โดยไม่มีค่าใช้จ่ายใดๆ
                        </div>
                        <div>
                          7. การชำระค่าบริการ
                          ผู้ว่าจ้างต้องทำรายการผ่านแพลตฟอร์ม โดยบริษัทฯ
                          จะดูแลค่าบริการไว้จนกว่าแคดดี้จะได้ส่งมอบงานแก่ผู้ว่าจ้าง
                          ทั้งนี้
                          เพื่อคุ้มครองผลประโยชน์และความปลอดภัยให้แก่ผู้ใช้งาน
                          และผู้ว่าจ้างสามารถตรวจสอบรายละเอียดการชำระเงินและค่าใช้จ่ายต่าง
                          ๆ ได้ที่ช่องทางการชำระเงินที่ทำรายการผ่านแพลตฟอร์ม
                        </div>
                        <div>
                          8. ค่าตอบแทนในการใช้งานแพลตฟอร์ม บริษัทฯ
                          จะเรียกเก็บค่าธรรมเนียมการใช้บริการแพลตฟอร์มจากผู้ว่าจ้าง
                          ในอัตราตามที่บริษัทฯ กำหนด
                          และค่าธรรมเนียมดังกล่าวจะถูกหักออกจากค่าบริการนอกเหนือจากค่าบริการที่แคดดี้พึงได้รับจากการให้บริการตามการจ้างงานในวันที่ส่งมอบงานโดยอัตโนมัติ
                          ทั้งนี้
                          ค่าธรรมเนียมดังกล่าวจะถูกหักออกจากบัญชีของผู้ว่าจ้างในวันที่มีการจ้างงานโดยอัตโนมัติ
                        </div>
                        <div>
                          9. แคดดี้จะต้องให้ข้อมูลบัญชีธนาคาร
                          ได้แก่หน้าสมุดบัญชีธนาคาร และอื่นๆที่เกี่ยวข้อง
                          บันทึกเข้าแพลตฟอร์ม เพื่อให้บริษัทฯ
                          สามารถโอนค่าบริการไปยังแคดดี้ได้ ทั้งนี้
                          หากแคดดี้รายใดไม่ให้ข้อมูลดังกล่าวภายใน 12 เดือน
                          นับจากวันที่ได้รับอนุมัติจากผู้ว่าจ้าง บริษัทฯ
                          จะดูแลค่าบริการไว้จนกว่าแคดดี้จะได้ให้ข้อมูลบัญชีธนาคารแก่บริษัทฯ
                          ในกรณีนี้บริษัทฯ
                          จะเรียกเก็บค่าธรรมเนียมการรักษาสถานภาพของบัญชีผู้ใช้งานในแพลตฟอร์มในอัตราเดือนละ
                          50 บาทจนกว่าแคดดี้จะได้ให้ข้อมูลบัญชีธนาคารแก่บริษัทฯ
                          เพื่อบันทึกเข้าแพลตฟอร์มครบถ้วน{" "}
                        </div>
                        <div>
                          10. ค่าบริการ ค่าธรรมเนียมการชำระเงิน
                          และค่าธรรมเนียมการใช้บริการแพลตฟอร์ม
                          ซึ่งผู้ว่าจ้างได้ชำระจากการใช้บริการแพลตฟอร์ม
                          จะไม่รวมภาษีหัก ณ ที่จ่าย
                          หรือภาษีหรือค่าธรรมเนียมอื่นใดที่ผู้ใช้บริการมีหน้าที่ต้องชำระตามกฎหมาย
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>การประเมินผลงาน</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          1. การประเมินผลงานของงานที่ผู้ว่าจ้างจะได้รับ
                          ย่อมมีความสำคัญต่อการพัฒนาแพลตฟอร์มตลอดจนการคัดเลือกแคดดี้ที่มีคุณสมบัติและศักยภาพในการพร้อมให้บริการแก่ผู้ว่าจ้างแต่ละราย
                          เพื่อป้องกันความผิดพลาดหรือไม่เป็นไปตามวัตถุประสงค์ในการใช้งานของระบบการประเมินผลงาน
                        </div>
                        <div>
                          2. ผู้ว่าจ้างที่จะมีสิทธิประเมินผลงาน
                          ต้องเป็นผู้ว่าจ้างที่ได้รับมอบผลงาน และ/หรือ
                          บริการแล้วเท่านั้น
                        </div>
                        <div>
                          3. การประเมินผลงานต้องดำเนินการภายใน 7 วัน
                          นับแต่วันที่ได้รับมอบงานแล้ว
                          โดยรายละเอียดการประเมินผลงานจะปรากฏอยู่ในช่องงานของฉัน
                          ซึ่งผู้ว่าจ้างต้องประเมินผลงานด้วยวิธีการให้คะแนนผลงานจากมากสุดไปถึงน้อยสุด
                          อย่างไรก็ดี
                          ผู้ว่าจ้างสามารถเลือกที่จะไม่บรรยายรายละเอียดของการประเมินผลงานได้
                        </div>
                        <div>
                          4.
                          การประเมินผลงานของแคดดี้จะถูกคำนวณขึ้นมาจากคะแนนประเมินผลงานที่ผู้ว่าจ้างได้ประเมินต่องานของแคดดี้หลังจากแคดดี้ได้ส่งมอบผลงาน
                          และ/หรือ บริการ แล้ว
                          โดยการประเมินผลงานจะอยู่บนพื้นฐานของความน่าเชื่อถือตามสภาพ
                          (“as is basis”)
                          และการให้บริการตามที่มีอยู่หรือเป็นอยู่ (“as
                          available”)
                          ซึ่งข้อความที่ปรากฏในแพลตฟอร์มนั้นไม่ถือเป็นการรับประกันหรือการรับรองคุณภาพ
                          ความถูกต้อง ความปลอดภัย ความน่าเชื่อถือ
                          หรือความพร้อมของแคดดี้แต่อย่างใด
                        </div>
                        <div>
                          5. การประเมินผลงานเป็นสิทธิของผู้ว่าจ้าง
                          ซึ่งจะไม่ถูกลบออกไม่ว่าด้วยเหตุผลใด ๆ
                          เว้นแต่เป็นการประเมินผลงานที่ละเมิดข้อตกลงในการใช้งาน
                          ทั้งนี้ บริษัทฯ
                          จะใช้ความพยายามอย่างถึงที่สุดในการสนับสนุนให้ผู้ว่าจ้างได้สื่อสารกับแคดดี้ถึงระดับความพึงพอใจของผลงานตลอดจนปัญหาที่ได้รับจากผลงาน
                          และ/หรือ บริการ
                          เพื่อให้แคดดี้ได้แก้ไขปรับปรุงงานให้ตรงและเหมาะสมตามที่ได้เสนอไว้กับผู้ว่าจ้าง
                          อนึ่ง บริษัทฯ ขอสงวนสิทธิดำเนินการใด ๆ
                          กับบัญชีผู้ใช้งานที่มีการใช้งานระบบการประเมินผลงานผิดวัตถุประสงค์
                          ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                        </div>
                        <div>
                          6.
                          ผู้ว่าจ้างและแคดดี้สามารถสมัครเป็นสมาชิกแพลตฟอร์มได้โดยไม่มีค่าใช้จ่ายใดๆ
                        </div>
                        <div>
                          6.
                          แคดดี้ไม่สามารถต่อรองการส่งมอบงานเพื่อให้ได้รับการประเมินผลงานที่ดีจากผู้ว่าจ้างได้
                          หากบริษัทฯ รับทราบการกระทำดังกล่าว บริษัทฯ
                          มีสิทธิดำเนินการใดๆ
                          กับบัญชีผู้ใช้งานที่มีการใช้งานระบบการประเมินผลงานผิดวัตถุประสงค์
                          ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        การเปลี่ยนแปลงสถานะและการยกเลิกจ้างงาน
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          1. เมื่อมีการจองการจ้างงานแล้ว
                          ตลอดระยะเวลาที่แคดดี้ยังไม่ส่งมอบผลงานและ/หรือบริการ
                          ผู้ใช้งานสามารถเปลี่ยนแปลงสถานะการจ้างงานหรือยกเลิกการจ้างงานได้ตลอดระยะเวลา
                          แต่ต้องไม่น้อยกว่า 24 ชั่วโมง
                          โดยผู้ใช้งานจะต้องแจ้งมายังบริษัทฯ
                          ตามช่องทางติดต่อของบริษัทฯ อย่างไรก็ตาม
                          แม้ว่าผู้ว่าจ้างจะได้ยื่นเปลี่ยนแปลงสถานะจ้างงานหรือยกเลิกจ้างงานแล้ว
                          บริษัทฯ
                          มีสิทธิใช้ดุลพินิจในการพิจารณาความเหมาะสมและ/หรือเหตุผล
                          เพื่ออนุมัติการเปลี่ยนแปลงสถานะหรือขอยกเลิกจ้างงานและการคืนเงินได้
                          ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด ทั้งนี้
                          อัตราค่าบริการที่ผู้ว่าจ้างจะได้รับคืนนั้นจะเป็นไปตามกระบวนการขอยกเลิกจ้างงานและการคืนเงินที่บริษัทฯ
                          กำหนด
                        </div>
                        <div>
                          2. เมื่อมีการยื่นขอยกเลิกจ้างงาน เจ้าหน้าที่ของบริษัทฯ
                          จะติดต่อกลับไปยังผู้ว่าจ้างตามข้อมูลการติดต่อที่ผู้ว่าจ้างได้ลงทะเบียนไว้เพื่อขอบัญชีธนาคารสำหรับการคืนค่าบริการ
                          ทั้งนี้ บริษัทฯ
                          ขอสงวนสิทธิในการคืนค่าธรรมเนียมการชำระเงินให้กับผู้ว่าจ้าง
                        </div>
                        <div>
                          3. บริษัทฯ
                          มีสิทธิแต่เพียงผู้เดียวในการพิจารณาสัดส่วนของค่าบริการที่จะคืนแก่ผู้ว่าจ้าง
                          ซึ่งการพิจารณานั้นจะประกอบด้วยปัจจัยต่าง ๆ อาทิ
                          การละเมิดข้อตกลง
                          การละเมิดสิทธิการใช้งานของผู้ใช้งานคนอื่น ๆ
                          การใช้บริการแพลตฟอร์มตามข้อตกลงการใช้งานอย่างไม่เหมาะสม
                          การส่งมอบงานผิดวัตถุประสงค์ เป็นต้น
                        </div>
                        <div>
                          <div>
                            4.
                            เมื่อได้สัดส่วนของค่าบริการที่จะคืนแก่ผู้ว่าจ้างแล้ว
                            บริษัทฯ
                            จะคืนค่าบริการให้แก่ผู้ว่าจ้างตามช่องทางต่อไปนี้
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>
                              4.1
                              กรณีผู้ว่าจ้างชำระค่าบริการผ่านบัญชีธนาคารหรือโมบายแบงก์กิ้ง
                              บริษัทฯ
                              จะคืนค่าบริการดังกล่าวผ่านช่องทางบัญชีธนาคารที่ผู้ว่าจ้างได้ให้ข้อมูลสำหรับการคืนค่าบริการไว้
                            </div>
                            <div>
                              4.2 กรณีผู้ว่าจ้างชำระค่าบริการผ่านบัตรเครดิต
                              บริษัทฯ
                              จะคืนค่าบริการดังกล่าวผ่านบัตรเครดิตที่ใช้ชำระค่าบริการ
                              โดยบริษัทฯ
                              จะส่งเรื่องขอคืนเงินไปยังธนาคารผู้ให้บริการบัตรเครดิตนั้นๆ
                              ทั้งนี้
                              ระยะเวลาการคืนเงินดังกล่าวจะขึ้นอยู่กับนโยบายของแต่ละธนาคาร
                            </div>
                            <div>
                              4.3 กรณีผู้ว่าจ้างชำระค่าบริการผ่านทรู มันนี่
                              (TrueMoney Wallet) บริษัทฯ
                              จะคืนค่าบริการดังกล่าวผ่านบัญชีธนาคารที่ผู้ว่าจ้างให้ข้อมูลสำหรับการคืนค่าบริการ
                            </div>
                          </div>
                        </div>
                        <div>
                          5. การประเมินผลงานเป็นสิทธิของผู้ว่าจ้าง
                          ซึ่งจะไม่ถูกลบออกไม่ว่าด้วยเหตุผลใด ๆ
                          เว้นแต่เป็นการประเมินผลงานที่ละเมิดข้อตกลงในการใช้งาน
                          ทั้งนี้ บริษัทฯ
                          จะใช้ความพยายามอย่างถึงที่สุดในการสนับสนุนให้ผู้ว่าจ้างได้สื่อสารกับแคดดี้ถึงระดับความพึงพอใจของผลงานตลอดจนปัญหาที่ได้รับจากผลงาน
                          และ/หรือ บริการ
                          เพื่อให้แคดดี้ได้แก้ไขปรับปรุงงานให้ตรงและเหมาะสมตามที่ได้เสนอไว้กับผู้ว่าจ้าง
                          อนึ่ง บริษัทฯ ขอสงวนสิทธิดำเนินการใด ๆ
                          กับบัญชีผู้ใช้งานที่มีการใช้งานระบบการประเมินผลงานผิดวัตถุประสงค์
                          ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                        </div>
                        <div>
                          6.
                          ผู้ว่าจ้างและแคดดี้สามารถสมัครเป็นสมาชิกแพลตฟอร์มได้โดยไม่มีค่าใช้จ่ายใดๆ
                        </div>
                        <div>
                          6.
                          แคดดี้ไม่สามารถต่อรองการส่งมอบงานเพื่อให้ได้รับการประเมินผลงานที่ดีจากผู้ว่าจ้างได้
                          หากบริษัทฯ รับทราบการกระทำดังกล่าว บริษัทฯ
                          มีสิทธิดำเนินการใดๆ
                          กับบัญชีผู้ใช้งานที่มีการใช้งานระบบการประเมินผลงานผิดวัตถุประสงค์
                          ซึ่งดุลพินิจของบริษัทฯ ให้ถือเป็นที่สุด
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        ข้อจำกัดการยกเลิกจ้างงานและการคืนเงิน
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          <div>
                            ในกรณีดังต่อไปนี้
                            ผู้ใช้งานอาจถูกจำกัดสิทธิในการยกเลิกจ้างงานและการคืนเงินตามกฎหมาย
                            รวมถึงอาจถูกระงับการใช้งานบัญชีผู้ใช้งานชั่วคราว
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>
                              1)
                              แคดดี้ได้ส่งมอบงานตามรายละเอียดที่กำหนดในงานที่นำเสนอและ/หรือใบเสนอราคา
                              (ถ้ามี)
                            </div>
                            <div>
                              2) ผู้ว่าจ้างมีส่วนเกี่ยวข้องในการยกเลิกจ้างงาน
                              ซึ่งรวมถึง กรณีการเชิญชวนแคดดี้ให้บริการนอกระบบ
                              หรือการขอยกเลิกการจ้างโดยความประสงค์ของผู้ว่าจ้างฝ่ายเดียว
                              ฯลฯ
                            </div>
                            <div>
                              3) ผู้ว่าจ้างมีส่วนเกี่ยวข้องในกิจกรรมใด ๆ
                              ที่มีลักษณะเป็นฉ้อโกงหรือแสวงหาผลประโยชน์อื่นใดโดยมิชอบ
                              ไม่ว่าเพื่อประโยชน์แก่ตนเองหรือบุคคลอื่นก็ตาม
                              บริษัทฯ
                              จะถือว่าเป็นการฉ้อโกงการใช้บริการแพลตฟอร์มในส่วนที่เกี่ยวข้องกับจ้างงานดังกล่าว
                            </div>
                            <div>
                              4)
                              ผู้ว่าจ้างได้แจ้งระงับการชำระหรือขอรับค่าบริการคืนจากผู้ให้บริการรับชำระเงิน
                              ซึ่งไม่จำกัดเพียง ธนาคาร สถาบันการเงิน
                              หรือบุคคลอื่น ๆ ที่นอกเหนือจากบริษัทฯ
                            </div>
                          </div>
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        การระงับการใช้งานและการยกเลิกบัญชีผู้ใช้งาน
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          1.
                          ในการควบคุมการใช้บริการแพลตฟอร์มให้เป็นไปตามข้อตกลงการใช้งานที่แท้จริง
                          บริษัทฯ
                          มีสิทธิตรวจสอบความเป็นเจ้าของบัญชีผู้ใช้งานได้ตลอดระยะเวลาที่ขอใช้บริการแพลตฟอร์ม
                          เมื่อบริษัทฯ มีการตรวจสอบดังกล่าว
                          ผู้ใช้งานต้องแสดงความเป็นเจ้าของบัญชีผู้ใช้งานโดยการแสดงหลักฐานต่าง
                          ๆ เช่น บัตรประจำตัวประชาชน สมุดบัญชีธนาคาร พาสปอร์ต
                          เอกสารทางกฎหมายต่าง ๆ ที่หน่วยงานของรัฐเป็นผู้ออกให้
                          หรือเอกสารอื่นใดตามที่บริษัทฯ ร้องขอ ทั้งนี้
                          เพื่อใช้เป็นหลักฐานในการยืนยันตัวตน
                        </div>
                        <div>
                          2. ในกรณีที่ผู้ใช้งานกระทำการใด ๆ ที่ไม่เหมาะสม
                          หรือกระทำการขัดต่อเงื่อนไขของข้อตกลงการใช้งานบริการแพลตฟอร์ม
                          บริษัทฯ
                          อาจเตือนผู้ใช้งานให้ระงับหรือยุติการกระทำดังกล่าวผ่านช่องทางติดต่อที่ผู้ใช้งานได้ลงทะเบียนไว้
                          และ/หรือแสดงการแจ้งเตือนบนแพลตฟอร์มขณะที่ผู้ใช้งานลงชื่อเข้าใช้งาน
                          อนึ่ง
                          แม้การเตือนดังกล่าวจะไม่ส่งผลต่อการใช้งานแพลตฟอร์มในทันที
                          แต่อาจส่งผลต่อการระงับการใช้งานและการยกเลิกบัญชีผู้ใช้งานในอนาคตได้
                        </div>
                        <div>
                          <div>
                            3. บริษัทฯ มีสิทธิใช้ดุลพินิจในการดำเนินการใด ๆ
                            กับบัญชีผู้ใช้งาน อาทิ
                            การระงับการใช้งานบัญชีผู้ใช้งานไม่ว่าชั่วคราวหรือถาวร
                            การลบบัญชีผู้ใช้งาน
                            การขึ้นทะเบียนแบล็คลิสต์บัญชีผู้ใช้งาน
                            หรือการอื่นใดที่บริษัทฯ เห็นสมควร ฯลฯ หากบริษัทฯ
                            เห็นว่าผู้ใช้งานฝ่าฝืนข้อตกลงการใช้งานฉบับนี้
                            ซึ่งรวมถึงกรณีดังดังต่อไปนี้
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>
                              3.1
                              ผู้ใช้งานกระทำการละเมิดข้อตกลงใช้งานหรือมีการกระทำที่ไม่เหมาะสมบนแพลตฟอร์ม
                              อาทิ การใช้คำพูดที่ไม่เหมาะสม การใช้ถ้อยคำหยาบคาย
                              การส่อเสียดเหยียดหยาม กลั่นแกล้ง หรือดูถูก เป็นต้น
                            </div>
                            <div>
                              3.2 ผู้ใช้งานกระทำการใด ๆ
                              อันมีพฤติการณ์หรือลักษณะเป็นการหลอกลวงเพื่อหวังผลข้อมูล
                              (ฟิชชิ่ง)
                              หรือก่อให้เกิดความเดือดร้อนรำคาญแก่ผู้อื่น (สแปม)
                            </div>
                            <div>
                              3.3 ผู้ใช้งานกระทำการใด ๆ อันเป็นสิ่งผิดกฎหมาย
                              หรือขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชนผ่านแพลตฟอร์ม
                              ซึ่งรวมถึงการกระทำความผิดตามพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์
                              พ.ศ. 2550 ฯลฯ
                            </div>
                            <div>
                              3.4 ผู้ใช้งานกระทำการใด ๆ
                              อันมีพฤติการณ์หรือลักษณะเป็นการพยายามที่จะเข้าสู่บัญชีผู้ใช้งานหรืออุปกรณ์การใช้งานของผู้ใช้อื่น
                              ๆ ผ่านแพลตฟอร์ม
                            </div>
                            <div>
                              3.5 ผู้ใช้งานกระทำการใด ๆ
                              อันมีพฤติการณ์หรือลักษณะเป็นการละเมิดลิขสิทธิ์หรือละเมิดทรัพย์สินทางปัญญาของบุคคลอื่น
                            </div>
                            <div>
                              3.6 ผู้ใช้งานกระทำการใด ๆ
                              อันมีพฤติการณ์หรือลักษณะให้ตนเองหรือบุคคลอื่นได้รับสิทธิประโยชน์ที่ไม่มีสิทธิได้รับตามกฎหมาย
                              ซึ่งรวมถึงการจ้างงานตนเองเพื่อหวังผลประโยชน์จากการส่งเสริมการขายและไม่ได้มีวัตถุประสงค์เพื่อการจ้างงานอย่างแท้จริง
                              ฯลฯ
                            </div>
                            <div>
                              3.7 ผู้ใช้งานมีบัญชีมากกว่าหนึ่งบัญชี
                              หรือผู้ใช้งานใช้ข้อมูลส่วนบุคคลของบุคคลอื่นมาสมัครใช้งาน
                              ผู้ใช้งานซื้อขายบัญชีผู้ใช้งานให้กับบุคคลอื่น
                            </div>
                            <div>
                              3.8 ผู้ใช้งานกระทำการใด ๆ
                              อันมีพฤติการณ์หรือลักษณะเป็นการหลีกเลี่ยงค่าธรรมเนียมการใช้บริการแพลตฟอร์ม
                              และ/หรือ ค่าธรรมเนียมการชำระเงิน
                              ซึ่งรวมถึงการชักจูงหรือจูงใจให้นำไปสู่การติดต่อเพื่อจ้างงานนอกแพลตฟอร์ม
                              ฯลฯ
                            </div>
                          </div>
                        </div>
                        <div>
                          4. การใช้ดุลพินิจของบริษัทฯ ย่อมถือเป็นที่สุด
                          โดยผู้ว่าจ้างไม่สามารถอุทธรณ์หรือโต้แย้งการใช้ดุลพินิจของบริษัทฯ
                          ในการระงับการใช้งานและการยกเลิกบัญชีผู้ใช้งานได้
                          แต่ไม่ตัดสิทธิท่านในการให้ข้อมูลหรือชี้แจงข้อเท็จจริงใด
                          ๆ
                          ที่เกี่ยวข้องกับการใช้ดุลพินิจในการระงับการใช้งานและการยกเลิกบัญชีผู้ใช้งานของท่าน
                        </div>
                        <div>
                          5. บัญชีผู้ใช้งานที่ถูกระงับการใช้งานไปแล้ว
                          จะไม่สามารถทำการซื้อขายงานบนแพลตฟอร์มได้อีกต่อไป
                          รวมถึงการลงผลงานและ/หรือบริการเพิ่มเติมได้
                          อย่างไรก็ตาม
                          เมื่อมีการระงับการใช้งานบัญชีผู้ใช้งานรายใด
                          ผู้ที่ได้รับผลกระทบจากการระงับบัญชีผู้ใช้งานสามารถติดต่อเจ้าหน้าที่ของบริษัทฯ
                          ตามช่องทางที่บริษัทฯ กำหนด
                          เพื่อสอบถามถึงข้อมูลหรือสถานะของบัญชีผู้ใช้งานดังกล่าว
                          ตลอดจนแนวทางการขอยกเลิกออร์เดอร์ได้
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        การระงับข้อพิพาทระหว่างผู้ใช้งาน
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          <div>
                            1. บริษัทฯ
                            สนับสนุนให้ผู้ใช้งานแก้ไขข้อพิพาทด้วยการเจรจาพูดคุยบนแพลตฟอร์ม
                            ซึ่งรวมถึงข้อพิพาทในกรณีดังต่อไปนี้
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>1.1 คุณภาพของงาน</div>
                            <div>1.2 ขอบเขตของงาน</div>
                            <div>1.3 กำหนดระยะเวลาส่งมอบงาน</div>
                            <div>1.4 ความเสียหายที่เกิดขึ้นขณะทำงาน</div>
                            <div>
                              1.5 ความเสียหายที่อาจเกิดขึ้นภายหลังส่งมอบงาน
                            </div>
                          </div>
                        </div>
                        <div>
                          2. ในกรณีที่ไม่สามารถระงับข้อพิพาทได้
                          ผู้ว่าจ้างหรือแคดดี้ แล้วแต่กรณี อาจติดต่อมาที่บริษัทฯ
                          ผ่านช่องทางติดต่อที่ระบุไว้ เพื่อให้บริษัทฯ
                          เข้ามาไกล่เกลี่ยระงับข้อพิพาทได้ ซึ่งบริษัทฯ
                          มีความประสงต์ต้องการให้การไกล่เกลี่ยได้ดำเนินการอย่างถูกต้องและเป็นธรรมที่สุด
                          ทั้งนี้ ผู้ใช้งานตกลงส่งมอบข้อเท็จจริง เอกสาร
                          หรือหลักฐานต่าง ๆ ที่เกี่ยวข้องกับข้อพิพาท
                          ตลอดจนตกลงและยินยอมให้บริษัทฯ
                          เข้าถึงการพูดคุยของผู้ว่าจ้างและแคดดี้
                          รวมทั้งตรวจสอบรายละเอียดหรือข้อมูลการติดต่อ
                          เพื่อระงับข้อพิพาทระหว่างผู้ใช้งานได้
                        </div>
                        <div>
                          3. ในกรณีที่มีการร้องเรียนคุณภาพของงาน บริษัทฯ
                          อาจตรวจสอบประวัติการทำงาน จ้างงาน ข้อความ การชำระเงิน
                          และข้อมูลอื่น ๆ ของแคดดี้ได้
                          โดยมิต้องขอความยินยอมหรือแจ้งให้แคดดี้ทราบล่วงหน้า
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        การเรียกร้องค่าเสียหาย
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          <div>
                            1. ในกรณีที่มีความเสียหายใด ๆ เกิดขึ้นต่อบุคคลภายนอก
                            ซึ่งไม่ใช่ความผิดของผู้ให้บริการแพลตฟอร์ม
                            ผู้ใช้งานตกลงรับผิดชดใช้ค่าสินไหมทดแทนแก่บุคคลที่เกี่ยวข้องโดยตรง
                            ซึ่งรวมถึงกรณีดังต่อไปนี้
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>
                              1.1
                              ผู้ใช้งานซึ่งเป็นผู้ใช้หรือเปิดเผยข้อมูลส่วนบุคคลตกลงรับผิดชดใช้ค่าสินไหมทดแทนต่อบุคคลภายนอกซึ่งเป็นเจ้าของข้อมูลส่วนบุคคลนั้น
                            </div>
                            <div>
                              1.2
                              ผู้ใช้งานซึ่งเป็นผู้ใช้หรือเผยแพร่ลิขสิทธิหรือทรัพย์สินทางปัญญา
                              ตกลงรับผิดชดใช้ค่าสินไหมทดแทนต่อบุคคลภายนอกซึ่งเป็นเจ้าของทรัพย์สินทางปัญญา
                            </div>
                            <div>
                              1.3
                              ผู้ใช้งานซึ่งเป็นผู้ใช้หรือเปิดเผยข้อมูลอันเป็นความลับ
                              ตกลงรับผิดชดใช้ค่าสินไหมทดแทนต่อผู้ถูกเปิดเผยข้อมูลอันเป็นความลับ
                            </div>
                            <div>
                              1.4 ผู้ใช้งานซึ่งเป็นผู้ไขข่าวแพร่หลาย
                              ตกลงรับผิดชดใช้ค่าสินไหมทดแทนต่อผู้ที่ได้รับความเสียหายจากข้อมูลดังกล่าว
                            </div>
                          </div>
                        </div>
                        <div>
                          2. ในกรณีที่มีการฟ้องคดีหรือดำเนินการใด ๆ
                          กับบุคคลภายนอกจากการกระทำของผู้ใช้งาน
                          ซึ่งส่งผลให้บริษัทฯ
                          ต้องเข้าร่วมเป็นคู่ความหรือต้องให้การใด ๆ
                          ตามคำสั่งของหน่วยงานของรัฐที่เกี่ยวข้อง
                          ผู้ใช้งานตกลงรับผิดร่วมกันต่อบริษัทฯ
                          ในการออกค่าใช้จ่ายต่าง ๆ
                          ที่เกิดขึ้นจากการดำเนินการดังกล่าว
                          ซึ่งรวมถึงค่าทนายความ ค่าเดินทาง ค่าธรรมเนียม อากร
                          ค่าบริการ ค่าปรับ ค่าสินไหมทดแทน
                          หรือค่าเสียหายอื่นใดที่เกิดจากหรือสืบเนื่องจากการดำเนินการดังกล่าว
                          ไม่ว่าโดยตรงหรือโดยอ้อม
                        </div>
                        <div>
                          3. ในกรณีที่ผู้ใช้งานต้องรับผิดชอบต่อบริษัทฯ
                          ผู้ใช้งานตกลงชดใช้ค่าสินไหมทดแทนต่อบริษัทฯ
                          เพื่อเยียวยาความเสียหายไม่ว่าโดยทางตรงหรือโดยทางอ้อม
                        </div>
                        <div>
                          4. ในกรณีที่ผู้ใช้งานต้องรับผิดระหว่างกัน
                          ผู้ใช้งานตกลงชดใช้ค่าสินไหมทดแทนตามเงื่อนไขที่ได้จากการระงับข้อพิพาทระหว่างผู้ใช้งาน
                        </div>
                        <div>
                          5. ในกรณีที่บริษัทฯ ต้องรับผิดต่อผู้ใช้งาน บริษัทฯ
                          ตกลงชดใช้ค่าสินไหมทดแทนตามความเสียหายที่เกิดขึ้นจริงต่อผู้ใช้งานเพื่อเยียวยาความเสียหายดังกล่าว
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        ข้อจำกัดความรับผิดของบริษัทฯ
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          <div>
                            1. การให้บริการแพลตฟอร์มไม่ได้ส่งผลให้บริษัทฯ
                            เป็นตัวการร่วม ตัวแทนร่วม ลูกหนี้ร่วม
                            หรือนิติสัมพันธ์ใด ๆ ร่วมกับผู้ใช้งาน
                            นอกจากการเป็นผู้ให้บริการ
                            ซึ่งผู้ใช้บริการมีหน้าที่ชำระค่าธรรมเนียมการใช้บริการแพลตฟอร์มและค่าธรรมเนียมการชำระเงิน
                            แล้วแต่กรณี ให้แก่บริษัทฯ
                          </div>
                        </div>
                        <div>
                          <div>
                            2. บริษัทฯ ขอสงวนสิทธิในความรับผิดใด ๆ
                            จากผลงานและ/หรือบริการที่ผู้ว่าจ้างได้รับจากแคดดี้ในกรณีต่อไปนี้
                          </div>
                          <div
                            style={{
                              padding: "0px 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            <div>
                              (1) การจ้างงานที่ไม่อยู่ในขอบเขตของการจ้างงาน
                            </div>
                            <div>
                              (2) การจ้างงานที่ไม่มีการชำระเงินผ่านแพลตฟอร์ม
                            </div>
                            <div>
                              (3) การจ้างงานที่เป็นการละเมิดข้อตกลงการใช้งาน
                            </div>
                            <div>
                              (4) ข้อความใด ๆ
                              ที่ปรากฏในงานที่นำเสนอหรือพูดคุยของผู้ใช้งานเอง
                            </div>
                            <div>
                              (5) ข้อความใด ๆ ที่ปรากฏในแบบการประเมินผลงาน
                            </div>
                          </div>
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>คุณภาพของงาน</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          กรณีความเสียหายที่เกิดขึ้นหรืออาจเกิดขึ้นจากงาน
                          กรณีความเสียหายที่เกิดขึ้นหรืออาจเกิดขึ้นจากการระงับข้อพิพาทระหว่างผู้ใช้งาน
                          ในกรณีดังกล่าวบริษัทฯ
                          ไม่อาจรับประกันคุณภาพของผลงานและ/หรือบริการที่ผู้ว่าจ้างพึงได้รับมอบจากแคดดี้ได้
                          ซึ่งรวมถึงขอบเขตงาน ความสำเร็จของงาน
                          ความเสียหายที่เกิดขึ้นจากการทำงาน ทั้งนี้
                          ไม่ว่าจะเกิดขณะหรือภายหลังส่งมอบงาน ฯลฯ
                          การศึกษาคุณภาพของงานนั้นสามารถทำได้จากการพิจารณารายละเอียดและคะแนนของการประเมินผลงานที่แคดดี้ได้รับ
                          อย่างไรก็ตาม บริษัทฯ
                          จะใช้ความพยายามอย่างถึงที่สุดในการให้ผู้ว่าจ้างได้รับงานที่ถูกต้องตามคุณสมบัติที่เสนอในงานที่นำเสนอจากแคดดี้
                        </div>
                        <div>
                          บริษัทในเครือ ผู้บริหาร กรรมการ ผู้ถือหุ้น ลูกจ้าง
                          พนักงาน ตัวแทน คู่ค้า
                          หรือบุคคลอื่นใดที่อยู่ภายใต้การกำกับดูแลของบริษัทฯ
                          มีสิทธิในการปฏิเสธความรับผิดต่อความเสียหายใด ๆ
                          ที่เกี่ยวข้องกับการใช้บริการแพลตฟอร์ม
                          ไม่ว่าจะเป็นความเสียหายโดยตรง
                          อันเนื่องจากความเสียหายเพื่อพฤติการณ์พิเศษ
                          หรือค่าเสียหายเชิงลงโทษ หรือกรณีการบาดเจ็บส่วนบุคคล
                          ความเจ็บปวดทุกข์ทรมานไม่ว่าต่อร่างกายหรือจิตใจ
                          การสูญเสียรายได้ การสูญเสียกำไร
                          การสูญเสียโอกาสทางธุรกิจหรือกำไรที่คาดหวังไว้
                          ความเสียหายต่อร่างกาย ทรัพย์สิน ชื่อเสียง หรือข้อมูล
                          เป็นต้น
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>
                        นโยบายความเป็นส่วนตัว
                      </h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          บริษัทฯ
                          ให้ความสำคัญและตระหนักถึงการคุ้มครองความปลอดภัยของข้อมูลส่วนบุคคลของผู้ว่าจ้างตามกฎหมาย
                          ซึ่งนโยบายความเป็นส่วนตัวนี้ถือเป็นส่วนหนึ่งของข้อตกลงการใช้งานฉบับนี้ด้วย
                          การคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้งาน บริษัทฯ
                          ถือว่าข้อมูลส่วนบุคคลของผู้ใช้งานดังกล่าวเป็นข้อมูลที่เป็นความลับ
                          และจะถูกประมวลผลตามวัตถุประสงค์ของการเก็บรวบรวมตามข้อตกลงการใช้งานฉบับนี้และกฎหมายที่เกี่ยวข้องเท่านั้น
                          บริษัทฯ
                          จะไม่ประมวลผลข้อมูลส่วนบุคคลของผู้ใช้งานนอกเหนือจากข้อกำหนดดังกล่าวเว้นแต่จะได้รับการยินยอมจากผู้ใช้งาน
                          หรือผู้มีอำนาจตามกฎหมาย
                        </div>
                        <div>
                          บริษัทฯ
                          อาจเข้าถึงข้อมูลการพูดคุยของผู้ว่าจ้างและแคดดี้เพื่อควบคุมไม่ให้มีการใช้บริการแพลตฟอร์มที่ฝ่าฝืนกับข้อตกลงการใช้งาน
                          โดยเฉพาะอย่างยิ่งเรื่องการติดต่อพูดคุย อาทิ
                          การชักจูงหรือจูงใจให้มีการติดต่อเพื่อจ้างงานนอกแพลตฟอร์ม
                          การติดต่อสอบถามหรือส่งมอบงานเพิ่มเติมในช่องทางอื่นนอกเหนือจากแพลตฟอร์ม
                          เป็นต้น รวมถึงเพื่อการระงับข้อพิพาทระหว่างผู้ใช้งาน
                          การตรวจสอบในกรณีมีข้อสงสัยเรื่องการกระทำที่ทุจริต
                          ผิดกฎหมาย
                          หรือขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีของประชาชนผ่านแพลตฟอร์ม
                          ฯลฯ
                        </div>
                        <div>
                          กรณีที่ผู้ว่าจ้างสมัครใช้บริการแพลตฟอร์ม
                          ย่อมถือเป็นการยอมรับข้อกำหนดของข้อตกลงการใช้งาน
                          ซึ่งบริษัทฯ มีอำนาจตามสัญญา ประโยชน์โดยชอบธรรม
                          ตลอดจนความยินยอมของผู้ว่าจ้างในการเข้าถึงข้อมูลส่วนบุคคลดังกล่าวด้วย
                        </div>
                        <div>
                          ผู้ว่าจ้างตกลงและยินยอมให้บริษัทฯ
                          มีสิทธิที่นำเนื้อหาต่าง ๆ
                          ที่ผู้ใช้งานเผยแพร่บนแพลตฟอร์ม อาทิ ข้อความ รูปภาพ
                          วีดีโอ ชื่อบัญชี ผลงาน หรือข้อมูลอื่นใด
                          เพื่อนำไปเผยแพร่เพื่อวัตถุประสงค์ของการประชาสัมพันธ์ทางการตลาดของบริษัทฯ
                        </div>
                      </div>
                      <h3 style={{ marginBottom: -10 }}>รายละเอียดการติดต่อ</h3>
                      <div
                        style={{
                          padding: "0px 10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                          marginTop: 10,
                        }}
                      >
                        <div>
                          ในกรณีที่ผู้ว่าจ้างต้องการสอบถามข้อมูลเกี่ยวกับข้อตกลงการใช้งานฉบับนี้
                          รวมถึงขอใช้สิทธิตามข้อกำหนดต่อบริษัทฯ
                          โดยผู้ว่าจ้างสามารถติดต่อบริษัทฯ ในวัน-เวลาทำการ
                          (จันทร์-ศุกร์ 8.30-17.30น. หยุด เสาร์-อาทิตย์
                          และวันหยุดนักขัตฤกษ์) ได้ผ่านรายละเอียดดังนี้
                        </div>
                        <div>ชื่อบริษัทฯ บริษัท กอล์ฟาโล่ จำกัด</div>
                        <div>
                          ที่อยู่ เลขที่ 571 อาคารอาร์เอสยูทาวเวอร์ ชั้น9
                          ยูนิต903 ซอยสุขุมวิท31 ถนนสุขุมวิท แขวงคลองตันเหนือ
                          เขตวัฒนา กรุงเทพมหานคร 10110
                        </div>
                        <div>จดหมายอิเล็กทรอนิกส์ support@golfalo.com</div>
                        <div>เบอร์โทรศัพท์ 02-117-9546</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                onClick={() => {
                  setShowTermCondition(false);
                }}
                type="primary"
                style={{ width: "100%", height: 40 }}
              >
                ยอมรับ
              </Button>
            </div>
          </div>
        </div>
      )
    );
  }

  function Page3() {
    const [selectedTime, setSelectedTime] = useState(null);

    // Generate available hours based on slot
    const generateAvailableHours = () => {
      const hours = [];
      if (!avalibleSelected?.slot?.start) return hours;

      const start = avalibleSelected.slot.start;
      const end = avalibleSelected.slot.end;

      const startHour = parseInt(start.split(":")[0]);
      const endHour = end ? parseInt(end.split(":")[0]) : startHour;

      for (let i = startHour; i <= endHour; i++) {
        hours.push(i);
      }
      return hours;
    };

    // Generate available minutes for selected hour based on time slot
    const generateAvailableMinutes = (selectedHour) => {
      if (!avalibleSelected?.slot?.start || selectedHour === null) return [];

      const start = avalibleSelected.slot.start;
      const end = avalibleSelected.slot.end;

      const startHour = parseInt(start.split(":")[0]);
      const startMinute = parseInt(start.split(":")[1] || "0");

      let endHour = startHour;
      let endMinute = 59;

      if (end) {
        endHour = parseInt(end.split(":")[0]);
        endMinute = parseInt(end.split(":")[1] || "0");
      }

      const minutes = [];

      // Determine available minutes based on selected hour
      let minMinute = 0;
      let maxMinute = 59;

      // If selected hour is the start hour, begin from start minute
      if (selectedHour === startHour) {
        minMinute = startMinute;
      }

      // If selected hour is the end hour and end time exists, end at end minute
      if (selectedHour === endHour && end) {
        maxMinute = endMinute;
      }

      for (let i = minMinute; i <= maxMinute; i++) {
        minutes.push(i);
      }

      return minutes;
    };

    const handleSubmitTime = () => {
      if (selectedTime) {
        navigate(
          `/book_caddy/${caddyData.id}?date=${avalibleSelected.date}&time=${selectedTime}`
        );
        setViewState((prev) => prev + 1);
      }
    };

    const availableHours = generateAvailableHours();

    return (
      <div className="search-caddy-view-content">
        <div
          style={{
            padding: 20,
            background: "white",
            borderRadius: 15,
            marginTop: 20,
          }}
        >
          <center>
            {/* <h4 style={{ marginBottom: 5, marginTop: 15 }}>วันที่ทีออฟ</h4> */}
            <h1 style={{ color: "rgb(20, 174, 92)" }}>
              {dayjs(avalibleSelected?.date, "YYYY-MM-DD").format(
                "DD MMMM YYYY"
              )}
            </h1>
            <h3 style={{ marginTop: -5 }}>
              {caddyData?.golf_course?.data?.name}
            </h3>
          </center>
          <Divider style={{ margin: "20px 0px" }} />
          <h3 style={{ display: "flex", gap: 10, flexDirection: "column" }}>
            <div>กรุณาเลือกเวลาทีออฟ</div>
            <div>
              ระหว่าง :{" "}
              <span style={{ color: "#14AE5C", fontWeight: "bold" }}>
                {avalibleSelected?.slot?.start}
                {avalibleSelected?.slot?.end &&
                  ` - ${avalibleSelected?.slot?.end}`}
              </span>
            </div>

            <CustomTimePicker
              value={selectedTime}
              onChange={setSelectedTime}
              availableHours={availableHours}
              availableMinutes={generateAvailableMinutes}
              timeSlot={{
                start: avalibleSelected?.slot?.start,
                end: avalibleSelected?.slot?.end,
              }}
              placeholder={{
                hour: "เลือกชั่วโมง",
                minute: "เลือกนาที",
              }}
              style={{ marginTop: "20px" }}
            />

            <Button
              style={{
                width: "100%",
                marginTop: "20px",
                height: "50px",
                fontSize: "16px",
                fontWeight: "600",
              }}
              type="primary"
              disabled={!selectedTime}
              onClick={handleSubmitTime}
            >
              จอง
            </Button>
          </h3>
        </div>
      </div>
    );
  }

  function Page4() {
    return (
      <div className="search-caddy-view-content">
        <Modal
          closable={false}
          open={openConfirmOrder}
          centered
          footer={false}
          onCancel={() => setOpenConfirmOrder(false)}
        >
          <center>
            <h2>ยืนยันการจอง Caddy</h2>
          </center>

          <div style={{ margin: "10px 0px 20px 0px" }}>
            <center>
              คุณต้องการจองแคดดี้{" "}
              <span style={{ fontWeight: "bold" }}>
                {caddyData?.display_name}
              </span>{" "}
              ใช่หรือไม่ ?
            </center>
            <center>
              หากยืนยันแล้วจะไม่สามารถยกเลิกได้ และต้องชำระเงินภายใน{" "}
              {controllerData?.payment_time_out} นาที.
            </center>
          </div>

          <div style={{ display: "flex", gap: 10, width: "100%" }}>
            <Button
              style={{ width: "100%" }}
              type="primary"
              onClick={() => onClickPayment()}
            >
              ใช่, ยืนยัน
            </Button>
            <Button
              style={{ width: "100%" }}
              danger
              onClick={() => setOpenConfirmOrder(false)}
            >
              ไม่ใช่
            </Button>
          </div>
        </Modal>
        <div
          style={{ backgroundColor: "white", borderRadius: 10, padding: 20 }}
        >
          <div>ชื่อก๊วน</div>
          <Input onChange={(e) => setGroupName(e.target.value)} />
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>
            ใช้รถหรือเดิน
          </div>
          <Radio.Group
            value={selectedMode}
            onChange={(e) => setSelectedMode(e.target.value)}
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            {BOOKING_MODE_OPTIONS.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
          {!selectedMode && (
            <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 5 }}>
              กรุณาเลือกใช้รถหรือเดิน
            </div>
          )}
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <div>หมายเหตุถึงแคดดี้</div>
          <Input.TextArea
            maxLength={255}
            showCount
            placeholder="เช่น เป็นมือใหม่ ช่วยแนะนำระยะด้วยครับ"
            onChange={(e) => setBookingNote(e.target.value)}
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h3>รายละเอียดการจอง</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div>ชื่อแคดดี้ : {caddyData?.display_name} (เบอร์: {caddyData?.caddy_number})</div>
            <div>สนาม : {caddyData?.golf_course?.data?.name}</div>
            <div>
              {search_pararms.get("date")
                ? `${dayjs(search_pararms.get("date", "YYYY-MM-DD")).format(
                    "DD"
                  )} ${
                    THAI_MONTHS[
                      parseInt(
                        dayjs(search_pararms.get("date", "YYYY-MM-DD")).format(
                          "MM"
                        )
                      ) - 1
                    ]
                  } ${dayjs(search_pararms.get("date", "YYYY-MM-DD")).format(
                    "YYYY"
                  )}`
                : "DD-MM-YYYY"}
            </div>
            <div>
              เวลาที่ทีออฟ :{" "}
              {search_pararms.get("time")
                ? `${search_pararms.get("time")} น.`
                : "HH:ss"}
            </div>
          </div>
        </div>

        {refundList?.length > 0 && (
          <div
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              padding: 20,
              marginTop: 15,
            }}
          >
            <h3 style={{ color: "#007AFF" }}>ยอดที่ยกมาจากการยกเลิก</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <Radio.Group
                value={refundJobsSelected ? refundJobsSelected.id : null}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  width: "100%",
                }}
              >
                {/* <Radio onClick={() => setRefundJobsSelected(null)} value={null}>
                  <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>ไม่เลือก</div>
                  </div>
                </Radio> */}
                <Divider style={{ margin: 0 }} />
                {refundList?.map((refund) => {
                  return (
                    <>
                      <Radio
                        onClick={() => setRefundJobsSelected(refund)}
                        value={refund.id}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <div style={{ fontSize: 16 }}>
                              {refund.caddy_name}
                            </div>
                            <b style={{ fontSize: 12 }}>
                              Ref : {refund.booking_ref}
                            </b>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div>
                              {new Intl.NumberFormat("th-TH", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(refund.refund_amount)}{" "}
                              บาท
                            </div>
                            <div
                              style={{
                                color:
                                  GetRefundTotal(refund.refund_amount) > 0
                                    ? `red`
                                    : GetRefundTotal(refund.refund_amount) === 0
                                    ? "rgba(0, 0, 0, 0.3)"
                                    : `rgb(0, 153, 81)`,
                              }}
                            >
                              {GetRefundTotal(refund.refund_amount) > 0
                                ? `ชำระเพิ่ม ${new Intl.NumberFormat("th-TH", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(
                                    GetRefundTotal(refund.refund_amount)
                                  )} บาท`
                                : GetRefundTotal(refund.refund_amount) === 0
                                ? `ไม่ต้องชำระเพิ่ม`
                                : `ได้รับเงินคืน ${new Intl.NumberFormat(
                                    "th-TH",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  ).format(
                                    Math.abs(
                                      GetRefundTotal(refund.refund_amount)
                                    )
                                  )} บาท`}
                            </div>
                          </div>
                        </div>
                      </Radio>
                      <Divider style={{ margin: 0 }} />
                    </>
                  );
                })}
              </Radio.Group>
            </div>
          </div>
        )}

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h3 style={{ color: "#007AFF" }}>รายละเอียดการชำระเงิน</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>ทิปแคดดี้ :</div>
              <div>
                {new Intl.NumberFormat("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(caddyData?.price ?? 0)}{" "}
                บาท
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>ค่าดำเนินการ :</div>
              <div>
                {new Intl.NumberFormat("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(controllerData?.transaction_fee ?? 0)}{" "}
                บาท
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>ยอดรวม (ก่อน VAT) : </div>
              <div>
                {new Intl.NumberFormat("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(
                  caddyData?.price + controllerData?.transaction_fee
                )}{" "}
                บาท
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>VAT 7 % :</div>
              <div>
                {new Intl.NumberFormat("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(controllerData?.transaction_fee * 0.07)}{" "}
                บาท
              </div>
            </div>
            {refundJobsSelected && (
              <Fragment>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>รวม :</div>
                  <div>
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(
                      controllerData?.transaction_fee * 0.07 +
                        caddyData?.price +
                        controllerData?.transaction_fee
                    )}{" "}
                    บาท
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "red",
                  }}
                >
                  <div>ยอดที่ยกมา :</div>
                  <div>
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(refundJobsSelected.refund_amount)}{" "}
                    บาท
                  </div>
                </div>
              </Fragment>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
                fontSize: 18,
              }}
            >
              <b>ยอดรวมทั้งหมด :</b>
              <div style={{ textAlign: "right" }}>
                {refundJobsSelected ? (
                  <div>
                    <b>
                      {GetRefundTotal(refundJobsSelected.refund_amount) < 0
                        ? 0
                        : new Intl.NumberFormat("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            Math.abs(
                              GetRefundTotal(refundJobsSelected.refund_amount)
                            )
                          )}{" "}
                      บาท
                    </b>
                    {GetRefundTotal(refundJobsSelected.refund_amount) < 0 && (
                      <div
                        style={{
                          color: "rgb(0, 153, 81)",
                          fontSize: 14,
                          marginTop: 5,
                        }}
                      >{`ได้รับเงินคืน ${new Intl.NumberFormat("th-TH", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        Math.abs(
                          GetRefundTotal(refundJobsSelected.refund_amount)
                        )
                      )} บาท`}</div>
                    )}
                  </div>
                ) : (
                  <b>
                    {new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(
                      controllerData?.transaction_fee * 0.07 +
                        caddyData?.price +
                        controllerData?.transaction_fee
                    )}{" "}
                    บาท
                  </b>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h3>ยืนยันการจอง</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              border: "1px solid rgba(5, 5, 5, 0.06)",
              padding: 20,
              borderRadius: 10,
            }}
          >
            <center style={{ fontSize: 28, fontWeight: "bold" }}>ราคา</center>
            <center
              style={{ color: "#007AFF", fontSize: 28, fontWeight: "bold" }}
            >
              {refundJobsSelected ? (
                <div>
                  <b>
                    {GetRefundTotal(refundJobsSelected.refund_amount) < 0
                      ? 0
                      : new Intl.NumberFormat("th-TH", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(
                          Math.abs(
                            GetRefundTotal(refundJobsSelected.refund_amount)
                          )
                        )}{" "}
                    บาท
                  </b>
                  {GetRefundTotal(refundJobsSelected.refund_amount) < 0 && (
                    <div
                      style={{
                        color: "rgb(0, 153, 81)",
                        fontWeight: "normal",
                        fontSize: 14,
                        marginTop: 5,
                      }}
                    >{`ได้รับเงินคืน ${new Intl.NumberFormat("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(
                      Math.abs(GetRefundTotal(refundJobsSelected.refund_amount))
                    )} บาท`}</div>
                  )}
                </div>
              ) : (
                <b>
                  {new Intl.NumberFormat("th-TH", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(
                    controllerData?.transaction_fee * 0.07 +
                      caddyData?.price +
                      controllerData?.transaction_fee
                  )}{" "}
                  บาท
                </b>
              )}
            </center>
            <center style={{ marginTop: 20 }}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                disabled={!selectedMode}
                onClick={() => setOpenConfirmOrder(true)}
              >
                ยืนยันการจอง
              </Button>
            </center>
            <center>
              <div style={{ marginTop: 10, lineHeight: "1.35rem" }}>
                โดยการคลิก "ชำระเงิน"
                ฉันได้อ่านข้อกำหนดและเงื่อนไขการเข้าร่วมเป็นสมาชิก /{" "}
                <span
                  onClick={() => setShowTermCondition(true)}
                  style={{
                    cursor: "pointer",
                    color: "#bad4d2",
                    textDecoration: "underline",
                    textUnderlineOffset: 3,
                  }}
                >
                  นโยบายความเป็นส่วนตัว
                </span>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }

  function Page6() {
    const showPaymentContent = !isCancel && paymentContent;
    const showPaymentError = paymentContent === false;

    const renderCountdown = () => {
      if (
        paymentContent &&
        targetTime &&
        timeLeft &&
        timeLeft.minutes >= 0 &&
        timeLeft.seconds >= 0 &&
        parseInt(bookingData?.status) !== 3
      ) {
        return (
          <center style={{ marginBottom: 0 }}>
            <b>
              ชำระภายใน {timeLeft.minutes}:
              {timeLeft.seconds >= 10
                ? timeLeft.seconds
                : `0${timeLeft.seconds}`}{" "}
              นาที
            </b>
          </center>
        );
      }
    };

    const renderCancelledMessage = () => (
      <center
        style={{
          fontWeight: "bold",
          marginTop: 20,
          fontSize: 16,
          display: "flex",
          flexDirection: "column",
          gap: 10,
          border: "1px solid red",
          padding: 15,
          borderRadius: 20,
          color: "red",
        }}
      >
        <div>การจองถูกยกเลิก</div>
        <div>เนื่องจากเกินเวลาที่กำหนด</div>
      </center>
    );

    return (
      <div className="search-caddy-view-content" style={{ marginTop: 10 }}>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h2>ยืนยันการจอง / ชำระเงิน</h2>

          <div
            style={{
              fontSize: 14,
              color: "red",
              padding: "0px 20px 20px 20px",
              textAlign: "center",
            }}
          >
            ** อย่าปิด Application Line จนกว่าการชำระเงินเสร็จสิ้น
            หรือจนกว่าจะได้รับการยืนยันการชำระเงิน (สามารถพับหน้าจอได้) **
          </div>

          {showPaymentContent && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                border: "1px solid rgba(5, 5, 5, 0.06)",
                padding: 20,
                borderRadius: 10,
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <center>
                  <div
                    style={{ marginTop: 5, fontWeight: "bold", fontSize: 16 }}
                  >
                    Ref : {bookingData?.booking_ref}
                  </div>
                </center>

                {renderCountdown()}
              </div>

              {/* Price Summary */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 0",
                  borderBottom: "1px solid #f0f0f0",
                  marginBottom: 5,
                }}
              >
                <span style={{ fontSize: 14, color: "#666" }}>ยอดรวมทั้งหมด:</span>
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    color: discountedGrandTotal ? "#389e0d" : "#333",
                  }}
                >
                  {new Intl.NumberFormat().format(
                    discountedGrandTotal ?? bookingData?.grand_total
                  )}{" "}
                  บาท
                </span>
              </div>
              {discountedGrandTotal && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 5,
                    marginBottom: 5,
                    fontSize: 13,
                    color: "#999",
                  }}
                >
                  <span>ราคาเดิม:</span>
                  <span style={{ textDecoration: "line-through" }}>
                    {new Intl.NumberFormat().format(bookingData?.grand_total)} บาท
                  </span>
                </div>
              )}

              {/* Coupon Input */}
              <CouponInput
                bookingId={bookingData?.id}
                grandTotal={bookingData?.grand_total}
                onCouponApplied={(data) => {
                  setAppliedCoupon(data);
                  setDiscountedGrandTotal(data.discounted_grand_total);
                  setCouponError("");
                }}
                onCouponRemoved={() => {
                  setAppliedCoupon(null);
                  setDiscountedGrandTotal(null);
                  setCouponError("");
                }}
                disabled={isLoading}
              />

              {couponError && (
                <div
                  style={{
                    color: "#ff4d4f",
                    fontSize: 13,
                    padding: "6px 10px",
                    borderRadius: 6,
                    backgroundColor: "#fff2f0",
                    marginBottom: 10,
                  }}
                >
                  {couponError}
                </div>
              )}

              <Button
                type="primary"
                size="large"
                onClick={handleGoPayment}
                style={{
                  background:
                    "linear-gradient(90deg, #34d399 0%, #059669 100%)",
                  border: "none",
                  borderRadius: "999px",
                  padding: "12px 24px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
                }}
              >
                💳 จ่ายเงิน
              </Button>

              {/* <iframe
                style={{ width: "100%", height: "700px", border: "none" }}
                src={paymentContent}
                title="payments"
              /> */}
            </div>
          )}

          {showPaymentError && (
            <center style={{ fontSize: 22, color: "red" }}>
              <CloseOutlined />
              <div>เกิดข้อผิดพลาดในการชำระเงิน </div>
              <div>กรุณาลองใหม่อีกครั้ง.</div>
            </center>
          )}

          {isCancel && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                border: "1px solid rgba(5, 5, 5, 0.06)",
                padding: 20,
                borderRadius: 10,
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <center>
                  <div
                    style={{ marginTop: 5, fontWeight: "bold", fontSize: 16 }}
                  >
                    Ref : {bookingData?.booking_ref}
                  </div>
                </center>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function confirmModal() {
    return (
      <Modal
        open={isConfirmModal}
        centered
        footer={false}
        onClose={() => setIsConfirmModal(false)}
        closable={false}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          {/* <WarningOutlined style={{ fontSize: 32, color: "#ffc107" }} /> */}
          <h2 style={{ marginBottom: 10, marginTop: 10 }}>ยืนยันแจ้งโอนเงิน</h2>
          <center>กรุณาตรวจสอบข้อมูลของคุณให้ถูกต้องก่อนทำการโอน</center>
          <center>
            หากทำการยืนยันคุณจะ
            <span style={{ color: "red" }}>ไม่สามารถยกเลิกได้</span>,
            คุณต้องการยืนยันหรือไม่ ?
          </center>
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              marginTop: 10,
            }}
          >
            <Button
              style={{ width: "100%" }}
              type="primary"
              onClick={handleSumbit}
            >
              ใช่, ยืนยัน
            </Button>
            <Button
              style={{ width: "100%" }}
              danger
              onClick={() => setIsConfirmModal(false)}
            >
              ยกเลิก
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  function Page7() {
    return (
      <div className="search-caddy-view-content" style={{ marginTop: -15 }}>
        {confirmModal()}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h3>ยืนยันการจอง</h3>
          <Form ref={formRef} onFinish={onUploadSlip}>
            <Form.Item
              name="slip_upload"
              label="แนบสลิปโอนเงิน"
              rules={[{ required: true, message: "กรุณา `แนบสลิปโอนเงิน`" }]}
            >
              <Upload
                accept=".jpg,.jpeg,.png"
                beforeUpload={(file) => {
                  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
                  const isAllowedType = allowedTypes.includes(file.type);

                  if (!isAllowedType) {
                    messageApi.error(
                      `${file.name} is not a valid file type. Only PNG, JPG, and JPEG are allowed.`
                    );
                  }

                  return isAllowedType || Upload.LIST_IGNORE;
                }}
                onRemove={(e) => {
                  setSlipImage(null);
                  formRef?.current?.setFieldValue("slip_upload", undefined);
                }}
                onPreview={handlePreview}
                fileList={slipImage}
                onChange={onUploadImage}
                className="custom-antd-upload-profile avatar-uploader"
                listType="picture-card"
              >
                {!slipImage && uploadButton}
              </Upload>
            </Form.Item>

            {previewImage && (
              <Image
                wrapperStyle={{
                  display: "none",
                }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(""),
                }}
                src={previewImage}
              />
            )}

            {targetTime && timeLeft && (
              <center style={{ marginTop: 20 }}>
                <b>
                  ชำระภายใน {timeLeft.minutes}:
                  {timeLeft.seconds >= 10
                    ? timeLeft.seconds
                    : `0${timeLeft.seconds}`}{" "}
                  นาที
                </b>
              </center>
            )}

            {isCancel ? (
              <center
                style={{
                  fontWeight: "bold",
                  marginTop: 20,
                  fontSize: 16,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  border: "1px solid red",
                  padding: 15,
                  borderRadius: 20,
                  color: "red",
                }}
              >
                <div>การจองถูกยกเลิก</div>
                <div>เนื่องจากเกินเวลาที่กำหนด</div>
              </center>
            ) : (
              <Form.Item style={{ marginBottom: 0 }}>
                <center>
                  <Button
                    htmlType="submit"
                    type="primary"
                    style={{
                      width: "100%",
                      height: 40,
                      marginTop: 10,
                      backgroundColor: "#009951",
                      color: "white",
                    }}
                  >
                    <div>แจ้งโอนเงินเรียบร้อย</div>
                  </Button>
                </center>
              </Form.Item>
            )}
          </Form>
        </div>
      </div>
    );
  }

  function Page8() {
    return (
      <div className="search-caddy-view-content" style={{ marginTop: 20 }}>
        {bookingData?.status === 1 ? (
          <>
            <center>
              <h2>แจ้งโอนเงินสำเร็จ</h2>
              <div style={{ marginBottom: 10 }}>
                กรุณารอยืนยันการชำระเงินภายใน 1 - 3 ชั่วโมง.
              </div>
            </center>
            <div
              class="loader-pending"
              style={{ transform: "scale(1.3)" }}
            ></div>
          </>
        ) : (
          <>
            <center>
              <h2>การชำระเงินได้รับการยืนยัน</h2>
            </center>
            <div class="success-animation">
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>
          </>
        )}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <h3>รายละเอียดการจอง</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div>ชื่อแคดดี้ : {caddyData?.display_name} (เบอร์: {caddyData?.caddy_number})</div>
            <div>สนาม : {caddyData?.golf_course?.data?.name}</div>
            <div>
              วันที่ทีออฟ :{" "}
              {bookingData?.tf_date
                ? `${dayjs(bookingData.tf_date).format("DD")} ${
                    THAI_MONTHS[
                      parseInt(dayjs(bookingData.tf_date).format("MM")) - 1
                    ]
                  } ${dayjs(bookingData.tf_date).format("YYYY")}`
                : "DD-MM-YYYY"}
            </div>
            <div>
              เวลาที่ทีออฟ :{" "}
              {bookingData?.tf_time
                ? `${dayjs(bookingData.tf_time).format("HH:mm")} น.`
                : "HH:mm"}
            </div>
          </div>
        </div>

        {!bookingData?.roll_up_job ||
        (bookingData?.roll_up_job?.is_refund &&
          bookingData.roll_up_amount > 0) ? (
          <div
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              padding: 20,
              marginTop: 15,
            }}
          >
            <h3 style={{ color: "#007AFF" }}>รายละเอียดการชำระเงิน</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>ทิปแคดดี้ :</div>
                <div>
                  {new Intl.NumberFormat().format(caddyData?.price ?? 0)} บาท
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>ค่าดำเนินการ :</div>
                <div>
                  {new Intl.NumberFormat().format(
                    controllerData?.transaction_fee ?? 0
                  )}{" "}
                  บาท
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>ยอดรวม (ก่อน VAT) : </div>
                <div>
                  {new Intl.NumberFormat().format(
                    caddyData?.price + controllerData?.transaction_fee
                  )}{" "}
                  บาท
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>VAT 7 % :</div>
                <div>
                  {new Intl.NumberFormat().format(
                    controllerData?.transaction_fee * 0.07
                  )}{" "}
                  บาท
                </div>
              </div>
              {bookingData?.roll_up_job ? (
                <Fragment>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>รวม :</div>
                    <div>
                      {new Intl.NumberFormat().format(bookingData?.grand_total)}{" "}
                      บาท
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: "red",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 5 }}
                    >
                      ยอดที่ยกมา{" "}
                      <span style={{ fontSize: 10 }}>
                        (REF: {bookingData?.roll_up_job.booking_ref})
                      </span>{" "}
                      :
                    </div>
                    <div>
                      {new Intl.NumberFormat().format(
                        bookingData?.roll_up_job.grand_total
                      )}{" "}
                      บาท
                    </div>
                  </div>
                </Fragment>
              ) : (
                <Fragment />
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: 18,
                }}
              >
                <b>ยอดรวมทั้งหมด :</b>
                <b>
                  {new Intl.NumberFormat().format(
                    bookingData?.roll_up_job
                      ? Math.abs(
                          bookingData?.roll_up_job.grand_total -
                            bookingData.grand_total
                        )
                      : controllerData?.transaction_fee * 0.07 +
                          caddyData?.price +
                          controllerData?.transaction_fee
                  )}{" "}
                  บาท
                </b>
              </div>
            </div>
          </div>
        ) : (
          <Fragment />
        )}

        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <center>
            <h3 style={{ margin: 0, marginBottom: 10 }}>
              ขอขอบคุณที่ใช้บริการ CADDIE DEE
            </h3>

            <b>Booking REF : {bookingData?.booking_ref}</b>
          </center>
        </div>

        {bookingData?.roll_up_job?.is_refund &&
        refundState > 1 &&
        bookingData.roll_up_amount < 0 ? (
          <div
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              padding: 20,
              marginTop: 15,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                border: "1px solid rgba(5, 5, 5, 0.06)",
                padding: "20px 20px 0px 20px",
                borderRadius: 10,
              }}
            >
              {PAGE_REFUND[refundState]}
            </div>
          </div>
        ) : (
          <Fragment />
        )}

        <center
          onClick={() => liff.closeWindow()}
          style={{
            cursor: "pointer",
            fontSize: 16,
            fontWeight: "bold",
            marginTop: 10,
            background: "#06C755",
            color: "white",
            padding: 10,
            borderRadius: 15,
          }}
        >
          กลับสู่ Line
        </center>
      </div>
    );
  }

  function Page5() {
    return (
      <div className="search-caddy-view-content" style={{ marginTop: 10 }}>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 15,
              border: "1px solid rgba(5, 5, 5, 0.06)",
              padding: 20,
              borderRadius: 10,
            }}
          >
            <center>
              <h1>รอการยืนยันจากแคดดี้</h1>
              <img
                src="https://cdn-icons-png.flaticon.com/512/6117/6117275.png"
                width={120}
                alt="to-be-confirm"
              />
            </center>
            <b style={{ fontSize: 20 }}>{bookingData?.caddy_name} (เบอร์: {bookingData?.caddy_number})</b>
            <div style={{ fontSize: 16 }}>
              วันที่ทีออฟ (Tee-Off) :{" "}
              {dayjs(bookingData?.tf_date).format("DD-MM-YYYY")}
            </div>
            <div style={{ fontSize: 16 }}>
              เวลาทีออฟ (Tee-Off) :{" "}
              {dayjs(bookingData?.tf_time).format("HH:mm")} -{" "}
              {dayjs(bookingData?.tf_time).add(6, "hours").format("HH:mm")} น.
            </div>
            <div style={{ fontSize: 14, color: "red" }}>
              รอยืนยันภายใน :{" "}
              {dayjs(bookingData?.caddy_accept_expire_at).format(
                "DD-MM-YYYY HH:mm"
              )}{" "}
              น.
            </div>
          </div>

          <div style={{ fontSize: 12, marginTop: 15, textAlign: "center" }}>
            ** กรุณาชำระเงินภายใน {controllerData?.payment_time_out} นาที
            หลังจากแคดดี้ได้ทำการยืนยันแล้ว **
          </div>

          <center
            onClick={() => liff.closeWindow()}
            style={{
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginTop: 10,
              background: "#06C755",
              color: "white",
              padding: 10,
              borderRadius: 15,
            }}
          >
            กลับสู่ Line
          </center>
        </div>
      </div>
    );
  }

  function PageCancel() {
    return (
      <div className="search-caddy-view-content" style={{ marginTop: 10 }}>
        <div
          style={{
            backgroundColor: "white",
            borderRadius: 10,
            padding: 20,
            marginTop: 15,
          }}
        >
          <center
            style={{
              color: "red",
              display: "flex",
              gap: 10,
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <CloseOutlined style={{ fontSize: 32 }} />
            <h1 style={{ margin: 0 }}>การจองถูกยกเลิก</h1>
          </center>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 15,
              border: "1px solid rgba(5, 5, 5, 0.06)",
              padding: 20,
              borderRadius: 10,
            }}
          >
            <center>
              <img
                src="https://cdn-icons-png.flaticon.com/512/6117/6117275.png"
                width={120}
                alt="to-be-confirm"
              />
            </center>
            <b style={{ fontSize: 20 }}>{bookingData?.caddy_name} (เบอร์: {bookingData?.caddy_number})</b>
            <div style={{ fontSize: 16 }}>
              วันที่ทีออฟ (Tee-Off) :{" "}
              {dayjs(bookingData?.tf_date).format("DD-MM-YYYY")}
            </div>
            <div style={{ fontSize: 16 }}>
              เวลาทีออฟ (Tee-Off) :{" "}
              {dayjs(bookingData?.tf_time).format("HH:mm")} -{" "}
              {dayjs(bookingData?.tf_time).add(6, "hours").format("HH:mm")} น.
            </div>
          </div>

          <center
            onClick={() => liff.closeWindow()}
            style={{
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginTop: 10,
              background: "#06C755",
              color: "white",
              padding: 10,
              borderRadius: 15,
            }}
          >
            กลับสู่ Line
          </center>
        </div>
      </div>
    );
  }

  const PageRefund1 = () => {
    return (
      <div style={{ paddingBottom: 20 }}>
        <center>
          <Image src={CaddyTipIcon} style={{ marginTop: 10 }} />
          <div
            style={{
              padding: 25,
              marginTop: 10,
              display: "flex",
              flexDirection: "column",
              gap: 5,
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            <div>แคดดี้ยังคงเตรียมพร้อมเต็มที่</div>
            <div>แม้ไม่ได้ลงสนาม</div>
            <div>การให้ทิปเล็กน้อย</div>
            <div>คือการส่งต่อกำลังใจอันยิ่งใหญ่ค่ะ</div>
          </div>
        </center>
        <div>
          กรอกจำนวนเงินที่ต้องการทิป จาก{" "}
          <span style={{ color: "#3B86FE", fontWeight: "bold" }}>
            {new Intl.NumberFormat().format(refundAmount)} บาท
          </span>
        </div>
        <Input
          value={compensateTips}
          max={parseInt(bookingData?.refund_amount)}
          type="number"
          onChange={(e) => {
            if (!e.target.value) setTipError(true);
            else setTipError(false);

            setCompensateTips(
              bookingData?.status !== 5 && bookingData?.roll_up_job
                ? parseInt(e.target.value) > Math.abs(refundAmount)
                  ? Math.abs(refundAmount)
                  : parseInt(e.target.value ? e.target.value : 0)
                : parseInt(e.target.value) > refundAmount
                ? parseInt(refundAmount ?? 0)
                : parseInt(e.target.value ? e.target.value : 0)
            );
            setSelectedPercen(null);
          }}
          style={{ border: "1px solid #D9D9D9 !important" }}
          placeholder="กรอกทิป"
        />
        {tipError && (
          <div style={{ color: "#ff4d4f", fontSize: 14, marginTop: 10 }}>
            กรุณากรอก `ทิปที่ต้องการ`
          </div>
        )}
        <div style={{ marginTop: 10 }}>จำนวนที่แนะนำ</div>
        <div style={{ display: "flex", gap: 5, marginTop: 5 }}>
          {TIPS_PERCEN?.map((tip, index) => {
            return (
              <div
                className={`caddy-tips-percen-btn ${
                  index === selectedPercen && "caddy-tips-percen-btn-active"
                }`}
                onClick={() => {
                  setSelectedPercen(index === selectedPercen ? null : index);

                  let baseRefund;
                  const hasRollUpJob =
                    bookingData?.status !== 5 && bookingData?.roll_up_job;

                  if (hasRollUpJob) {
                    baseRefund =
                      refundAmount === 0
                        ? refundAmount - compensateTips
                        : Math.abs(refundAmount) * (tip.value / 100);
                  } else {
                    baseRefund = refundAmount * (tip.value / 100);
                  }

                  setCompensateTips(Math.ceil(parseInt(baseRefund)));
                }}
              >
                {tip?.name}
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: 20 }}>
          <center>
            <h2 style={{ color: "rgb(59, 134, 254)" }}>ได้รับเงินคืนทั้งหมด</h2>
            <h2>
              {new Intl.NumberFormat().format(
                parseInt(
                  bookingData?.status !== 5 && bookingData?.roll_up_job
                    ? refundAmount === 0
                      ? refundAmount - compensateTips
                      : Math.abs(refundAmount) - compensateTips
                    : bookingData?.roll_up_to_job
                    ? !bookingData?.roll_up_used
                      ? refundAmount - compensateTips
                      : Math.abs(refundAmount) - compensateTips
                    : refundAmount - compensateTips
                )
              )}{" "}
              บาท
            </h2>
          </center>
        </div>
        <Button
          onClick={onClickCompensateTips}
          style={{
            background: "#06C755",
            width: "100%",
            height: 40,
            marginTop: 10,
          }}
          type="primary"
          htmlType="submit"
        >
          ทิปแคดดี้
        </Button>
        <Button
          onClick={() => setIsSkipCompensate(true)}
          style={{ width: "100%", height: 40, marginTop: 10 }}
          htmlType="submit"
        >
          ข้าม
        </Button>

        <Modal
          open={isSkipCompensate}
          centered
          footer={false}
          onCancel={() => setIsSkipCompensate(false)}
          closable={false}
        >
          <center>
            <Image src={SkipIcon} preview={false} />
          </center>
          <div style={{ display: "flex", width: "100%", gap: 10 }}>
            <Button
              onClick={() => {
                setRefundState((prev) => prev + 1);
                setCompensateTips(0);
              }}
              style={{
                background: "red",
                width: "100%",
                height: 40,
                marginTop: 10,
              }}
              type="primary"
              htmlType="submit"
            >
              ไม่ทิปแคดดี้
            </Button>
            <Button
              onClick={() => setIsSkipCompensate(false)}
              style={{
                width: "100%",
                height: 40,
                marginTop: 10,
                backgroundColor: "rgb(6, 199, 85)",
                color: "white",
              }}
              htmlType="submit"
            >
              ทิปก็ได้
            </Button>
          </div>
        </Modal>
      </div>
    );
  };

  const PageRefund3 = () => {
    return (
      <Fragment>
        <div style={{ padding: 20 }}>
          <center>
            <h2 style={{ color: "#007AFF" }}>ส่งข้อมูลการคืนเงินแล้ว</h2>
            <div
              style={{
                fontWeight: "bold",
                fontSize: 14,
                marginBottom: 10,
                marginTop: -5,
              }}
            >
              Refund REF :{" "}
              {bookingData?.status !== 5 &&
              bookingData?.roll_up_job &&
              bookingData?.roll_up_job > 0
                ? bookingData?.roll_up_job?.booking_ref
                : bookingData?.booking_ref}
            </div>
            <div style={{ fontWeight: "bold", fontSize: 16 }}>
              กรุณารอโอนเงินคืนภายใน 1 - 2 วันทำการ
            </div>
          </center>
        </div>

        {!bookingData?.roll_up_job && (
          <center
            onClick={() => liff.closeWindow()}
            style={{
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginTop: 0,
              marginBottom: 40,
              background: "#06C755",
              color: "white",
              padding: 10,
              borderRadius: 15,
            }}
          >
            กลับสู่ Line
          </center>
        )}
      </Fragment>
    );
  };

  const PageRefund4 = () => {
    return (
      <Fragment>
        <div style={{ padding: 20 }}>
          <center>
            <div
              style={{ marginTop: -5, marginBottom: 10, fontWeight: "bold" }}
            >
              Booking Ref :{" "}
              {bookingData?.status !== 5 &&
              bookingData?.roll_up_job &&
              bookingData?.roll_up_job > 0
                ? bookingData?.roll_up_job?.booking_ref
                : bookingData?.booking_ref}
            </div>
            <h2 style={{ color: "rgb(6, 199, 85)" }}>ได้รับเงินคืนแล้ว</h2>
            <div style={{ marginTop: 0 }}>
              <center>
                <h2 style={{ color: "rgb(59, 134, 254)" }}>คืนเงินทั้งหมด</h2>
                <h2 style={{ marginTop: 0 }}>
                  {new Intl.NumberFormat().format(
                    parseInt(
                      bookingData?.status !== 5 && bookingData?.roll_up_job
                        ? bookingData?.roll_up_job?.roll_up_amount === 0
                          ? bookingData?.roll_up_job.refund_amount -
                            compensateTips
                          : Math.abs(bookingData?.roll_up_job?.roll_up_amount) -
                            compensateTips
                        : bookingData?.roll_up_to_job
                        ? Math.abs(bookingData?.roll_up_amount) - compensateTips
                        : bookingData?.refund_amount - compensateTips
                    )
                  )}{" "}
                  บาท
                </h2>
              </center>

              <center
                style={{
                  color: "rgb(255, 77, 79)",
                  marginTop: -10,
                  fontSize: 12,
                  marginBottom: 10,
                }}
              >
                ยอดทั้งหมด (
                {new Intl.NumberFormat().format(
                  parseInt(
                    bookingData?.status !== 5 && bookingData?.roll_up_job
                      ? bookingData?.roll_up_job?.roll_up_amount === 0
                        ? bookingData?.roll_up_job.refund_amount
                        : Math.abs(bookingData?.roll_up_job?.roll_up_amount)
                      : bookingData?.refund_amount
                  )
                )}
                ) - ทิปแคดดี้ (
                {new Intl.NumberFormat().format(parseInt(compensateTips ?? 0))})
              </center>
            </div>
            {/* <div style={{ fontWeight: "bold", fontSize: 16 }}>กรุณารอโอนเงินคืนภายใน 1 - 2 วันทำการ</div> */}
          </center>
        </div>

        {!bookingData?.roll_up_job && (
          <center
            onClick={() => liff.closeWindow()}
            style={{
              cursor: "pointer",
              fontSize: 16,
              fontWeight: "bold",
              marginTop: 0,
              marginBottom: 40,
              background: "#06C755",
              color: "white",
              padding: 10,
              borderRadius: 15,
            }}
          >
            กลับสู่ Line
          </center>
        )}
      </Fragment>
    );
  };

  const PageRefund2 = () => {
    return (
      <Fragment>
        <Form onFinish={handleSubmitRefund}>
          <Form.Item
            name="banking_id"
            label="เลือกธนาคาร"
            rules={[{ required: true, message: "กรุณาเลือก 'ธนาคาร'" }]}
          >
            <Select placeholder="กรุณาเลือกธนาคาร" style={{ marginBottom: 10 }}>
              {bankList?.map((bank) => {
                return <Option value={bank.id}>{bank.name}</Option>;
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="banking_name"
            label="ชื่อบัญชี"
            rules={[{ required: true, message: "กรุณากรอก 'ชื่อบัญชี'" }]}
          >
            <Input placeholder="ชื่อบัญชี" />
          </Form.Item>
          <Form.Item
            name="banking_number"
            label="เลขบัญชีธนาคาร / บัตรประชาชน / เบอร์โทรศัพท์"
            rules={[{ required: true, message: "กรุณากรอก 'เลขบัญชีธนาคาร'" }]}
          >
            <Input placeholder="เลขบัญชีธนาคาร" />
          </Form.Item>

          <div style={{ marginTop: 25 }}>
            <center>
              <h2 style={{ color: "rgb(59, 134, 254)" }}>
                ได้รับเงินคืนทั้งหมด
              </h2>
              <h2 style={{ marginTop: -15 }}>{golferRefundAmount} บาท</h2>
            </center>
            <center
              style={{
                color: "rgb(255, 77, 79)",
                marginTop: -10,
                fontSize: 12,
                marginBottom: 10,
              }}
            >
              ยอดทั้งหมด ({refundAmount}) - ทิปแคดดี้ (
              {new Intl.NumberFormat().format(parseInt(compensateTips ?? 0))})
            </center>
          </div>

          <Form.Item>
            <Button
              style={{
                background: "#06C755",
                width: "100%",
                height: 40,
                marginTop: 10,
              }}
              type="primary"
              htmlType="submit"
            >
              ส่งข้อมูล
            </Button>
          </Form.Item>
        </Form>

        <Modal
          open={isConfirmRefund}
          footer={false}
          centered
          closable={false}
          onCancel={() => setIsConfirmRefund(false)}
        >
          <center>
            <h2 style={{ color: "#007AFF" }}>ยืนยันข้อมูล</h2>
          </center>
          <div>
            <div>
              <b>ธนาคาร : </b>
              {
                bankList?.find(
                  (bank) => bank.id === confirmRefundData?.banking_id
                )?.name
              }
            </div>
            <div>
              <b>ชื่อบัญชี : </b> {confirmRefundData?.banking_name}
            </div>
            <div>
              <b>หมายเลขบัญชี : </b> {confirmRefundData?.banking_number}
            </div>

            <div style={{ marginTop: 15 }}>
              <center>
                <h2 style={{ color: "rgb(59, 134, 254)" }}>
                  ได้รับเงินคืนทั้งหมด
                </h2>
                <h2 style={{ marginTop: -15 }}>
                  {new Intl.NumberFormat().format(
                    parseInt(
                      bookingData?.status !== 5 && bookingData?.roll_up_job
                        ? bookingData?.roll_up_job?.roll_up_amount === 0
                          ? refundAmount - compensateTips
                          : Math.abs(refundAmount) - compensateTips
                        : bookingData?.roll_up_to_job
                        ? !bookingData?.roll_up_used
                          ? refundAmount - compensateTips
                          : Math.abs(bookingData?.roll_up_amount) -
                            compensateTips
                        : refundAmount - compensateTips
                    )
                  )}{" "}
                  บาท
                </h2>
              </center>
              <center
                style={{
                  color: "rgb(255, 77, 79)",
                  marginTop: -10,
                  fontSize: 12,
                  marginBottom: 10,
                }}
              >
                ยอดทั้งหมด (
                {new Intl.NumberFormat().format(
                  bookingData?.status !== 5 && bookingData?.roll_up_job
                    ? bookingData?.roll_up_job?.roll_up_amount === 0
                      ? refundAmount
                      : Math.abs(refundAmount)
                    : bookingData?.roll_up_to_job
                    ? !bookingData?.roll_up_used
                      ? refundAmount - compensateTips
                      : Math.abs(bookingData?.roll_up_amount)
                    : parseInt(refundAmount)
                )}
                ) - ทิปแคดดี้ (
                {new Intl.NumberFormat().format(parseInt(compensateTips ?? 0))})
              </center>
            </div>

            <div style={{ display: "flex", width: "100%", gap: 10 }}>
              <Button
                onClick={() => onSubmitRefuned()}
                style={{
                  background: "rgb(6, 199, 85)",
                  width: "100%",
                  height: 40,
                  marginTop: 10,
                }}
                type="primary"
                htmlType="submit"
              >
                ยืนยัน
              </Button>
              <Button
                onClick={() => {
                  setConfirmRefundData(null);
                  setIsConfirmRefund(false);
                }}
                style={{ width: "100%", height: 40, marginTop: 10 }}
                htmlType="submit"
              >
                ยกเลิก
              </Button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  };

  const PageRefund5 = () => {
    return (
      <div className="search-caddy-view-content">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            borderRadius: 10,
            alignItems: "center",
          }}
        >
          <CloseCircleFilled style={{ fontSize: 100, color: "red" }} />

          <center style={{ marginTop: 10, color: "red" }}>
            <h3>
              <div>Booking นี้ถูกใช้งาน Refund </div>
              <div style={{ marginTop: 10 }}>ไปแล้วไม่สามารถขอคืนเงินได้.</div>
            </h3>
          </center>
        </div>
      </div>
    );
  };

  const PAGE_REFUND = [
    PageRefund1(),
    PageRefund2(),
    PageRefund3(),
    PageRefund4(),
    PageRefund5(),
  ];

  let PAGES = [
    Page1(),
    Page2(),
    Page3(),
    Page4(),
    Page5(),
    Page6(),
    Page7(),
    Page8(),
    PageCancel(),
    PageRefund(),
  ];

  return !is_comming ? (
    <ComingSoon />
  ) : (
    <>
      <Loading visible={isLoading} />
      <div className="search-caddy-view-container">
        {contextHolder}
        {viewState < 4 && (
          <div
            onClick={() => {
              setAvailable(null);
              setAvailableSelected(null);
              viewState > 0
                ? setViewState((prev) =>
                    search_pararms.get("date") && search_pararms.get("time")
                      ? 0
                      : prev - 1
                  )
                : navigate(-1);
            }}
            style={{
              position: "absolute",
              left: 10,
              top: 10,
              zIndex: 99,
              fontSize: 22,
              backgroundColor: "white",
              borderRadius: "50%",
              width: 35,
              height: 35,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <LeftCircleOutlined />
          </div>
        )}

        {viewState >= 1 && (
          <div
            style={{
              padding:
                viewState === 6 || viewState >= 8
                  ? "0px 0px 0px 0px"
                  : "55px 0px 0px 0px",
              marginBottom: -5,
              marginLeft: -15,
              overflow: "hidden",
            }}
          >
            {viewState < 6 && (
              <center>
                <h2>{caddyData?.display_name} Booking</h2>
              </center>
            )}
            {viewState < 8 && (
              <Steps
                className="custom-steps"
                labelPlacement="vertical"
                responsive={false}
                items={[
                  {
                    description: "จอง",
                    status: viewState >= 1 ? "finish" : "process",
                    icon: <FileTextOutlined />,
                  },
                  {
                    description: "ยืนยันการจอง",
                    status:
                      viewState > 3
                        ? "finish"
                        : viewState >= 2
                        ? "process"
                        : "wait",
                    icon: <FileDoneOutlined />,
                  },
                  {
                    description: "ชำระเงิน",
                    status:
                      viewState > 5
                        ? "finish"
                        : viewState > 4
                        ? "process"
                        : "wait",
                    icon: <DollarOutlined />,
                  },
                  {
                    description: "สำเร็จ",
                    status: viewState === 7 ? "finish" : "wait",
                    icon: <CheckOutlined />,
                  },
                ]}
              />
            )}
          </div>
        )}

        {renderTermCondition()}
        {caddyData && PAGES[viewState]}
      </div>
    </>
  );
}
